@file:Suppress("unused", "SpellCheckingInspection")

package xim.poc.game.configuration.constants

const val itemHexedHaubert_10240 = 10240
const val itemHexedDomaru_10241 = 10241
const val itemHexedJacket_10242 = 10242
const val itemHexedDoublet_10243 = 10243
const val itemHexedBliaut_10244 = 10244
const val itemHexedHaubert1_10245 = 10245
const val itemHexedDomaru1_10246 = 10246
const val itemHexedJacket1_10247 = 10247
const val itemHexedDoublet1_10248 = 10248
const val itemHexedBliaut1_10249 = 10249
const val itemMoogleSuit_10250 = 10250
const val itemDecennialCoat_10251 = 10251
const val itemDecennialDress_10252 = 10252
const val itemDecennialCoat1_10253 = 10253
const val itemDecennialDress1_10254 = 10254
const val itemMatancaHarness_10255 = 10255
const val itemMarineGilet_10256 = 10256
const val itemMarineTop_10257 = 10257
const val itemWoodsyGilet_10258 = 10258
const val itemWoodsyTop_10259 = 10259
const val itemCreekMaillot_10260 = 10260
const val itemCreekTop_10261 = 10261
const val itemRiverTop_10262 = 10262
const val itemDuneGilet_10263 = 10263
const val itemMarineGilet1_10264 = 10264
const val itemMarineTop1_10265 = 10265
const val itemWoodsyGilet1_10266 = 10266
const val itemWoodsyTop1_10267 = 10267
const val itemCreekMaillot1_10268 = 10268
const val itemCreekTop1_10269 = 10269
const val itemRiverTop1_10270 = 10270
const val itemDuneGilet1_10271 = 10271
const val itemDuxScaleMail_10272 = 10272
const val itemDuxScMail1_10273 = 10273
const val itemChelonaBlazer_10274 = 10274
const val itemChelonaBlazer1_10275 = 10275
const val itemEnifCorazza_10276 = 10276
const val itemAdharaManteel_10277 = 10277
const val itemMurzimCorazza_10278 = 10278
const val itemShedirManteel_10279 = 10279
const val itemLaeradrBreastplate_10280 = 10280
const val itemManasaChasuble_10281 = 10281
const val itemKrabatJacket_10282 = 10282
const val itemVaraBrigandine_10283 = 10283
const val itemGrandoynesMail_10284 = 10284
const val itemBeguilersJerkin_10285 = 10285
const val itemSeidrCotehardie_10286 = 10286
const val itemFeverishKorazin_10287 = 10287
const val itemBaalmuianRobe_10288 = 10288
const val itemSublimeBreastplate_10289 = 10289
const val itemLaudanCuirass_10290 = 10290
const val itemFebroKaftan_10291 = 10291
const val itemWikyoCloak_10292 = 10292
const val itemChocoboShirt_10293 = 10293
const val itemKokousEarring_10295 = 10295
const val itemCharivariEarring_10296 = 10296
const val itemSortiariusEarring_10297 = 10297
const val itemBeatificEarring_10298 = 10298
const val itemSabongEarring_10299 = 10299
const val itemMyrmexMittens_10300 = 10300
const val itemArcitenGauntlets_10301 = 10301
const val itemPunishingGloves_10302 = 10302
const val itemHexedGauntlets_10303 = 10303
const val itemHexedTekko_10304 = 10304
const val itemHexedWristbands_10305 = 10305
const val itemHexedGages_10306 = 10306
const val itemHexedCuffs_10307 = 10307
const val itemHexedGantl1_10308 = 10308
const val itemHexedTekko1_10309 = 10309
const val itemHexedWrist1_10310 = 10310
const val itemHexedGages1_10311 = 10311
const val itemHexedCuffs1_10312 = 10312
const val itemPaalakaGloves_10313 = 10313
const val itemAneirinsGloves_10314 = 10314
const val itemAlcedoGauntlets_10315 = 10315
const val itemDuxFngGnt_10316 = 10316
const val itemDuxFngGnt1_10317 = 10317
const val itemChelonaGloves_10318 = 10318
const val itemChlGloves1_10319 = 10319
const val itemEnifManopolas_10320 = 10320
const val itemAdharaGages_10321 = 10321
const val itemMurzimManopolas_10322 = 10322
const val itemShedirGages_10323 = 10323
const val itemLeohtGloves_10324 = 10324
const val itemHierosMittens_10325 = 10325
const val itemEnifCosciales_10326 = 10326
const val itemAdharaSeraweels_10327 = 10327
const val itemMurzimCosciales_10328 = 10328
const val itemShedirSeraweels_10329 = 10329
const val itemMarineBoxers_10330 = 10330
const val itemMarineShorts_10331 = 10331
const val itemWoodsyBoxers_10332 = 10332
const val itemWoodsyShorts_10333 = 10333
const val itemCreekBoxers_10334 = 10334
const val itemCreekShorts_10335 = 10335
const val itemRiverShorts_10336 = 10336
const val itemDuneBoxers_10337 = 10337
const val itemMarineBoxers1_10338 = 10338
const val itemMarineShorts1_10339 = 10339
const val itemWoodsyBoxers1_10340 = 10340
const val itemWoodsyShorts1_10341 = 10341
const val itemCreekBoxers1_10342 = 10342
const val itemCreekShorts1_10343 = 10343
const val itemRiverShorts1_10344 = 10344
const val itemDuneBoxers1_10345 = 10345
const val itemDuxCuisses_10346 = 10346
const val itemDuxCuisses1_10347 = 10347
const val itemChelonaTrousers_10348 = 10348
const val itemChlTrousers1_10349 = 10349
const val itemWohpesSabots_10350 = 10350
const val itemIhwaHuaraches_10351 = 10351
const val itemGhadhabNails_10352 = 10352
const val itemHexedGambieras_10353 = 10353
const val itemHexedSuneAte_10354 = 10354
const val itemHexedGamashes_10355 = 10355
const val itemHexedNails_10356 = 10356
const val itemHexedBoots_10357 = 10357
const val itemHexedGamb1_10358 = 10358
const val itemHexedSuneAte1_10359 = 10359
const val itemHexedGamash1_10360 = 10360
const val itemHexedNails1_10361 = 10361
const val itemHexedBoots1_10362 = 10362
const val itemDuxGreaves_10363 = 10363
const val itemDuxGreaves1_10364 = 10364
const val itemChelonaBoots_10365 = 10365
const val itemChelonaBoots1_10366 = 10366
const val itemEnifGambieras_10367 = 10367
const val itemAdharaCrackows_10368 = 10368
const val itemMurzimGambieras_10369 = 10369
const val itemShedirCrackows_10370 = 10370
const val itemVeikrPumps_10371 = 10371
const val itemPlumbBoots_10372 = 10372
const val itemOcularBoots_10373 = 10373
const val itemDreamMittens_10382 = 10382
const val itemDreamMittens1_10383 = 10383
const val itemCumulusMasque_10384 = 10384
const val itemCumulusMasque1_10385 = 10385
const val itemMalisonMedallion_10392 = 10392
const val itemDebilisMedallion_10393 = 10393
const val itemOrunmilasTorque_10394 = 10394
const val itemLasaiaPendant_10395 = 10395
const val itemRiotersCollar_10396 = 10396
const val itemIshtarsCollar_10397 = 10397
const val itemWeikeTorque_10398 = 10398
const val itemHrafnCoronet_10400 = 10400
const val itemTenryuSomen_10401 = 10401
const val itemKheperBonnet_10402 = 10402
const val itemAuspexCoif_10403 = 10403
const val itemPaeanMitra_10404 = 10404
const val itemHuginnCoronet_10405 = 10405
const val itemTenryuSomen1_10406 = 10406
const val itemKhepriBonnet_10407 = 10407
const val itemSpurrinaCoif_10408 = 10408
const val itemIasoMitra_10409 = 10409
const val itemUgolSalade_10410 = 10410
const val itemMavrosSalade_10411 = 10411
const val itemUrjaHelm_10412 = 10412
const val itemSthiraHelm_10413 = 10413
const val itemSpoliaChapeau_10414 = 10414
const val itemOpimaChapeau_10415 = 10415
const val itemCanutesHelm_10416 = 10416
const val itemManeasArmet_10417 = 10417
const val itemSeiokonaBeret_10418 = 10418
const val itemHexedCoronet_10419 = 10419
const val itemHexedSomen_10420 = 10420
const val itemHexedBonnet_10421 = 10421
const val itemHexedCoif_10422 = 10422
const val itemHexedMitra_10423 = 10423
const val itemHexedCoronet1_10424 = 10424
const val itemHexedSomen1_10425 = 10425
const val itemHexedBonnet1_10426 = 10426
const val itemHexedCoif1_10427 = 10427
const val itemHexedMitra1_10428 = 10428
const val itemMoogleMasque_10429 = 10429
const val itemDecennialCrown_10430 = 10430
const val itemDecennialTiara_10431 = 10431
const val itemDecennialCrown1_10432 = 10432
const val itemDecennialTiara1_10433 = 10433
const val itemDuxVisor_10434 = 10434
const val itemDuxVisor1_10435 = 10435
const val itemChelonaHat_10436 = 10436
const val itemChelonaHat1_10437 = 10437
const val itemEnifZucchetto_10438 = 10438
const val itemAdharaTurban_10439 = 10439
const val itemMurzimZucchetto_10440 = 10440
const val itemShedirTurban_10441 = 10441
const val itemLaeradrHelm_10442 = 10442
const val itemBendissHairpin_10443 = 10443
const val itemZouavesBeret_10444 = 10444
const val itemNemetonaCap_10445 = 10445
const val itemAhrimanCap_10446 = 10446
const val itemPyracmonCap_10447 = 10447
const val itemKahinTurban_10448 = 10448
const val itemOgiersSurcoat_10450 = 10450
const val itemAthossTabard_10451 = 10451
const val itemRubeusJacket_10452 = 10452
const val itemPraecoDoublet_10453 = 10453
const val itemAsuraSamue_10454 = 10454
const val itemAsuraSamue1_10455 = 10455
const val itemAvantMail_10456 = 10456
const val itemAvantMail1_10457 = 10457
const val itemKacuraHarness_10458 = 10458
const val itemKacuraHarness1_10459 = 10459
const val itemSwevenCoat_10460 = 10460
const val itemSwevenCoat1_10461 = 10461
const val itemCalmaBreastplate_10462 = 10462
const val itemMustelaHarness_10463 = 10463
const val itemMagavanFrock_10464 = 10464
const val itemFuladZereh_10465 = 10465
const val itemGunmanGambison_10466 = 10466
const val itemPharmakeiaRobe_10467 = 10467
const val itemKumarbisAkar_10468 = 10468
const val itemEirenesManteel_10469 = 10469
const val itemRheicKorazin_10470 = 10470
const val itemRheicKorazin1_10471 = 10471
const val itemRheicKorazin2_10472 = 10472
const val itemRheicKorazin3_10473 = 10473
const val itemPhorcysKorazin_10474 = 10474
const val itemEuxineCoat_10475 = 10475
const val itemEuxineCoat1_10476 = 10476
const val itemEuxineCoat2_10477 = 10477
const val itemEuxineCoat3_10478 = 10478
const val itemThaumasCoat_10479 = 10479
const val itemTethyanSaio_10480 = 10480
const val itemTethyanSaio1_10481 = 10481
const val itemTethyanSaio2_10482 = 10482
const val itemTethyanSaio3_10483 = 10483
const val itemNaresSaio_10484 = 10484
const val itemTesseraSaio_10485 = 10485
const val itemPorthosByrnie_10486 = 10486
const val itemHederaCotehardie_10487 = 10487
const val itemKudzuAketon_10488 = 10488
const val itemHuginnHaubert_10489 = 10489
const val itemTenryuDomaru1_10490 = 10490
const val itemKhepriJacket_10491 = 10491
const val itemSpurrinaDoublet_10492 = 10492
const val itemIasoBliaut_10493 = 10493
const val itemUgolHaubert_10494 = 10494
const val itemMavrosHaubert_10495 = 10495
const val itemUrjaJerkin_10496 = 10496
const val itemSthiraJerkin_10497 = 10497
const val itemSpoliaSaio_10498 = 10498
const val itemOpimaSaio_10499 = 10499
const val itemOgiersGauntlets_10500 = 10500
const val itemAthossGloves_10501 = 10501
const val itemRubeusGloves_10502 = 10502
const val itemBregoGloves_10503 = 10503
const val itemIuvenalisMittens_10504 = 10504
const val itemNomkahpaMittens_10505 = 10505
const val itemAvantGauntlets_10506 = 10506
const val itemAvantGauntlets1_10507 = 10507
const val itemKacuraMittens_10508 = 10508
const val itemKacuraMittens1_10509 = 10509
const val itemSwevenMitts_10510 = 10510
const val itemSwevenMitts1_10511 = 10511
const val itemCalmaGauntlets_10512 = 10512
const val itemMustelaGloves_10513 = 10513
const val itemMagavanMitts_10514 = 10514
const val itemMiodioGloves_10515 = 10515
const val itemAntiasMitts_10516 = 10516
const val itemRepartieGloves_10517 = 10517
const val itemAyaosGages_10518 = 10518
const val itemRheicMitts_10519 = 10519
const val itemRheicMitts1_10520 = 10520
const val itemRheicMitts2_10521 = 10521
const val itemRheicMitts3_10522 = 10522
const val itemPhorcysMitts_10523 = 10523
const val itemEuxineGloves_10524 = 10524
const val itemEuxineGloves1_10525 = 10525
const val itemEuxineGloves2_10526 = 10526
const val itemEuxineGloves3_10527 = 10527
const val itemThaumasGloves_10528 = 10528
const val itemTethyanCuffs_10529 = 10529
const val itemTethyanCuffs1_10530 = 10530
const val itemTethyanCuffs2_10531 = 10531
const val itemTethyanCuffs3_10532 = 10532
const val itemNaresCuffs_10533 = 10533
const val itemHrafnGauntlets_10534 = 10534
const val itemTenryuTekko_10535 = 10535
const val itemKheperWristbands_10536 = 10536
const val itemAuspexGages_10537 = 10537
const val itemPaeanCuffs_10538 = 10538
const val itemHuginnGauntlets_10539 = 10539
const val itemTenryuTekko1_10540 = 10540
const val itemKhepriWristbands_10541 = 10541
const val itemSpurrinaGages_10542 = 10542
const val itemIasoCuffs_10543 = 10543
const val itemUgolMoufles_10544 = 10544
const val itemMavrosMoufles_10545 = 10545
const val itemUrjaGloves_10546 = 10546
const val itemSthiraGloves_10547 = 10547
const val itemSpoliaCuffs_10548 = 10548
const val itemOpimaCuffs_10549 = 10549
const val itemRheicDirs_10550 = 10550
const val itemRheicDirs1_10551 = 10551
const val itemRheicDirs2_10552 = 10552
const val itemRheicDirs3_10553 = 10553
const val itemPhorcysDirs_10554 = 10554
const val itemEuxineKecks_10555 = 10555
const val itemEuxineKecks1_10556 = 10556
const val itemEuxineKecks2_10557 = 10557
const val itemEuxineKecks3_10558 = 10558
const val itemThaumasKecks_10559 = 10559
const val itemTethyanTrews_10560 = 10560
const val itemTethyanTrews1_10561 = 10561
const val itemTethyanTrews2_10562 = 10562
const val itemTethyanTrews3_10563 = 10563
const val itemNaresTrews_10564 = 10564
const val itemHrafnHose_10565 = 10565
const val itemTenryuHakama_10566 = 10566
const val itemKheperKecks_10567 = 10567
const val itemAuspexSlops_10568 = 10568
const val itemPaeanTights_10569 = 10569
const val itemHuginnHose_10570 = 10570
const val itemTenryuHakama1_10571 = 10571
const val itemKhepriKecks_10572 = 10572
const val itemSpurrinaSlops_10573 = 10573
const val itemIasoTights_10574 = 10574
const val itemUgolBrayettes_10575 = 10575
const val itemMavrosBrayettes_10576 = 10576
const val itemUrjaTrousers_10577 = 10577
const val itemSthiraTrousers_10578 = 10578
const val itemSpoliaTrews_10579 = 10579
const val itemOpimaTrews_10580 = 10580
const val itemLefayBrais_10581 = 10581
const val itemGardylooTrousers_10582 = 10582
const val itemHexedHose_10583 = 10583
const val itemHexedHakama_10584 = 10584
const val itemHexedKecks_10585 = 10585
const val itemHexedSlops_10586 = 10586
const val itemHexedTights_10587 = 10587
const val itemHexedHose1_10588 = 10588
const val itemHexedHakama1_10589 = 10589
const val itemHexedKecks1_10590 = 10590
const val itemHexedSlops1_10591 = 10591
const val itemHexedTights1_10592 = 10592
const val itemDecennialTights_10593 = 10593
const val itemDecennialHose_10594 = 10594
const val itemDecennialTights1_10595 = 10595
const val itemDecennialHose1_10596 = 10596
const val itemAkashaChaps_10597 = 10597
const val itemAlcedoCuisses_10598 = 10598
const val itemOgiersLeggings_10600 = 10600
const val itemAthossBoots_10601 = 10601
const val itemRubeusBoots_10602 = 10602
const val itemScopuliNails_10603 = 10603
const val itemAvantLeggings_10604 = 10604
const val itemAvantLeggings1_10605 = 10605
const val itemKacuraLeggings_10606 = 10606
const val itemKacuraLeggings1_10607 = 10607
const val itemSwevenBoots_10608 = 10608
const val itemSwevenBoots1_10609 = 10609
const val itemCalmaLeggings_10610 = 10610
const val itemMustelaBoots_10611 = 10611
const val itemMagavanClogs_10612 = 10612
const val itemMuddlePumps_10613 = 10613
const val itemWrathwingNails_10614 = 10614
const val itemWurrukatteBoots_10615 = 10615
const val itemRheicSchuhs_10616 = 10616
const val itemRheicSchuhs1_10617 = 10617
const val itemRheicSchuhs2_10618 = 10618
const val itemRheicSchuhs3_10619 = 10619
const val itemPhorcysSchuhs_10620 = 10620
const val itemEuxineNails_10621 = 10621
const val itemEuxineNails1_10622 = 10622
const val itemEuxineNails2_10623 = 10623
const val itemEuxineNails3_10624 = 10624
const val itemThaumasNails_10625 = 10625
const val itemTethyanClogs_10626 = 10626
const val itemTethyanClogs1_10627 = 10627
const val itemTethyanClogs2_10628 = 10628
const val itemTethyanClogs3_10629 = 10629
const val itemNaresClogs_10630 = 10630
const val itemHrafnGambieras_10631 = 10631
const val itemTenryuSuneAte_10632 = 10632
const val itemKheperGamashes_10633 = 10633
const val itemAuspexNails_10634 = 10634
const val itemPaeanBoots_10635 = 10635
const val itemHuginnGambieras_10636 = 10636
const val itemTenryuSuneAte1_10637 = 10637
const val itemKhepriGamashes_10638 = 10638
const val itemSpurrinaNails_10639 = 10639
const val itemIasoBoots_10640 = 10640
const val itemUgolSollerets_10641 = 10641
const val itemMavrosSollerets_10642 = 10642
const val itemUrjaLedelsens_10643 = 10643
const val itemSthiraLedelsens_10644 = 10644
const val itemSpoliaPigaches_10645 = 10645
const val itemOpimaPigaches_10646 = 10646
const val itemAreionBoots_10647 = 10647
const val itemAreionBoots1_10648 = 10648
const val itemWarMask2_10650 = 10650
const val itemMelCrown2_10651 = 10651
const val itemClrCap2_10652 = 10652
const val itemSrcPetasos2_10653 = 10653
const val itemDlsChapeau2_10654 = 10654
const val itemAsnBonnet2_10655 = 10655
const val itemVlrCoronet2_10656 = 10656
const val itemAbsBurgeonet2_10657 = 10657
const val itemMstHelm2_10658 = 10658
const val itemBrdRoundlet2_10659 = 10659
const val itemSctBeret2_10660 = 10660
const val itemSaoKabuto2_10661 = 10661
const val itemKogHatsuburi2_10662 = 10662
const val itemWymArmet2_10663 = 10663
const val itemSmnHorn2_10664 = 10664
const val itemMirageKeffiyeh2_10665 = 10665
const val itemCommTricorne2_10666 = 10666
const val itemPantinTaj2_10667 = 10667
const val itemEtoileTiara2_10668 = 10668
const val itemArguteMboard2_10669 = 10669
const val itemWarLorica2_10670 = 10670
const val itemMelCyclas2_10671 = 10671
const val itemClrBliaut2_10672 = 10672
const val itemSrcCoat2_10673 = 10673
const val itemDlsTabard2_10674 = 10674
const val itemAsnVest2_10675 = 10675
const val itemVlrSurcoat2_10676 = 10676
const val itemAbsCuirass2_10677 = 10677
const val itemMstJackcoat2_10678 = 10678
const val itemBrdJstcorps2_10679 = 10679
const val itemSctJerkin2_10680 = 10680
const val itemSaoDomaru2_10681 = 10681
const val itemKogChainmail2_10682 = 10682
const val itemWymMail2_10683 = 10683
const val itemSmnDoublet2_10684 = 10684
const val itemMirageJubbah2_10685 = 10685
const val itemCommFrac2_10686 = 10686
const val itemPantinTobe2_10687 = 10687
const val itemEtoileCasaque2_10688 = 10688
const val itemArguteGown2_10689 = 10689
const val itemWarMufflers2_10690 = 10690
const val itemMelGloves2_10691 = 10691
const val itemClrMitts2_10692 = 10692
const val itemSrcGloves2_10693 = 10693
const val itemDlsGloves2_10694 = 10694
const val itemAsnArmlets2_10695 = 10695
const val itemVlrGauntlets2_10696 = 10696
const val itemAbsGauntlets2_10697 = 10697
const val itemMstGloves2_10698 = 10698
const val itemBrdCuffs2_10699 = 10699
const val itemSctBracers2_10700 = 10700
const val itemSaoKote2_10701 = 10701
const val itemKogTekko2_10702 = 10702
const val itemWymFngGnt2_10703 = 10703
const val itemSmnBracers2_10704 = 10704
const val itemMrgBazubands2_10705 = 10705
const val itemCommGants2_10706 = 10706
const val itemPantinDastanas2_10707 = 10707
const val itemEtoileBangles2_10708 = 10708
const val itemArguteBracers2_10709 = 10709
const val itemWarCuisses2_10710 = 10710
const val itemMelHose2_10711 = 10711
const val itemClrPantaln2_10712 = 10712
const val itemSrcTonban2_10713 = 10713
const val itemDlsTights2_10714 = 10714
const val itemAsnCulottes2_10715 = 10715
const val itemVlrBreeches2_10716 = 10716
const val itemAbsFlanchard2_10717 = 10717
const val itemMstTrousers2_10718 = 10718
const val itemBrdCannions2_10719 = 10719
const val itemSctBraccae2_10720 = 10720
const val itemSaoHaidate2_10721 = 10721
const val itemKogHakama2_10722 = 10722
const val itemWymBrais2_10723 = 10723
const val itemSmnSpats2_10724 = 10724
const val itemMirageShalwar2_10725 = 10725
const val itemCommTrews2_10726 = 10726
const val itemPtnChuridars2_10727 = 10727
const val itemEtoileTights2_10728 = 10728
const val itemArgutePants2_10729 = 10729
const val itemWarCalligae2_10730 = 10730
const val itemMelGaiters2_10731 = 10731
const val itemClrDuckbills2_10732 = 10732
const val itemSrcSabots2_10733 = 10733
const val itemDlsBoots2_10734 = 10734
const val itemAsnPoulaines2_10735 = 10735
const val itemVlrLeggings2_10736 = 10736
const val itemAbsSollerets2_10737 = 10737
const val itemMstGaiters2_10738 = 10738
const val itemBrdSlippers2_10739 = 10739
const val itemSctSocks2_10740 = 10740
const val itemSaoSuneAte2_10741 = 10741
const val itemKogKyahan2_10742 = 10742
const val itemWymGreaves2_10743 = 10743
const val itemSmnPigaches2_10744 = 10744
const val itemMirageCharuqs2_10745 = 10745
const val itemCommBottes2_10746 = 10746
const val itemPtnBabouches2_10747 = 10747
const val itemEtoileToeShoes2_10748 = 10748
const val itemArguteLoafers2_10749 = 10749
const val itemTyrantsRing_10750 = 10750
const val itemValseursRing_10751 = 10751
const val itemProlixRing_10752 = 10752
const val itemPaguroideaRing_10753 = 10753
const val itemMoepapaRing_10754 = 10754
const val itemMoepapaAnnulet_10755 = 10755
const val itemTjukurrpaRing_10756 = 10756
const val itemTjukurrpaAnnulet_10757 = 10757
const val itemAifesRing_10758 = 10758
const val itemAifesAnnulet_10759 = 10759
const val itemPortusRing_10760 = 10760
const val itemPortusAnnulet_10761 = 10761
const val itemAnghaRing_10762 = 10762
const val itemPoeasRing_10763 = 10763
const val itemShelteredRing_10764 = 10764
const val itemArvinaRinglet_10765 = 10765
const val itemLunetteRing_10766 = 10766
const val itemPerniciousRing_10767 = 10767
const val itemGelatinousRing_10768 = 10768
const val itemGelatinousRing1_10769 = 10769
const val itemCacoethicRing_10770 = 10770
const val itemCacoethicRing1_10771 = 10771
const val itemPetrovRing_10772 = 10772
const val itemFortifiedRing_10773 = 10773
const val itemVertigoRing_10774 = 10774
const val itemGaiardasRing_10775 = 10775
const val itemGaubiousRing_10776 = 10776
const val itemCaloussuRing_10777 = 10777
const val itemNangerRing_10778 = 10778
const val itemSophiaRing_10779 = 10779
const val itemQuiesRing_10780 = 10780
const val itemCynosureRing_10781 = 10781
const val itemAmbuscadeRing_10782 = 10782
const val itemVeneficiumRing_10783 = 10783
const val itemDhanurvedaRing_10784 = 10784
const val itemProvocareRing_10785 = 10785
const val itemMediatorsRing_10786 = 10786
const val itemAsklepianRing_10787 = 10787
const val itemMaquetteRing_10788 = 10788
const val itemFolhardiRing_10789 = 10789
const val itemEphedraRing_10790 = 10790
const val itemHaomasRing_10791 = 10791
const val itemSaidaRing_10792 = 10792
const val itemEshmunsRing_10793 = 10793
const val itemBlenmotsRing_10794 = 10794
const val itemBlenmotsRing1_10795 = 10795
const val itemDecennialRing_10796 = 10796
const val itemDagazRing_10797 = 10797
const val itemEihwazRing_10798 = 10798
const val itemSljorRing_10799 = 10799
const val itemCastellansShield_10800 = 10800
const val itemPsychistShield_10801 = 10801
const val itemMajorelleShield_10802 = 10802
const val itemWeatheringShield_10803 = 10803
const val itemThuellaicEcu_10804 = 10804
const val itemPanzerShield_10805 = 10805
const val itemAdamas_10806 = 10806
const val itemMandraguard_10807 = 10807
const val itemJanusGuard_10808 = 10808
const val itemMoogleGuard_10809 = 10809
const val itemMoogleGuard1_10810 = 10810
const val itemChocoboShield_10811 = 10811
const val itemChocoShield1_10812 = 10812
const val itemCorvaxSash_10814 = 10814
const val itemPhasmidaBelt_10815 = 10815
const val itemGlassblowersBelt_10816 = 10816
const val itemMoepapaStone_10817 = 10817
const val itemTjukurrpaBelt_10818 = 10818
const val itemFlumeBelt_10819 = 10819
const val itemBishopsSash_10820 = 10820
const val itemOlympusSash_10821 = 10821
const val itemHarfnersSash_10822 = 10822
const val itemCimmerianSash_10823 = 10823
const val itemCassoSash_10824 = 10824
const val itemChinersBelt_10825 = 10825
const val itemWitfulBelt_10826 = 10826
const val itemProsilioBelt_10827 = 10827
const val itemWindbuffetBelt_10828 = 10828
const val itemArtfulBelt_10829 = 10829
const val itemArtfulBelt1_10830 = 10830
const val itemPaewrBelt_10831 = 10831
const val itemCarriersSash_10832 = 10832
const val itemManiacusSash_10833 = 10833
const val itemWanionBelt_10834 = 10834
const val itemSliporSash_10835 = 10835
const val itemPhosBelt_10836 = 10836
const val itemPhosBelt1_10837 = 10837
const val itemPatentiaSash_10838 = 10838
const val itemOthilaSash_10839 = 10839
const val itemAswangSash_10840 = 10840
const val itemPanthalassaSash_10841 = 10841
const val itemBougoniaRope_10842 = 10842
const val itemCaudataBelt_10844 = 10844
const val itemElanidBelt_10845 = 10845
const val itemIstioBelt_10846 = 10846
const val itemOrcBelt_10847 = 10847
const val itemQuadavBelt_10848 = 10848
const val itemYagudoBelt_10849 = 10849
const val itemLeechBelt_10850 = 10850
const val itemSlimeBelt_10851 = 10851
const val itemHecteyesBelt_10852 = 10852
const val itemOceloHeadpiece_10864 = 10864
const val itemNeferKhat_10865 = 10865
const val itemMekiraoto_10866 = 10866
const val itemOceHeadpiece1_10867 = 10867
const val itemNeferKhat1_10868 = 10868
const val itemMekiraoto1_10869 = 10869
const val itemSceamolBand_10870 = 10870
const val itemPandinusBeret_10871 = 10871
const val itemRuachCrown_10872 = 10872
const val itemTheiasHairpin_10873 = 10873
const val itemChersosHelm_10874 = 10874
const val itemSnowmanCap_10875 = 10875
const val itemOgiersHelm_10876 = 10876
const val itemAthossChapeau_10877 = 10877
const val itemRubeusBandeau_10878 = 10878
const val itemHreystiHelm_10879 = 10879
const val itemPraecoBeret_10880 = 10880
const val itemBregoHelm_10881 = 10881
const val itemSmilodonMask_10882 = 10882
const val itemGallianHelm_10883 = 10883
const val itemAvantHelm_10884 = 10884
const val itemAvantHelm1_10885 = 10885
const val itemKacuraCap_10886 = 10886
const val itemKacuraCap1_10887 = 10887
const val itemSwevenCorona_10888 = 10888
const val itemSwevenCorona1_10889 = 10889
const val itemCalmaArmet_10890 = 10890
const val itemMustelaMask_10891 = 10891
const val itemMagavanBeret_10892 = 10892
const val itemProdigysCirclet_10893 = 10893
const val itemStrigaCrown_10894 = 10894
const val itemPalnatokesCap_10895 = 10895
const val itemAasCirclet_10896 = 10896
const val itemRheicSalade_10897 = 10897
const val itemRheicSalade1_10898 = 10898
const val itemRheicSalade2_10899 = 10899
const val itemRheicSalade3_10900 = 10900
const val itemPhorcysSalade_10901 = 10901
const val itemEuxineHat_10902 = 10902
const val itemEuxineHat1_10903 = 10903
const val itemEuxineHat2_10904 = 10904
const val itemEuxineHat3_10905 = 10905
const val itemThaumasHat_10906 = 10906
const val itemTethyanCap_10907 = 10907
const val itemTethyanCap1_10908 = 10908
const val itemTethyanCap2_10909 = 10909
const val itemTethyanCap3_10910 = 10910
const val itemNaresCap_10911 = 10911
const val itemDrachenhorn_10912 = 10912
const val itemHyalineHat_10913 = 10913
const val itemMuzzlingCollar_10914 = 10914
const val itemMuzzlingCollar1_10915 = 10915
const val itemPacifyingChain_10916 = 10916
const val itemPacifyingChain1_10917 = 10917
const val itemTandemNecklace_10918 = 10918
const val itemTndmNecklace1_10919 = 10919
const val itemTndmNecklace2_10920 = 10920
const val itemTndmNecklace3_10921 = 10921
const val itemTndmNecklace4_10922 = 10922
const val itemChocoboTorque_10924 = 10924
const val itemFishersTorque_10925 = 10925
const val itemFieldTorque_10926 = 10926
const val itemGenesisLocket_10927 = 10927
const val itemGaneshasMala_10928 = 10928
const val itemApathyGorget_10929 = 10929
const val itemVeisaCollar_10930 = 10930
const val itemRancorCollar_10931 = 10931
const val itemOneirosTorque_10932 = 10932
const val itemMujinNecklace_10933 = 10933
const val itemJusticiarsTorque_10934 = 10934
const val itemPhrenicTorque_10935 = 10935
const val itemWiglenGorget_10936 = 10936
const val itemCalcitrantStole_10937 = 10937
const val itemHouyisGorget_10938 = 10938
const val itemDualismCollar_10939 = 10939
const val itemMoepapaPendant_10940 = 10940
const val itemTjukurrpaMedal_10941 = 10941
const val itemAifesMedal_10942 = 10942
const val itemMoepapaMedal_10943 = 10943
const val itemPortusCollar_10944 = 10944
const val itemWaylayersScarf_10945 = 10945
const val itemCoatlGorget_10946 = 10946
const val itemSaevusPendant_10947 = 10947
const val itemCarversTorque_10948 = 10948
const val itemSmithysTorque_10949 = 10949
const val itemGoldsmTorque_10950 = 10950
const val itemWeaversTorque_10951 = 10951
const val itemTannersTorque_10952 = 10952
const val itemBoneTorque_10953 = 10953
const val itemAlchemstTorque_10954 = 10954
const val itemCulinTorque_10955 = 10955
const val itemStoicheionMedal_10957 = 10957
const val itemNefariousCollar_10958 = 10958
const val itemInquisitorsChain_10959 = 10959
const val itemPhalainaLocket_10960 = 10960
const val itemLavalier_10961 = 10961
const val itemLavalier1_10962 = 10962
const val itemAirmidsGorget_10963 = 10963
const val itemEloquenceCape_10964 = 10964
const val itemEloquenceCape1_10965 = 10965
const val itemAisanceMantle_10966 = 10966
const val itemAisanceMantle1_10967 = 10967
const val itemVigilanceMantle_10968 = 10968
const val itemVigilanceMantle1_10969 = 10969
const val itemScutaCape_10970 = 10970
const val itemStrenduMantle_10971 = 10971
const val itemOneirosCappa_10972 = 10972
const val itemOneirosCape_10973 = 10973
const val itemMujinMantle_10974 = 10974
const val itemArchonCape_10975 = 10975
const val itemKaikiasCape_10976 = 10976
const val itemRomanusCape_10977 = 10977
const val itemMisuuchiKappa_10978 = 10978
const val itemBalladeersCape_10979 = 10979
const val itemMolluscaMantle_10980 = 10980
const val itemChelaCape_10981 = 10981
const val itemVimuktiMantle_10982 = 10982
const val itemAifesMantle_10983 = 10983
const val itemTjukurrpaMantle_10984 = 10984
const val itemMoondoeMantle_10985 = 10985
const val itemOretaniasCape_10986 = 10986
const val itemMeanaghCape_10987 = 10987
const val itemBlitheMantle_10988 = 10988
const val itemTemperedCape_10989 = 10989
const val itemEngulferCape_10990 = 10990
const val itemRancorousMantle_10991 = 10991
const val itemVassalsMantle_10992 = 10992
const val itemDrachenblutCape_10993 = 10993
const val itemChuparrosaMantle_10994 = 10994
const val itemZaffreCape_10995 = 10995
const val itemTestudoMantle_10996 = 10996
const val itemTestudoMantle1_10997 = 10997
const val itemAttackersMantle_10998 = 10998
const val itemDauntlessMantle_10999 = 10999
const val itemSwithCape_11000 = 11000
const val itemSwithCape1_11001 = 11001
const val itemDragonTank_11002 = 11002
const val itemProdigiousMantle_11003 = 11003
const val itemAlgidusCape_11004 = 11004
const val itemFierabrassMantle_11005 = 11005
const val itemThallMantle_11006 = 11006
const val itemLetalisMantle_11007 = 11007
const val itemMedalaCape_11008 = 11008
const val itemShapersShawl_11009 = 11009
const val itemFelineMantle_11010 = 11010
const val itemGwyddionsCape_11012 = 11012
const val itemTaubranCape_11013 = 11013
const val itemFlamePearl_11014 = 11014
const val itemSnowPearl_11015 = 11015
const val itemBreezePearl_11016 = 11016
const val itemSoilPearl_11017 = 11017
const val itemThunderPearl_11018 = 11018
const val itemAquaPearl_11019 = 11019
const val itemLightPearl_11020 = 11020
const val itemDarknessPearl_11021 = 11021
const val itemVulcansPearl_11022 = 11022
const val itemAquilosPearl_11023 = 11023
const val itemAustersPearl_11024 = 11024
const val itemTerrasPearl_11025 = 11025
const val itemJupitersPearl_11026 = 11026
const val itemNeptunesPearl_11027 = 11027
const val itemApollosPearl_11028 = 11028
const val itemPlutosPearl_11029 = 11029
const val itemOneirosEarring_11030 = 11030
const val itemOneirosPearl_11031 = 11031
const val itemMujinStud_11032 = 11032
const val itemBruisersEarring_11033 = 11033
const val itemEvergreenEarring_11034 = 11034
const val itemStrophadicEarring_11035 = 11035
const val itemEnchntrEarring_11036 = 11036
const val itemEarthcryEarring_11037 = 11037
const val itemDragonkinEarring_11038 = 11038
const val itemBrachyuraEarring_11039 = 11039
const val itemTerminusEarring_11040 = 11040
const val itemLiminusEarring_11041 = 11041
const val itemRebelEarring_11042 = 11042
const val itemGiantsEarring_11043 = 11043
const val itemCorybantPearl_11044 = 11044
const val itemSaviesaPearl_11045 = 11045
const val itemOueskPearl_11046 = 11046
const val itemBelatzPearl_11047 = 11047
const val itemCythereaPearl_11048 = 11048
const val itemMyrddinPearl_11049 = 11049
const val itemPuissantPearl_11050 = 11050
const val itemHeartyEarring_11051 = 11051
const val itemEsperEarring_11052 = 11052
const val itemCholericEarring_11053 = 11053
const val itemPenseeEarring_11054 = 11054
const val itemAredanEarring_11055 = 11055
const val itemGhillieEarring_11056 = 11056
const val itemGhillieEarring1_11057 = 11057
const val itemHajdukRing_11058 = 11058
const val itemHajdukRing1_11059 = 11059
const val itemEvaderEarring_11060 = 11060
const val itemEvaderEarring1_11061 = 11061
const val itemFountainRing_11062 = 11062
const val itemPraanRing_11063 = 11063
const val itemRavagersMask2_11064 = 11064
const val itemTantraCrown2_11065 = 11065
const val itemOrisonCap2_11066 = 11066
const val itemGoetiaPetasos2_11067 = 11067
const val itemEstqChappel2_11068 = 11068
const val itemRaidBonnet2_11069 = 11069
const val itemCreedArmet2_11070 = 11070
const val itemBaleBurgeonet2_11071 = 11071
const val itemFerineCabasset2_11072 = 11072
const val itemAoidosCalot2_11073 = 11073
const val itemSylvanGapette2_11074 = 11074
const val itemUnkaiKabuto2_11075 = 11075
const val itemIgaZukin2_11076 = 11076
const val itemLancersMezail2_11077 = 11077
const val itemCallersHorn2_11078 = 11078
const val itemMaviKavuk2_11079 = 11079
const val itemNvrchTricorne2_11080 = 11080
const val itemCirqueCappello2_11081 = 11081
const val itemCharisTiara2_11082 = 11082
const val itemSvntBonnet2_11083 = 11083
const val itemRvgLorica2_11084 = 11084
const val itemTantraCyclas2_11085 = 11085
const val itemOrisonBliaut2_11086 = 11086
const val itemGoetiaCoat2_11087 = 11087
const val itemEstqSayon2_11088 = 11088
const val itemRaidersVest2_11089 = 11089
const val itemCreedCuirass2_11090 = 11090
const val itemBaleCuirass2_11091 = 11091
const val itemFerineGausape2_11092 = 11092
const val itemAoidosHngrln2_11093 = 11093
const val itemSylvanCaban2_11094 = 11094
const val itemUnkaiDomaru2_11095 = 11095
const val itemIgaNingi2_11096 = 11096
const val itemLncrPlackart2_11097 = 11097
const val itemCallDoublet2_11098 = 11098
const val itemMaviMintan2_11099 = 11099
const val itemNvrchFrac2_11100 = 11100
const val itemCirqueFarsetto2_11101 = 11101
const val itemCharisCasaque2_11102 = 11102
const val itemSavantsGown2_11103 = 11103
const val itemRvgMufflers2_11104 = 11104
const val itemTantraGloves2_11105 = 11105
const val itemOrisonMitts2_11106 = 11106
const val itemGoetiaGloves2_11107 = 11107
const val itemEstqGanthrt2_11108 = 11108
const val itemRaidArmlets2_11109 = 11109
const val itemCrdGauntlets2_11110 = 11110
const val itemBaleGauntlets2_11111 = 11111
const val itemFrnManoplas2_11112 = 11112
const val itemAdMnchtte2_11113 = 11113
const val itemSylGlvltte2_11114 = 11114
const val itemUnkaiKote2_11115 = 11115
const val itemIgaTekko2_11116 = 11116
const val itemLncrVmbrc2_11117 = 11117
const val itemCallBracers2_11118 = 11118
const val itemMvBazubands2_11119 = 11119
const val itemNvrchGants2_11120 = 11120
const val itemCirqueGuanti2_11121 = 11121
const val itemCharisBangles2_11122 = 11122
const val itemSvntBracers2_11123 = 11123
const val itemRvgCuisses2_11124 = 11124
const val itemTantraHose2_11125 = 11125
const val itemOrsnPantaln2_11126 = 11126
const val itemGoetChausses2_11127 = 11127
const val itemEstqrFuseau2_11128 = 11128
const val itemRaidCulottes2_11129 = 11129
const val itemCreedCuisses2_11130 = 11130
const val itemBaleFlanchard2_11131 = 11131
const val itemFerineQuijotes2_11132 = 11132
const val itemAoidosRhing2_11133 = 11133
const val itemSylvanBragues2_11134 = 11134
const val itemUnkaiHaidate2_11135 = 11135
const val itemIgaHakama2_11136 = 11136
const val itemLncrCuissots2_11137 = 11137
const val itemCallersSpats2_11138 = 11138
const val itemMaviTayt2_11139 = 11139
const val itemNvrchCulottes2_11140 = 11140
const val itemCirqPantaloni2_11141 = 11141
const val itemCharisTights2_11142 = 11142
const val itemSavantsPants2_11143 = 11143
const val itemRvgCalligae2_11144 = 11144
const val itemTantraGaiters2_11145 = 11145
const val itemOrsnDuckbills2_11146 = 11146
const val itemGoetiaSabots2_11147 = 11147
const val itemEstqHouseaux2_11148 = 11148
const val itemRaidPoulaines2_11149 = 11149
const val itemCreedSabatons2_11150 = 11150
const val itemBaleSollerets2_11151 = 11151
const val itemFerineOcreae2_11152 = 11152
const val itemAoidosCothrn2_11153 = 11153
const val itemSylvanBottln2_11154 = 11154
const val itemUnkaiSuneAte2_11155 = 11155
const val itemIgaKyahan2_11156 = 11156
const val itemLncrSchynbld2_11157 = 11157
const val itemCallersPgch2_11158 = 11158
const val itemMaviBasmak2_11159 = 11159
const val itemNvrchBottes2_11160 = 11160
const val itemCirqueScarpe2_11161 = 11161
const val itemCharisToeShoes2_11162 = 11162
const val itemSvntLoafers2_11163 = 11163
const val itemRavagersMask1_11164 = 11164
const val itemTantraCrown1_11165 = 11165
const val itemOrisonCap1_11166 = 11166
const val itemGoetiaPetasos1_11167 = 11167
const val itemEstqChappel1_11168 = 11168
const val itemRaidBonnet1_11169 = 11169
const val itemCreedArmet1_11170 = 11170
const val itemBaleBurgeonet1_11171 = 11171
const val itemFerineCabasset1_11172 = 11172
const val itemAoidosCalot1_11173 = 11173
const val itemSylvanGapette1_11174 = 11174
const val itemUnkaiKabuto1_11175 = 11175
const val itemIgaZukin1_11176 = 11176
const val itemLancersMezail1_11177 = 11177
const val itemCallersHorn1_11178 = 11178
const val itemMaviKavuk1_11179 = 11179
const val itemNvrchTricorne1_11180 = 11180
const val itemCirqueCappello1_11181 = 11181
const val itemCharisTiara1_11182 = 11182
const val itemSvntBonnet1_11183 = 11183
const val itemRvgLorica1_11184 = 11184
const val itemTantraCyclas1_11185 = 11185
const val itemOrisonBliaut1_11186 = 11186
const val itemGoetiaCoat1_11187 = 11187
const val itemEstqSayon1_11188 = 11188
const val itemRaidersVest1_11189 = 11189
const val itemCreedCuirass1_11190 = 11190
const val itemBaleCuirass1_11191 = 11191
const val itemFerineGausape1_11192 = 11192
const val itemAoidosHngrln1_11193 = 11193
const val itemSylvanCaban1_11194 = 11194
const val itemUnkaiDomaru1_11195 = 11195
const val itemIgaNingi1_11196 = 11196
const val itemLncrPlackart1_11197 = 11197
const val itemCallersDoublet1_11198 = 11198
const val itemMaviMintan1_11199 = 11199
const val itemNavarchsFrac1_11200 = 11200
const val itemCirqueFarsetto1_11201 = 11201
const val itemCharisCasaque1_11202 = 11202
const val itemSavantsGown1_11203 = 11203
const val itemRvgMufflers1_11204 = 11204
const val itemTantraGloves1_11205 = 11205
const val itemOrisonMitts1_11206 = 11206
const val itemGoetiaGloves1_11207 = 11207
const val itemEstqGanthrt1_11208 = 11208
const val itemRaidArmlets1_11209 = 11209
const val itemCrdGauntlets1_11210 = 11210
const val itemBaleGauntlets1_11211 = 11211
const val itemFrnManoplas1_11212 = 11212
const val itemAdMnchtte1_11213 = 11213
const val itemSylGlvltte1_11214 = 11214
const val itemUnkaiKote1_11215 = 11215
const val itemIgaTekko1_11216 = 11216
const val itemLncrVmbrc1_11217 = 11217
const val itemCallersBracers1_11218 = 11218
const val itemMvBazubands1_11219 = 11219
const val itemNvrchGants1_11220 = 11220
const val itemCirqueGuanti1_11221 = 11221
const val itemCharisBangles1_11222 = 11222
const val itemSvntBracers1_11223 = 11223
const val itemRvgCuisses1_11224 = 11224
const val itemTantraHose1_11225 = 11225
const val itemOrsnPantaln1_11226 = 11226
const val itemGoetChausses1_11227 = 11227
const val itemEstqrFuseau1_11228 = 11228
const val itemRaidCulottes1_11229 = 11229
const val itemCreedCuisses1_11230 = 11230
const val itemBaleFlanchard1_11231 = 11231
const val itemFerineQuijotes1_11232 = 11232
const val itemAoidosRhing1_11233 = 11233
const val itemSylvanBragues1_11234 = 11234
const val itemUnkaiHaidate1_11235 = 11235
const val itemIgaHakama1_11236 = 11236
const val itemLncrCuissots1_11237 = 11237
const val itemCallersSpats1_11238 = 11238
const val itemMaviTayt1_11239 = 11239
const val itemNvrchCulottes1_11240 = 11240
const val itemCirqPantaloni1_11241 = 11241
const val itemCharisTights1_11242 = 11242
const val itemSavantsPants1_11243 = 11243
const val itemRvgCalligae1_11244 = 11244
const val itemTantraGaiters1_11245 = 11245
const val itemOrsnDuckbills1_11246 = 11246
const val itemGoetiaSabots1_11247 = 11247
const val itemEstqHouseaux1_11248 = 11248
const val itemRaidPoulaines1_11249 = 11249
const val itemCreedSabatons1_11250 = 11250
const val itemBaleSollerets1_11251 = 11251
const val itemFerineOcreae1_11252 = 11252
const val itemAoidosCothrn1_11253 = 11253
const val itemSylvanBottln1_11254 = 11254
const val itemUnkaiSuneAte1_11255 = 11255
const val itemIgaKyahan1_11256 = 11256
const val itemLncrSchynbld1_11257 = 11257
const val itemCallersPgch1_11258 = 11258
const val itemMaviBasmak1_11259 = 11259
const val itemNvrchBottes1_11260 = 11260
const val itemCirqueScarpe1_11261 = 11261
const val itemCharisToeShoes1_11262 = 11262
const val itemSvntLoafers1_11263 = 11263
const val itemCustomGilet_11265 = 11265
const val itemCustomTop_11266 = 11266
const val itemMagnaGilet_11267 = 11267
const val itemMagnaTop_11268 = 11268
const val itemWonderMaillot_11269 = 11269
const val itemWonderTop_11270 = 11270
const val itemSavageTop_11271 = 11271
const val itemElderGilet_11272 = 11272
const val itemCustomGilet1_11273 = 11273
const val itemCustomTop1_11274 = 11274
const val itemMagnaGilet1_11275 = 11275
const val itemMagnaTop1_11276 = 11276
const val itemWonderMaillot1_11277 = 11277
const val itemWonderTop1_11278 = 11278
const val itemSavageTop1_11279 = 11279
const val itemElderGilet1_11280 = 11280
const val itemHachiryuHaramaki_11281 = 11281
const val itemAurumCuirass_11282 = 11282
const val itemOraclesRobe_11283 = 11283
const val itemEnkidusHarness_11284 = 11284
const val itemMrgnCotehardie_11285 = 11285
const val itemAvalonBreastplate_11286 = 11286
const val itemAntaresHarness_11287 = 11287
const val itemZahaksMail_11288 = 11288
const val itemIxionCloak_11289 = 11289
const val itemTidalTalisman_11290 = 11290
const val itemMagusJubbah1_11291 = 11291
const val itemMirageJubbah_11292 = 11292
const val itemMirageJubbah1_11293 = 11293
const val itemCorsairsFrac1_11294 = 11294
const val itemCommodoreFrac_11295 = 11295
const val itemCommFrac1_11296 = 11296
const val itemPupTobe1_11297 = 11297
const val itemPantinTobe_11298 = 11298
const val itemPantinTobe1_11299 = 11299
const val itemEerieCloak_11300 = 11300
const val itemEerieCloak1_11301 = 11301
const val itemDncCasaque1_11302 = 11302
const val itemDncCasaque1_11303 = 11303
const val itemScholarsGown1_11304 = 11304
const val itemEtoileCasaque_11305 = 11305
const val itemEtoileCasaque1_11306 = 11306
const val itemArguteGown_11307 = 11307
const val itemArguteGown1_11308 = 11308
const val itemBenedightCoat_11309 = 11309
const val itemArgentCoat_11310 = 11310
const val itemPlatinoCoat_11311 = 11311
const val itemRamblersCloak_11312 = 11312
const val itemNuevoCoselete_11313 = 11313
const val itemMirkeWardecors_11314 = 11314
const val itemRoyalRedingote_11315 = 11315
const val itemOtokogusaYukata_11316 = 11316
const val itemOnnagusaYukata_11317 = 11317
const val itemOtokoeshiYukata_11318 = 11318
const val itemOminaeshiYukata_11319 = 11319
const val itemSkeletonRobe_11320 = 11320
const val itemOrangeRaceSilks_11321 = 11321
const val itemBlackRaceSilks_11322 = 11322
const val itemPurpleRaceSilks_11323 = 11323
const val itemSBlueRaceSilks_11324 = 11324
const val itemBlueRaceSilks_11325 = 11325
const val itemRedRaceSilks_11326 = 11326
const val itemWhiteRaceSilks_11327 = 11327
const val itemGreenRaceSilks_11328 = 11328
const val itemCarpentersSmock_11329 = 11329
const val itemBlksmithSmock_11330 = 11330
const val itemGoldsmithsSmock_11331 = 11331
const val itemWeaversSmock_11332 = 11332
const val itemTannersSmock_11333 = 11333
const val itemBonewrkSmock_11334 = 11334
const val itemAlchemistsSmock_11335 = 11335
const val itemCulinariansSmock_11336 = 11336
const val itemFishermansSmock_11337 = 11337
const val itemAegasDoublet_11338 = 11338
const val itemChannelingRobe_11339 = 11339
const val itemSalutaryRobe_11340 = 11340
const val itemVivacityCoat_11341 = 11341
const val itemRestorerCloak_11342 = 11342
const val itemThrkBreastplate_11343 = 11343
const val itemStyrneByrnie_11344 = 11344
const val itemAlacerAketon_11345 = 11345
const val itemVelaJustaucorps_11346 = 11346
const val itemMenetriersAlb_11347 = 11347
const val itemSalutaryRobe1_11348 = 11348
const val itemVivacityCoat1_11349 = 11349
const val itemStyrneByrnie1_11350 = 11350
const val itemAlacerAketon1_11351 = 11351
const val itemVelaJstcorps1_11352 = 11352
const val itemMenetriersAlb1_11353 = 11353
const val itemNocturnusMail_11354 = 11354
const val itemDinnerJacket_11355 = 11355
const val itemRylGrdLivery_11356 = 11356
const val itemMythMskLivery_11357 = 11357
const val itemPtrPrtLivery_11358 = 11358
const val itemVeloxHarness_11359 = 11359
const val itemTaranissHarness_11360 = 11360
const val itemPluviale_11361 = 11361
const val itemTwilightMail_11362 = 11362
const val itemTwilightCloak_11363 = 11363
const val itemHachiryuSuneAte_11364 = 11364
const val itemKarasutengu_11365 = 11365
const val itemAvocatPigaches_11366 = 11366
const val itemNobushiKyahan_11367 = 11367
const val itemHakkeHabaki_11368 = 11368
const val itemNumeristPumps_11369 = 11369
const val itemJunkenshiHabaki_11370 = 11370
const val itemSeikenshiHabaki_11371 = 11371
const val itemJunrenshiHabaki_11372 = 11372
const val itemSeirenshiHabaki_11373 = 11373
const val itemJunhanshiHabaki_11374 = 11374
const val itemSeihanshiHabaki_11375 = 11375
const val itemAurumSabatons_11376 = 11376
const val itemOraclesPigaches_11377 = 11377
const val itemEnkidusLeggings_11378 = 11378
const val itemHermesSandals_11379 = 11379
const val itemHermesSandals1_11380 = 11380
const val itemMagusCharuqs1_11381 = 11381
const val itemMirageCharuqs_11382 = 11382
const val itemMirageCharuqs1_11383 = 11383
const val itemCorBottes1_11384 = 11384
const val itemCommBottes_11385 = 11385
const val itemCommBottes1_11386 = 11386
const val itemPupBabouches1_11387 = 11387
const val itemPantinBabouches_11388 = 11388
const val itemPtnBabouches1_11389 = 11389
const val itemLlwydsClogs_11390 = 11390
const val itemEmissaryBoots_11391 = 11391
const val itemKoscheiCrackows_11392 = 11392
const val itemDancersToeShoes1_11393 = 11393
const val itemDancersToeShoes1_11394 = 11394
const val itemSchLoafers1_11395 = 11395
const val itemEtoileToeShoes_11396 = 11396
const val itemEtoileToeShoes1_11397 = 11397
const val itemArguteLoafers_11398 = 11398
const val itemArguteLoafers1_11399 = 11399
const val itemNoblePoulaines_11400 = 11400
const val itemRamblersGaiters_11401 = 11401
const val itemGothicSabatons_11402 = 11402
const val itemTalaria_11403 = 11403
const val itemPromptitudeSolea_11404 = 11404
const val itemKyoshuKyahan_11405 = 11405
const val itemStimulusSabots_11406 = 11406
const val itemMettleLeggings_11407 = 11407
const val itemMoranaPigaches_11408 = 11408
const val itemAoidesPumps_11409 = 11409
const val itemSetantasLed_11410 = 11410
const val itemShrewdPumps_11411 = 11411
const val itemMttLeggings1_11412 = 11412
const val itemPerleSollerets_11413 = 11413
const val itemAuroreGaiters_11414 = 11414
const val itemTealPigaches_11415 = 11415
const val itemCloutBoots_11416 = 11416
const val itemTheurgiaClogs_11417 = 11417
const val itemPoiseShoes_11418 = 11418
const val itemLitheBoots_11419 = 11419
const val itemRuffianLeggings_11420 = 11420
const val itemMissileBoots_11421 = 11421
const val itemConduitShoes_11422 = 11422
const val itemRagerLedelsens_11423 = 11423
const val itemGulesLeggings_11424 = 11424
const val itemGulesLeggings1_11425 = 11425
const val itemVersaSollerets_11426 = 11426
const val itemVersaSollerets1_11427 = 11427
const val itemLoreSabots_11428 = 11428
const val itemLoreSabots1_11429 = 11429
const val itemTandavaCrackows_11430 = 11430
const val itemBallerines_11431 = 11431
const val itemAcesLeggings_11432 = 11432
const val itemDornenSchuhs_11433 = 11433
const val itemSapientiaSabots_11434 = 11434
const val itemBellicusSabatons_11435 = 11435
const val itemBestiaGreaves_11436 = 11436
const val itemParagonSollerets_11437 = 11437
const val itemSkoposSocks_11438 = 11438
const val itemKokuSuneAte_11439 = 11439
const val itemSpryGaiters_11440 = 11440
const val itemMederiBrogues_11441 = 11441
const val itemLiteraeSabots_11442 = 11442
const val itemFacioGaloshes_11443 = 11443
const val itemFriskySabots_11444 = 11444
const val itemEtaminGambieras_11445 = 11445
const val itemAreionsGamashes_11446 = 11446
const val itemAlcidesLeggings_11447 = 11447
const val itemAlcdLeggings1_11448 = 11448
const val itemNemusNails_11449 = 11449
const val itemNemusNails1_11450 = 11450
const val itemNebulaPigaches_11451 = 11451
const val itemNebulaPgch1_11452 = 11452
const val itemCalmecacLeggings_11453 = 11453
const val itemJingangGreaves_11454 = 11454
const val itemMenhitLeggings_11455 = 11455
const val itemRyugaSuneAte_11456 = 11456
const val itemEurusLedelsens_11457 = 11457
const val itemDilaramsSollerets_11458 = 11458
const val itemSavateursGaiters_11459 = 11459
const val itemFajinBoots_11460 = 11460
const val itemAifesPumps_11461 = 11461
const val itemGigantesBoots_11462 = 11462
const val itemMagusKeffiyeh1_11464 = 11464
const val itemMirageKeffiyeh_11465 = 11465
const val itemMirageKeffiyeh1_11466 = 11466
const val itemCorTricorne1_11467 = 11467
const val itemCommTricorne_11468 = 11468
const val itemCommTricorne1_11469 = 11469
const val itemPuppetryTaj1_11470 = 11470
const val itemPantinTaj_11471 = 11471
const val itemPantinTaj1_11472 = 11472
const val itemMirrorTiara_11473 = 11473
const val itemLouhisMask_11474 = 11474
const val itemDancersTiara1_11475 = 11475
const val itemDancersTiara1_11476 = 11476
const val itemSchMboard1_11477 = 11477
const val itemEtoileTiara_11478 = 11478
const val itemEtoileTiara1_11479 = 11479
const val itemArguteMboard_11480 = 11480
const val itemArguteMboard1_11481 = 11481
const val itemEyepatch_11482 = 11482
const val itemGnoleCrown_11483 = 11483
const val itemAnticaBand_11484 = 11484
const val itemSpelunkersHelm_11485 = 11485
const val itemDianaCorona_11486 = 11486
const val itemChampionsGalea_11487 = 11487
const val itemAnwigSalade_11488 = 11488
const val itemSelenianCap_11489 = 11489
const val itemSnowBunnyHat_11490 = 11490
const val itemSBunnyHat1_11491 = 11491
const val itemRiskyPatch_11492 = 11492
const val itemPrecisionBandana_11493 = 11493
const val itemCircesHat_11494 = 11494
const val itemZealCap_11495 = 11495
const val itemFenrirsCrown_11496 = 11496
const val itemSpurrerBeret_11497 = 11497
const val itemZealCap1_11498 = 11498
const val itemTraineesSpecs_11499 = 11499
const val itemChocoboBeret_11500 = 11500
const val itemNocturnusHelm_11501 = 11501
const val itemAcubensHelm_11502 = 11502
const val itemPerleSalade_11503 = 11503
const val itemAuroreBeret_11504 = 11504
const val itemTealChapeau_11505 = 11505
const val itemVarangianHelm_11506 = 11506
const val itemHerosGalea_11507 = 11507
const val itemTokonHachimaki_11508 = 11508
const val itemIssenHachimaki_11509 = 11509
const val itemKenshoHachimaki_11510 = 11510
const val itemHakoHachimaki_11511 = 11511
const val itemRyoshiHachimaki_11512 = 11512
const val itemSenshinHachimaki_11513 = 11513
const val itemRekkaHachimaki_11514 = 11514
const val itemShitotsuHachimaki_11515 = 11515
const val itemKanjaHachimaki_11516 = 11516
const val itemKengoHachimaki_11517 = 11517
const val itemRokugoHachimaki_11518 = 11518
const val itemHakkeHachimaki_11519 = 11519
const val itemShuntenHachimaki_11520 = 11520
const val itemSaikaHachimaki_11521 = 11521
const val itemLightsomeCap_11522 = 11522
const val itemBriskMask_11523 = 11523
const val itemNoesisHelm_11524 = 11524
const val itemMaestriaMask_11525 = 11525
const val itemBersailCap_11526 = 11526
const val itemHecatesCrown_11527 = 11527
const val itemBesiegerMantle_11528 = 11528
const val itemFrugalCape_11529 = 11529
const val itemExactitudeMantle_11530 = 11530
const val itemFidelityMantle_11531 = 11531
const val itemAccuraCape_11532 = 11532
const val itemLyricistsGonnelle_11533 = 11533
const val itemEchoCape_11534 = 11534
const val itemFowlersMantle_11535 = 11535
const val itemWygKltMantle_11536 = 11536
const val itemKinesisMantle_11537 = 11537
const val itemNexusCape_11538 = 11538
const val itemExactMantle1_11539 = 11539
const val itemAccuraCape1_11540 = 11540
const val itemFowlersMantle1_11541 = 11541
const val itemKinesisMantle1_11542 = 11542
const val itemHecatesCape_11543 = 11543
const val itemVeelaCape_11544 = 11544
const val itemFourthMantle_11545 = 11545
const val itemAesirMantle_11546 = 11546
const val itemColossussMantle_11547 = 11547
const val itemTacticalMantle_11548 = 11548
const val itemTerebellumMantle_11549 = 11549
const val itemBelenosMantle_11550 = 11550
const val itemMetallonMantle_11551 = 11551
const val itemLibeccioMantle_11552 = 11552
const val itemCavarosMantle_11553 = 11553
const val itemOrisonCape_11554 = 11554
const val itemFerineMantle_11555 = 11555
const val itemSunbeamCape_11556 = 11556
const val itemFortisMantle_11557 = 11557
const val itemNiftyMantle_11558 = 11558
const val itemUltionMantle_11559 = 11559
const val itemPedantCape_11560 = 11560
const val itemSalvusMantle_11561 = 11561
const val itemSharpeyeMantle_11562 = 11562
const val itemMesmericCape_11563 = 11563
const val itemTiresiasCape_11564 = 11564
const val itemVellaunusMantle_11565 = 11565
const val itemVatesCape_11566 = 11566
const val itemAenotherusMantle_11567 = 11567
const val itemFelicitasCape_11568 = 11568
const val itemFugacityMantle_11569 = 11569
const val itemForbanCape_11570 = 11570
const val itemKaragozMantle_11571 = 11571
const val itemVitaCape_11572 = 11572
const val itemBlurMantle_11573 = 11573
const val itemPotentiaCape_11574 = 11574
const val itemGrapevineCape_11575 = 11575
const val itemBondCape_11576 = 11576
const val itemTiercelNecklace_11578 = 11578
const val itemFylgjaTorque_11579 = 11579
const val itemFylgjaTorque1_11580 = 11580
const val itemIreTorque_11581 = 11581
const val itemIreTorque1_11582 = 11582
const val itemLmgMedallion_11583 = 11583
const val itemLmgMedallion1_11584 = 11584
const val itemBeguilingCollar_11585 = 11585
const val itemBacklashTorque_11586 = 11586
const val itemNyxGorget_11587 = 11587
const val itemMrcMjrCharm_11588 = 11588
const val itemAesirTorque_11589 = 11589
const val itemColossussTorque_11590 = 11590
const val itemRavagersGorget_11591 = 11591
const val itemTantraNecklace_11592 = 11592
const val itemGoetiaChain_11593 = 11593
const val itemEstoqueursCollar_11594 = 11594
const val itemCreedCollar_11595 = 11595
const val itemSylvanScarf_11596 = 11596
const val itemUnkaiNodowa_11597 = 11597
const val itemIgaErimaki_11598 = 11598
const val itemLancersTorque_11599 = 11599
const val itemMaviScarf_11600 = 11600
const val itemNavarchsChoker_11601 = 11601
const val itemCirqueNecklace_11602 = 11602
const val itemCharisNecklace_11603 = 11603
const val itemCorvusTorque_11604 = 11604
const val itemZielCharm_11605 = 11605
const val itemArctiersTorque_11606 = 11606
const val itemArtemissMedal_11607 = 11607
const val itemBarcarolleMedal_11608 = 11608
const val itemShiftingNecklace_11609 = 11609
const val itemLaconoNecklace_11610 = 11610
const val itemAcesosChoker_11611 = 11611
const val itemEidolonPendant_11612 = 11612
const val itemKatipoCharm_11613 = 11613
const val itemArdorPendant_11614 = 11614
const val itemOrisonLocket_11615 = 11615
const val itemBaleChoker_11616 = 11616
const val itemFerineNecklace_11617 = 11617
const val itemAoidosMatinee_11618 = 11618
const val itemCallersPendant_11619 = 11619
const val itemSavantsChain_11620 = 11620
const val itemChrysTorque_11621 = 11621
const val itemAgasayasCollar_11622 = 11622
const val itemNoeticTorque_11623 = 11623
const val itemSolonTorque_11624 = 11624
const val itemTwilightTorque_11625 = 11625
const val itemToreroTorque_11626 = 11626
const val itemMagoragaBeads_11627 = 11627
const val itemStrigoiRing_11628 = 11628
const val itemZilantRing_11629 = 11629
const val itemCorneusRing_11630 = 11630
const val itemBlobnagRing_11631 = 11631
const val itemKarkaRing_11632 = 11632
const val itemGaldrRing_11633 = 11633
const val itemVeelaRing_11634 = 11634
const val itemAlertRing_11635 = 11635
const val itemRKSigilRing_11636 = 11636
const val itemMeridianRing_11637 = 11637
const val itemAdlerRing_11638 = 11638
const val itemBlasonRing_11639 = 11639
const val itemBifrostRing_11640 = 11640
const val itemMetanoiaRing_11641 = 11641
const val itemHoardRing_11642 = 11642
const val itemOdiumRing_11643 = 11643
const val itemAreweRing_11644 = 11644
const val itemAreweRing1_11645 = 11645
const val itemSironasRing_11646 = 11646
const val itemAiryRing_11647 = 11647
const val itemSpiralRing_11648 = 11648
const val itemSolemnRing_11649 = 11649
const val itemHeedRing_11650 = 11650
const val itemEponasRing_11651 = 11651
const val itemMiseriaRing_11652 = 11652
const val itemKeenRing_11653 = 11653
const val itemPuffinRing_11654 = 11654
const val itemNoddyRing_11655 = 11655
const val itemPyrosoulRing_11656 = 11656
const val itemIcesoulRing_11657 = 11657
const val itemStormsoulRing_11658 = 11658
const val itemTerrasoulRing_11659 = 11659
const val itemThundersoulRing_11660 = 11660
const val itemAquasoulRing_11661 = 11661
const val itemDawnsoulRing_11662 = 11662
const val itemDusksoulRing_11663 = 11663
const val itemPhrygianRing_11664 = 11664
const val itemPhrygianRing1_11665 = 11665
const val itemNovennialRing_11666 = 11666
const val itemRollersRing_11667 = 11667
const val itemIrrwischRing_11668 = 11668
const val itemStrenduRing_11669 = 11669
const val itemOneirosAnnulet_11670 = 11670
const val itemOneirosRing_11671 = 11671
const val itemMujinBand_11672 = 11672
const val itemDemonryRing_11673 = 11673
const val itemArchonRing_11674 = 11674
const val itemFervorRing_11675 = 11675
const val itemFlockRing_11676 = 11676
const val itemProuesseRing_11677 = 11677
const val itemFlameEarring_11678 = 11678
const val itemThunderEarring_11679 = 11679
const val itemSoilEarring_11680 = 11680
const val itemBreezeEarring_11681 = 11681
const val itemSnowEarring_11682 = 11682
const val itemAquaEarring_11683 = 11683
const val itemLightEarring_11684 = 11684
const val itemDarknessEarring_11685 = 11685
const val itemVulcansEarring_11686 = 11686
const val itemJupitersEarring_11687 = 11687
const val itemTerrasEarring_11688 = 11688
const val itemAustersEarring_11689 = 11689
const val itemAquilosEarring_11690 = 11690
const val itemNeptunesEarring_11691 = 11691
const val itemApollosEarring_11692 = 11692
const val itemPlutosEarring_11693 = 11693
const val itemBloodgemEarring_11694 = 11694
const val itemVolleyEarring_11695 = 11695
const val itemKemasEarring_11696 = 11696
const val itemMoonshadeEarring_11697 = 11697
const val itemHecatesEarring_11698 = 11698
const val itemClearviewEarring_11699 = 11699
const val itemGiftedEarring_11700 = 11700
const val itemSkaldBreloque_11701 = 11701
const val itemCentaurusEarring_11702 = 11702
const val itemRavagersEarring_11703 = 11703
const val itemTantraEarring_11704 = 11704
const val itemOrisonEarring_11705 = 11705
const val itemGoetiaEarring_11706 = 11706
const val itemEstqEarring_11707 = 11707
const val itemRaidersEarring_11708 = 11708
const val itemCreedEarring_11709 = 11709
const val itemBaleEarring_11710 = 11710
const val itemFerineEarring_11711 = 11711
const val itemAoidosEarring_11712 = 11712
const val itemSylvanEarring_11713 = 11713
const val itemUnkaiMimikazari_11714 = 11714
const val itemIgaMimikazari_11715 = 11715
const val itemLancersEarring_11716 = 11716
const val itemCallersEarring_11717 = 11717
const val itemMaviEarring_11718 = 11718
const val itemNavarchsEarring_11719 = 11719
const val itemCirqueEarring_11720 = 11720
const val itemCharisEarring_11721 = 11721
const val itemSavantsEarring_11722 = 11722
const val itemReverieEarring_11723 = 11723
const val itemReverieEarring1_11724 = 11724
const val itemPhrygianEarring_11725 = 11725
const val itemPhrygEarring1_11726 = 11726
const val itemFlockEarring_11727 = 11727
const val itemBullwhipBelt_11728 = 11728
const val itemGoadingBelt_11729 = 11729
const val itemNierenschutz_11730 = 11730
const val itemAnguinusBelt_11731 = 11731
const val itemNuskusSash_11732 = 11732
const val itemAquilineBelt_11733 = 11733
const val itemShaolinBelt_11734 = 11734
const val itemImpulseBelt_11735 = 11735
const val itemRaidersBelt_11736 = 11736
const val itemBaleBelt_11737 = 11737
const val itemAoidosBelt_11738 = 11738
const val itemCallersSash_11739 = 11739
const val itemThiazisBelt_11740 = 11740
const val itemSentryBelt_11741 = 11741
const val itemCognitionBelt_11742 = 11742
const val itemSearingSash_11743 = 11743
const val itemCognizantBelt_11744 = 11744
const val itemAristoBelt_11745 = 11745
const val itemBelisamasRope_11746 = 11746
const val itemAusterityBelt_11747 = 11747
const val itemAcerbicSash_11748 = 11748
const val itemSveltesseGouriz_11749 = 11749
const val itemCreedBaudrier_11750 = 11750
const val itemCirqueSash_11751 = 11751
const val itemDiabolossRope_11752 = 11752
const val itemEmphatikosRope_11753 = 11753
const val itemCrudelisBelt_11754 = 11754
const val itemFlameBelt_11755 = 11755
const val itemSnowBelt_11756 = 11756
const val itemBreezeBelt_11757 = 11757
const val itemSoilBelt_11758 = 11758
const val itemThunderBelt_11759 = 11759
const val itemAquaBelt_11760 = 11760
const val itemLightBelt_11761 = 11761
const val itemShadowBelt_11762 = 11762
const val itemBeirBelt_11763 = 11763
const val itemBeirBelt1_11764 = 11764
const val itemSanctuaryObi_11765 = 11765
const val itemSanctuaryObi1_11766 = 11766
const val itemChocoboRope_11767 = 11767
const val itemFishersRope_11768 = 11768
const val itemFieldRope_11769 = 11769
const val itemAccursedBelt_11770 = 11770
const val itemPipilakaBelt_11771 = 11771
const val itemOneirosSash_11772 = 11772
const val itemOneirosBelt_11773 = 11773
const val itemOneirosCest_11774 = 11774
const val itemOneirosRope_11775 = 11775
const val itemMujinObi_11776 = 11776
const val itemDemonrySash_11777 = 11777
const val itemGulesCap_11778 = 11778
const val itemGulesCap1_11779 = 11779
const val itemVersaCelata_11780 = 11780
const val itemVersaCelata1_11781 = 11781
const val itemLoreHat_11782 = 11782
const val itemLoreHat1_11783 = 11783
const val itemAiasBonnet_11784 = 11784
const val itemVeloceZuchetto_11785 = 11785
const val itemLaurelWreath_11786 = 11786
const val itemHikmetHat_11787 = 11787
const val itemJestersHat_11788 = 11788
const val itemBellicusCelata_11789 = 11789
const val itemBestiaHelm_11790 = 11790
const val itemParagonGalea_11791 = 11791
const val itemSkoposVisor_11792 = 11792
const val itemKokuHatsuburi_11793 = 11793
const val itemSpryHeadgear_11794 = 11794
const val itemMederiTam_11795 = 11795
const val itemLiteraeHat_11796 = 11796
const val itemFacioCaubeen_11797 = 11797
const val itemTwilightHelm_11798 = 11798
const val itemZelusTiara_11799 = 11799
const val itemCenobitesCoiffe_11800 = 11800
const val itemDeceitMask_11801 = 11801
const val itemAlcidesCap_11802 = 11802
const val itemAlcidesCap1_11803 = 11803
const val itemNemusKhud_11804 = 11804
const val itemNemusKhud1_11805 = 11805
const val itemNebulaHat_11806 = 11806
const val itemNebulaHat1_11807 = 11807
const val itemFazheluoHelm_11808 = 11808
const val itemCuauhHeadpiece_11809 = 11809
const val itemHyksosKhat_11810 = 11810
const val itemDestrierBeret_11811 = 11811
const val itemCharityCap_11812 = 11812
const val itemChimeraHairpin_11813 = 11813
const val itemGaneshasMask_11814 = 11814
const val itemAppetenceCrown_11815 = 11815
const val itemOneirosHelm_11816 = 11816
const val itemOneirosBarbut_11817 = 11817
const val itemOneirosHeadgear_11818 = 11818
const val itemOneirosCoif_11819 = 11819
const val itemKhthoniosMask_11820 = 11820
const val itemKhthoniosHelm_11821 = 11821
const val itemAmanitaHairpin_11822 = 11822
const val itemCocoonBand_11823 = 11823
const val itemFazheluoHelm1_11824 = 11824
const val itemCuauhHdpce1_11825 = 11825
const val itemHyksosKhat1_11826 = 11826
const val itemLenoresHairpin_11827 = 11827
const val itemGulesHarness_11828 = 11828
const val itemGulesHarness1_11829 = 11829
const val itemVersaHauberk_11830 = 11830
const val itemVersaHauberk1_11831 = 11831
const val itemLoreRobe_11832 = 11832
const val itemLoreRobe1_11833 = 11833
const val itemBellicusCuirass_11834 = 11834
const val itemBestiaMail_11835 = 11835
const val itemParagonHaubert_11836 = 11836
const val itemSkoposJerkin_11837 = 11837
const val itemKokugetsuTogi_11838 = 11838
const val itemSpryVest_11839 = 11839
const val itemMederiTalar_11840 = 11840
const val itemLiteraeCoat_11841 = 11841
const val itemFacioBliaut_11842 = 11842
const val itemTristansBrstplate_11843 = 11843
const val itemAlcidesHarness_11844 = 11844
const val itemAlcdHarness1_11845 = 11845
const val itemNemusPeti_11846 = 11846
const val itemNemusPeti1_11847 = 11847
const val itemNebulaHpl_11848 = 11848
const val itemNebulaHpl1_11849 = 11849
const val itemFazheluoMail_11850 = 11850
const val itemCuauhtliHarness_11851 = 11851
const val itemHyksosRobe_11852 = 11852
const val itemNovennialCoat_11853 = 11853
const val itemNovennialDress_11854 = 11854
const val itemMextliHarness_11855 = 11855
const val itemAnhurRobe_11856 = 11856
const val itemFazheluoRMail_11857 = 11857
const val itemFazheluoMail1_11858 = 11858
const val itemCuauhHarness1_11859 = 11859
const val itemHyksosRobe1_11860 = 11860
const val itemHikogamiYukata_11861 = 11861
const val itemHimegamiYukata_11862 = 11862
const val itemOcelomehHarness_11863 = 11863
const val itemNeferKalasiris_11864 = 11864
const val itemMekiraToshugai_11865 = 11865
const val itemTocisHarness_11866 = 11866
const val itemHekasKalasiris_11867 = 11867
const val itemMekiraMeikogai_11868 = 11868
const val itemOcelmHarness1_11869 = 11869
const val itemNeferKalasiris1_11870 = 11870
const val itemMekiraToshugai1_11871 = 11871
const val itemAcesMail_11872 = 11872
const val itemHrafnHaubert_11873 = 11873
const val itemTenryuDomaru_11874 = 11874
const val itemKheperJacket_11875 = 11875
const val itemAuspexDoublet_11876 = 11876
const val itemPaeanBliaut_11877 = 11877
const val itemGulesMittens_11878 = 11878
const val itemGulesMittens1_11879 = 11879
const val itemVersaMufflers_11880 = 11880
const val itemVersaMufflers1_11881 = 11881
const val itemLoreCuffs_11882 = 11882
const val itemLoreCuffs1_11883 = 11883
const val itemEradicoMitts_11884 = 11884
const val itemSchellenband_11885 = 11885
const val itemAmpleGloves_11886 = 11886
const val itemBellicusDastanas_11887 = 11887
const val itemBestiaMufflers_11888 = 11888
const val itemParagonMoufles_11889 = 11889
const val itemSkoposBracers_11890 = 11890
const val itemKokugetsuKote_11891 = 11891
const val itemSpryWristbands_11892 = 11892
const val itemMederiGants_11893 = 11893
const val itemLiteraeCuffs_11894 = 11894
const val itemFacioGages_11895 = 11895
const val itemAcesMufflers_11896 = 11896
const val itemSchutzenMittens_11897 = 11897
const val itemWaveGages_11898 = 11898
const val itemWealdGages_11899 = 11899
const val itemSavannaGages_11900 = 11900
const val itemTropicGages_11901 = 11901
const val itemStrandGages_11902 = 11902
const val itemTideGages_11903 = 11903
const val itemThicketGages_11904 = 11904
const val itemBrookGages_11905 = 11905
const val itemWildGages_11906 = 11906
const val itemTorridGages_11907 = 11907
const val itemBruteGauntlets_11908 = 11908
const val itemTriggerGloves_11909 = 11909
const val itemDerobadeMittens_11910 = 11910
const val itemAlcidesMitts_11911 = 11911
const val itemAlcidesMitts1_11912 = 11912
const val itemNemusBazubands_11913 = 11913
const val itemNmsBazubands1_11914 = 11914
const val itemNebulaCuffs_11915 = 11915
const val itemNebulaCuffs1_11916 = 11916
const val itemCarapachoCuffs_11917 = 11917
const val itemKhthoniosGloves_11918 = 11918
const val itemAvestaBangles_11919 = 11919
const val itemMelacoMittens_11920 = 11920
const val itemMagmaGauntlets_11921 = 11921
const val itemPavorGauntlets_11922 = 11922
const val itemTjukurrpaGauntlets_11923 = 11923
const val itemAlucinorMitts_11924 = 11924
const val itemAlrunasGloves_11925 = 11925
const val itemOchain_11926 = 11926
const val itemAegis_11927 = 11927
const val itemGulesSubligar_11928 = 11928
const val itemGulesSubligar1_11929 = 11929
const val itemVersaBreeches_11930 = 11930
const val itemVersaBreeches1_11931 = 11931
const val itemLoreSlops_11932 = 11932
const val itemLoreSlops1_11933 = 11933
const val itemCybelePants_11934 = 11934
const val itemAmbushersHose_11935 = 11935
const val itemBustleDirs_11936 = 11936
const val itemSagacityLappas_11937 = 11937
const val itemBellicusCuisses_11938 = 11938
const val itemBestiaBreeches_11939 = 11939
const val itemParagonBrayettes_11940 = 11940
const val itemSkoposBraccae_11941 = 11941
const val itemKokugetsuHaidate_11942 = 11942
const val itemSpryTights_11943 = 11943
const val itemMederiSlacks_11944 = 11944
const val itemLiteraePants_11945 = 11945
const val itemFacioSpats_11946 = 11946
const val itemNisseSlacks_11947 = 11947
const val itemStanchCuisses_11948 = 11948
const val itemHavenHose_11949 = 11949
const val itemAlcidesSubligar_11950 = 11950
const val itemAlcdSubligar1_11951 = 11951
const val itemNemusSalvars_11952 = 11952
const val itemNemusSalvars1_11953 = 11953
const val itemNebulaSlops_11954 = 11954
const val itemNebulaSlops1_11955 = 11955
const val itemNovennialHose_11956 = 11956
const val itemNovennialBoots_11957 = 11957
const val itemCalmecacTrousers_11958 = 11958
const val itemCalmecacSubligar_11959 = 11959
const val itemJingangHose_11960 = 11960
const val itemMenhitSlacks_11961 = 11961
const val itemGalvanicSlops_11962 = 11962
const val itemAffronterCuisses_11963 = 11963
const val itemWhirlwindDirs_11964 = 11964
const val itemDreamTrousers_11965 = 11965
const val itemDreamTrousers1_11966 = 11966
const val itemDreamPants_11967 = 11967
const val itemDreamPants1_11968 = 11968
const val itemOgiersBreeches_11969 = 11969
const val itemAthossTights_11970 = 11970
const val itemRubeusSpats_11971 = 11971
const val itemPraecoSlacks_11972 = 11972
const val itemHidalgoSlops_11973 = 11973
const val itemAvantCuisses_11974 = 11974
const val itemAvantCuisses1_11975 = 11975
const val itemKacuraSubligar_11976 = 11976
const val itemKacuraSubligar1_11977 = 11977
const val itemSwevenSlacks_11978 = 11978
const val itemSwevenSlacks1_11979 = 11979
const val itemCalmaHose_11980 = 11980
const val itemMustelaBrais_11981 = 11981
const val itemMagavanSlops_11982 = 11982
const val itemTriplusSubligar_11983 = 11983
const val itemInduroCuisses_11984 = 11984
const val itemTussleBreeches_11985 = 11985
const val itemMystagogSlacks_11986 = 11986
const val itemNgenSeraweels_11987 = 11987
const val itemFightersTorque_11988 = 11988
const val itemTempleTorque_11989 = 11989
const val itemHealersTorque_11990 = 11990
const val itemWizardsTorque_11991 = 11991
const val itemWarlocksTorque_11992 = 11992
const val itemRoguesTorque_11993 = 11993
const val itemGallantTorque_11994 = 11994
const val itemChaosTorque_11995 = 11995
const val itemBeastTorque_11996 = 11996
const val itemChoralTorque_11997 = 11997
const val itemHuntersTorque_11998 = 11998
const val itemMyochinShusa_11999 = 11999
const val itemNinjaShusa_12000 = 12000
const val itemDrachenTorque_12001 = 12001
const val itemEvokersTorque_12002 = 12002
const val itemMagusTorque_12003 = 12003
const val itemCorsairsTorque_12004 = 12004
const val itemPuppetryTorque_12005 = 12005
const val itemDancersTorque_12006 = 12006
const val itemScholarsTorque_12007 = 12007
const val itemRavagersMask_12008 = 12008
const val itemTantraCrown_12009 = 12009
const val itemOrisonCap_12010 = 12010
const val itemGoetiaPetasos_12011 = 12011
const val itemEstqChappel_12012 = 12012
const val itemRaidersBonnet_12013 = 12013
const val itemCreedArmet_12014 = 12014
const val itemBaleBurgeonet_12015 = 12015
const val itemFerineCabasset_12016 = 12016
const val itemAoidosCalot_12017 = 12017
const val itemSylvanGapette_12018 = 12018
const val itemUnkaiKabuto_12019 = 12019
const val itemIgaZukin_12020 = 12020
const val itemLancersMezail_12021 = 12021
const val itemCallersHorn_12022 = 12022
const val itemMaviKavuk_12023 = 12023
const val itemNavarchsTricorne_12024 = 12024
const val itemCirqueCappello_12025 = 12025
const val itemCharisTiara_12026 = 12026
const val itemSavantsBonnet_12027 = 12027
const val itemRavagersLorica_12028 = 12028
const val itemTantraCyclas_12029 = 12029
const val itemOrisonBliaut_12030 = 12030
const val itemGoetiaCoat_12031 = 12031
const val itemEstoqueursSayon_12032 = 12032
const val itemRaidersVest_12033 = 12033
const val itemCreedCuirass_12034 = 12034
const val itemBaleCuirass_12035 = 12035
const val itemFerineGausape_12036 = 12036
const val itemAoidosHongreline_12037 = 12037
const val itemSylvanCaban_12038 = 12038
const val itemUnkaiDomaru_12039 = 12039
const val itemIgaNingi_12040 = 12040
const val itemLncrPlackart_12041 = 12041
const val itemCallersDoublet_12042 = 12042
const val itemMaviMintan_12043 = 12043
const val itemNavarchsFrac_12044 = 12044
const val itemCirqueFarsetto_12045 = 12045
const val itemCharisCasaque_12046 = 12046
const val itemSavantsGown_12047 = 12047
const val itemRavagersMufflers_12048 = 12048
const val itemTantraGloves_12049 = 12049
const val itemOrisonMitts_12050 = 12050
const val itemGoetiaGloves_12051 = 12051
const val itemEstqGantherots_12052 = 12052
const val itemRaidersArmlets_12053 = 12053
const val itemCreedGauntlets_12054 = 12054
const val itemBaleGauntlets_12055 = 12055
const val itemFerineManoplas_12056 = 12056
const val itemAoidosMnchtte_12057 = 12057
const val itemSylGlovelettes_12058 = 12058
const val itemUnkaiKote_12059 = 12059
const val itemIgaTekko_12060 = 12060
const val itemLancersVambraces_12061 = 12061
const val itemCallersBracers_12062 = 12062
const val itemMaviBazubands_12063 = 12063
const val itemNavarchsGants_12064 = 12064
const val itemCirqueGuanti_12065 = 12065
const val itemCharisBangles_12066 = 12066
const val itemSavantsBracers_12067 = 12067
const val itemRavagersCuisses_12068 = 12068
const val itemTantraHose_12069 = 12069
const val itemOrisonPantaloons_12070 = 12070
const val itemGoetiaChausses_12071 = 12071
const val itemEstqFuseau_12072 = 12072
const val itemRaidersCulottes_12073 = 12073
const val itemCreedCuisses_12074 = 12074
const val itemBaleFlanchard_12075 = 12075
const val itemFerineQuijotes_12076 = 12076
const val itemAoidosRhingrave_12077 = 12077
const val itemSylvanBragues_12078 = 12078
const val itemUnkaiHaidate_12079 = 12079
const val itemIgaHakama_12080 = 12080
const val itemLancersCuissots_12081 = 12081
const val itemCallersSpats_12082 = 12082
const val itemMaviTayt_12083 = 12083
const val itemNavarchsCulottes_12084 = 12084
const val itemCirquePantaloni_12085 = 12085
const val itemCharisTights_12086 = 12086
const val itemSavantsPants_12087 = 12087
const val itemRavagersCalligae_12088 = 12088
const val itemTantraGaiters_12089 = 12089
const val itemOrisonDuckbills_12090 = 12090
const val itemGoetiaSabots_12091 = 12091
const val itemEstqHouseaux_12092 = 12092
const val itemRaidersPoulaines_12093 = 12093
const val itemCreedSabatons_12094 = 12094
const val itemBaleSollerets_12095 = 12095
const val itemFerineOcreae_12096 = 12096
const val itemAoidosCothurnes_12097 = 12097
const val itemSylvanBottillons_12098 = 12098
const val itemUnkaiSuneAte_12099 = 12099
const val itemIgaKyahan_12100 = 12100
const val itemLncrSchynbalds_12101 = 12101
const val itemCallersPigaches_12102 = 12102
const val itemMaviBasmak_12103 = 12103
const val itemNavarchsBottes_12104 = 12104
const val itemCirqueScarpe_12105 = 12105
const val itemCharisToeShoes_12106 = 12106
const val itemSavantsLoafers_12107 = 12107
const val itemEbonCelata_12108 = 12108
const val itemFuriaCelata_12109 = 12109
const val itemEburCelata_12110 = 12110
const val itemEbonHelm_12111 = 12111
const val itemFuriaHelm_12112 = 12112
const val itemEburHelm_12113 = 12113
const val itemEbonGalea_12114 = 12114
const val itemFuriaGalea_12115 = 12115
const val itemEburGalea_12116 = 12116
const val itemEbonArmet_12117 = 12117
const val itemFuriaArmet_12118 = 12118
const val itemEburArmet_12119 = 12119
const val itemEbonMask_12120 = 12120
const val itemFuriaMask_12121 = 12121
const val itemEburMask_12122 = 12122
const val itemEbonVisor_12123 = 12123
const val itemFuriaVisor_12124 = 12124
const val itemEburVisor_12125 = 12125
const val itemShikkokuHatsuburi_12126 = 12126
const val itemShinkuHatsuburi_12127 = 12127
const val itemGinhakuHatsuburi_12128 = 12128
const val itemEbonHeadgear_12129 = 12129
const val itemFuriaHeadgear_12130 = 12130
const val itemEburHeadgear_12131 = 12131
const val itemEbonTam_12132 = 12132
const val itemFuriaTam_12133 = 12133
const val itemEburTam_12134 = 12134
const val itemEbonHat_12135 = 12135
const val itemFuriaHat_12136 = 12136
const val itemEburHat_12137 = 12137
const val itemEbonCaubeen_12138 = 12138
const val itemFuriaCaubeen_12139 = 12139
const val itemEburCaubeen_12140 = 12140
const val itemEbonBeret_12141 = 12141
const val itemFuriaBeret_12142 = 12142
const val itemEburBeret_12143 = 12143
const val itemEbonCuirass_12144 = 12144
const val itemFuriaCuirass_12145 = 12145
const val itemEburCuirass_12146 = 12146
const val itemEbonMail_12147 = 12147
const val itemFuriaMail_12148 = 12148
const val itemEburMail_12149 = 12149
const val itemEbonHaubert_12150 = 12150
const val itemFuriaHaubert_12151 = 12151
const val itemEburHaubert_12152 = 12152
const val itemEbonBreastplate_12153 = 12153
const val itemFuriaBreastplate_12154 = 12154
const val itemEburBreastplate_12155 = 12155
const val itemEbonHarness_12156 = 12156
const val itemFuriaHarness_12157 = 12157
const val itemEburHarness_12158 = 12158
const val itemEbonJerkin_12159 = 12159
const val itemFuriaJerkin_12160 = 12160
const val itemEburJerkin_12161 = 12161
const val itemShikkokuTogi_12162 = 12162
const val itemShinkuTogi_12163 = 12163
const val itemGinhakuTogi_12164 = 12164
const val itemEbonVest_12165 = 12165
const val itemFuriaVest_12166 = 12166
const val itemEburVest_12167 = 12167
const val itemEbonTalar_12168 = 12168
const val itemFuriaTalar_12169 = 12169
const val itemEburTalar_12170 = 12170
const val itemEbonCoat_12171 = 12171
const val itemFuriaCoat_12172 = 12172
const val itemEburCoat_12173 = 12173
const val itemEbonBliaut_12174 = 12174
const val itemFuriaBliaut_12175 = 12175
const val itemEburBliaut_12176 = 12176
const val itemEbonFrock_12177 = 12177
const val itemFuriaFrock_12178 = 12178
const val itemEburFrock_12179 = 12179
const val itemEbonDastanas_12180 = 12180
const val itemFuriaDastanas_12181 = 12181
const val itemEburDastanas_12182 = 12182
const val itemEbonMufflers_12183 = 12183
const val itemFuriaMufflers_12184 = 12184
const val itemEburMufflers_12185 = 12185
const val itemEbonMoufles_12186 = 12186
const val itemFuriaMoufles_12187 = 12187
const val itemEburMoufles_12188 = 12188
const val itemEbonGauntlets_12189 = 12189
const val itemFuriaGauntlets_12190 = 12190
const val itemEburGauntlets_12191 = 12191
const val itemEbonGloves_12192 = 12192
const val itemFuriaGloves_12193 = 12193
const val itemEburGloves_12194 = 12194
const val itemEbonBracers_12195 = 12195
const val itemFuriaBracers_12196 = 12196
const val itemEburBracers_12197 = 12197
const val itemShikkokuKote_12198 = 12198
const val itemShinkuKote_12199 = 12199
const val itemGinhakuKote_12200 = 12200
const val itemEbonWristbands_12201 = 12201
const val itemFuriaWristbands_12202 = 12202
const val itemEburWristbands_12203 = 12203
const val itemEbonGants_12204 = 12204
const val itemFuriaGants_12205 = 12205
const val itemEburGants_12206 = 12206
const val itemEbonCuffs_12207 = 12207
const val itemFuriaCuffs_12208 = 12208
const val itemEburCuffs_12209 = 12209
const val itemEbonGages_12210 = 12210
const val itemFuriaGages_12211 = 12211
const val itemEburGages_12212 = 12212
const val itemEbonMitts_12213 = 12213
const val itemFuriaMitts_12214 = 12214
const val itemEburMitts_12215 = 12215
const val itemEbonCuisses_12216 = 12216
const val itemFuriaCuisses_12217 = 12217
const val itemEburCuisses_12218 = 12218
const val itemEbonBreeches_12219 = 12219
const val itemFuriaBreeches_12220 = 12220
const val itemEburBreeches_12221 = 12221
const val itemEbonBrayettes_12222 = 12222
const val itemFuriaBrayettes_12223 = 12223
const val itemEburBrayettes_12224 = 12224
const val itemEbonHose_12225 = 12225
const val itemFuriaHose_12226 = 12226
const val itemEburHose_12227 = 12227
const val itemEbonBrais_12228 = 12228
const val itemFuriaBrais_12229 = 12229
const val itemEburBrais_12230 = 12230
const val itemEbonBraccae_12231 = 12231
const val itemFuriaBraccae_12232 = 12232
const val itemEburBraccae_12233 = 12233
const val itemShikkokuHaidate_12234 = 12234
const val itemShinkuHaidate_12235 = 12235
const val itemGinhakuHaidate_12236 = 12236
const val itemEbonTights_12237 = 12237
const val itemFuriaTights_12238 = 12238
const val itemEburTights_12239 = 12239
const val itemEbonSlacks_12240 = 12240
const val itemFuriaSlacks_12241 = 12241
const val itemEburSlacks_12242 = 12242
const val itemEbonPants_12243 = 12243
const val itemFuriaPants_12244 = 12244
const val itemEburPants_12245 = 12245
const val itemEbonSpats_12246 = 12246
const val itemFuriaSpats_12247 = 12247
const val itemEburSpats_12248 = 12248
const val itemEbonSlops_12249 = 12249
const val itemFuriaSlops_12250 = 12250
const val itemEburSlops_12251 = 12251
const val itemEbonSabatons_12252 = 12252
const val itemFuriaSabatons_12253 = 12253
const val itemEburSabatons_12254 = 12254
const val itemEbonGreaves_12255 = 12255
const val itemFuriaGreaves_12256 = 12256
const val itemEburGreaves_12257 = 12257
const val itemEbonSollerets_12258 = 12258
const val itemFuriaSollerets_12259 = 12259
const val itemEburSollerets_12260 = 12260
const val itemEbonLeggings_12261 = 12261
const val itemFuriaLeggings_12262 = 12262
const val itemEburLeggings_12263 = 12263
const val itemEbonBoots_12264 = 12264
const val itemFuriaBoots_12265 = 12265
const val itemEburBoots_12266 = 12266
const val itemEbonSocks_12267 = 12267
const val itemFuriaSocks_12268 = 12268
const val itemEburSocks_12269 = 12269
const val itemShikkokuSuneAte_12270 = 12270
const val itemShinkuSuneAte_12271 = 12271
const val itemGinhakuSuneAte_12272 = 12272
const val itemEbonGaiters_12273 = 12273
const val itemFuriaGaiters_12274 = 12274
const val itemEburGaiters_12275 = 12275
const val itemEbonBrogues_12276 = 12276
const val itemFuriaBrogues_12277 = 12277
const val itemEburBrogues_12278 = 12278
const val itemEbonSabots_12279 = 12279
const val itemFuriaSabots_12280 = 12280
const val itemEburSabots_12281 = 12281
const val itemEbonGaloshes_12282 = 12282
const val itemFuriaGaloshes_12283 = 12283
const val itemEburGaloshes_12284 = 12284
const val itemEbonClogs_12285 = 12285
const val itemFuriaClogs_12286 = 12286
const val itemEburClogs_12287 = 12287
const val itemLauanShield_12289 = 12289
const val itemMapleShield_12290 = 12290
const val itemElmShield_12291 = 12291
const val itemMahoganyShield_12292 = 12292
const val itemOakShield_12293 = 12293
const val itemLeatherShield_12294 = 12294
const val itemRoundShield_12295 = 12295
const val itemGenbusShield_12296 = 12296
const val itemParanaShield_12298 = 12298
const val itemAspis_12299 = 12299
const val itemTarge_12300 = 12300
const val itemBuckler_12301 = 12301
const val itemDarksteelBuckler_12302 = 12302
const val itemGoldBuckler_12303 = 12303
const val itemMskCmdShield_12304 = 12304
const val itemIceShield_12305 = 12305
const val itemKiteShield_12306 = 12306
const val itemHeaterShield_12307 = 12307
const val itemDarksteelShield_12308 = 12308
const val itemRitterShield_12309 = 12309
const val itemDiamondShield_12310 = 12310
const val itemHoplon_12311 = 12311
const val itemRKArmyShield_12312 = 12312
const val itemTKArmyShield_12313 = 12313
const val itemFishScaleShield_12316 = 12316
const val itemFlameShield_12317 = 12317
const val itemArgosShield_12318 = 12318
const val itemElmShield1_12319 = 12319
const val itemSeigneurShield_12320 = 12320
const val itemRylGrdShield_12321 = 12321
const val itemScutum_12323 = 12323
const val itemTowerShield_12324 = 12324
const val itemAspis1_12325 = 12325
const val itemKiteShield1_12326 = 12326
const val itemBuckler1_12327 = 12327
const val itemHeaterShield1_12328 = 12328
const val itemLeatherShield1_12329 = 12329
const val itemMapleShield1_12330 = 12330
const val itemOakShield1_12331 = 12331
const val itemJudgesShield_12332 = 12332
const val itemLauanShield1_12333 = 12333
const val itemStrongShield_12334 = 12334
const val itemTarge1_12335 = 12335
const val itemRylSqrShield_12336 = 12336
const val itemDecurionsShield_12337 = 12337
const val itemFrostShield_12338 = 12338
const val itemScutum1_12339 = 12339
const val itemMarineShield_12340 = 12340
const val itemTropicalShield_12341 = 12341
const val itemLanternShield_12342 = 12342
const val itemFaerieShield_12343 = 12343
const val itemMasterShield_12344 = 12344
const val itemBloodbeadEcu_12345 = 12345
const val itemDstShield1_12346 = 12346
const val itemSpikedBuckler_12347 = 12347
const val itemSerketShield_12348 = 12348
const val itemBalanceBuckler_12349 = 12349
const val itemStrikeShield_12350 = 12350
const val itemAstralShield_12351 = 12351
const val itemRoundShield1_12352 = 12352
const val itemGiltBuckler_12353 = 12353
const val itemTowerShield1_12354 = 12354
const val itemDiamondShield1_12355 = 12355
const val itemVikingShield_12356 = 12356
const val itemIceShield1_12357 = 12357
const val itemRitterShield1_12358 = 12358
const val itemHickoryShield_12359 = 12359
const val itemTatamiShield_12360 = 12360
const val itemSipar_12361 = 12361
const val itemHighlandersTarge_12362 = 12362
const val itemPtrPrtShield_12363 = 12363
const val itemNymphShield_12364 = 12364
const val itemNymphShield1_12365 = 12365
const val itemRylSqrShield1_12366 = 12366
const val itemRylSqrShield2_12367 = 12367
const val itemRKShield1_12368 = 12368
const val itemRKShield2_12369 = 12369
const val itemPicaroonsShield_12370 = 12370
const val itemClipeus_12371 = 12371
const val itemBastokanTarge_12372 = 12372
const val itemRepublicTarge_12373 = 12373
const val itemTortoiseShield_12374 = 12374
const val itemLightBuckler_12375 = 12375
const val itemTKShield1_12376 = 12376
const val itemTKShield2_12377 = 12377
const val itemHardShield_12378 = 12378
const val itemHolyShield_12379 = 12379
const val itemDivineShield_12380 = 12380
const val itemChargingShield_12381 = 12381
const val itemAstralAspis_12382 = 12382
const val itemGeneralsShield_12383 = 12383
const val itemAdmiralsShield_12384 = 12384
const val itemAcheronShield_12385 = 12385
const val itemAcheronShield1_12386 = 12386
const val itemKoenigShield_12387 = 12387
const val itemKaiserShield_12388 = 12388
const val itemMercenarysTarge_12389 = 12389
const val itemWrestlersAspis_12390 = 12390
const val itemHealersShield_12391 = 12391
const val itemWizardsShield_12392 = 12392
const val itemWarlocksShield_12393 = 12393
const val itemPilferersAspis_12394 = 12394
const val itemVarletsTarge_12395 = 12395
const val itemKillerTarge_12396 = 12396
const val itemTrimmersAspis_12397 = 12397
const val itemSingersShield_12398 = 12398
const val itemBeatersAspis_12399 = 12399
const val itemAshigaruTarge_12400 = 12400
const val itemGeninAspis_12401 = 12401
const val itemWyvernTarge_12402 = 12402
const val itemMagiciansShield_12403 = 12403
const val itemElegantShield_12404 = 12404
const val itemJennetShield_12405 = 12405
const val itemCoatedShield_12406 = 12406
const val itemPalmerinsShield_12407 = 12407
const val itemAbsorbingShield_12408 = 12408
const val itemNuminousShield_12409 = 12409
const val itemNmsShield1_12410 = 12410
const val itemDominusShield_12411 = 12411
const val itemHoplon1_12412 = 12412
const val itemTurtleShield1_12413 = 12413
const val itemTurtleShield_12414 = 12414
const val itemShellShield_12415 = 12415
const val itemSallet_12416 = 12416
const val itemMythrilSallet_12417 = 12417
const val itemGoldArmet_12418 = 12418
const val itemDarksteelArmet_12419 = 12419
const val itemAdamanBarbuta_12420 = 12420
const val itemKoenigSchaller_12421 = 12421
const val itemIrnMskArmet_12422 = 12422
const val itemDstArmet1_12423 = 12423
const val itemIronMask_12424 = 12424
const val itemSilverMask_12425 = 12425
const val itemBandedHelm_12426 = 12426
const val itemBascinet_12427 = 12427
const val itemCelata_12428 = 12428
const val itemAdamanCelata_12429 = 12429
const val itemRylKgtBascinet_12430 = 12430
const val itemRylSquiresHelm_12431 = 12431
const val itemFaceguard_12432 = 12432
const val itemBrassMask_12433 = 12433
const val itemGenbusKabuto_12434 = 12434
const val itemCoralVisor_12435 = 12435
const val itemDragonMask_12436 = 12436
const val itemGavialMask_12437 = 12437
const val itemCenturionsVisor_12438 = 12438
const val itemBascinet1_12439 = 12439
const val itemLeatherBandana_12440 = 12440
const val itemLizardHelm_12441 = 12441
const val itemStuddedBandana_12442 = 12442
const val itemCuirBandana_12443 = 12443
const val itemRaptorHelm_12444 = 12444
const val itemDuskMask_12445 = 12445
const val itemTigerHelm_12446 = 12446
const val itemCoeurlMask_12447 = 12447
const val itemBronzeCap_12448 = 12448
const val itemBrassCap_12449 = 12449
const val itemPaddedCap_12450 = 12450
const val itemScorpionMask_12451 = 12451
const val itemDarksteelCap_12452 = 12452
const val itemCoralCap_12453 = 12453
const val itemBoneMask_12454 = 12454
const val itemBeetleMask_12455 = 12455
const val itemHachimaki_12456 = 12456
const val itemCottonHachimaki_12457 = 12457
const val itemSoilHachimaki_12458 = 12458
const val itemZunariKabuto_12459 = 12459
const val itemShinobiHachigane_12460 = 12460
const val itemScorpionHelm1_12461 = 12461
const val itemToraHachimaki_12462 = 12462
const val itemBronzeCap1_12463 = 12463
const val itemHeadgear_12464 = 12464
const val itemCottonHeadgear_12465 = 12465
const val itemRedCap_12466 = 12466
const val itemWoolCap_12467 = 12467
const val itemGreenBeret_12468 = 12468
const val itemWarBeret_12469 = 12469
const val itemMrcCptHeadgear_12470 = 12470
const val itemHeadgear1_12471 = 12471
const val itemCirclet_12472 = 12472
const val itemPoetsCirclet_12473 = 12473
const val itemWoolHat_12474 = 12474
const val itemVelvetHat_12475 = 12475
const val itemSilkHat_12476 = 12476
const val itemNoblesCrown_12477 = 12477
const val itemTctMgcHat_12478 = 12478
const val itemWoolHat1_12479 = 12479
const val itemLizardHelm1_12480 = 12480
const val itemCuirBandana1_12481 = 12481
const val itemScorpionMask1_12482 = 12482
const val itemAristocratsCrown_12483 = 12483
const val itemMrcHachimaki_12484 = 12484
const val itemFungusHat_12485 = 12485
const val itemEmperorHairpin_12486 = 12486
const val itemFaceguard1_12487 = 12487
const val itemOstCerveliere_12488 = 12488
const val itemPixieHairpin_12489 = 12489
const val itemYashaJinpachi_12490 = 12490
const val itemOnionCap_12491 = 12491
const val itemFugacityBeret_12492 = 12492
const val itemAccordHat_12493 = 12493
const val itemGoldHairpin_12494 = 12494
const val itemSilverHairpin_12495 = 12495
const val itemCopperHairpin_12496 = 12496
const val itemBrassHairpin_12497 = 12497
const val itemCottonHeadband_12498 = 12498
const val itemFlaxHeadband_12499 = 12499
const val itemTravelersHat_12500 = 12500
const val itemMonksHeadgear_12501 = 12501
const val itemCmpEyeCirclet_12502 = 12502
const val itemSilkHeadband_12503 = 12503
const val itemRainbowHeadband_12504 = 12504
const val itemBoneHairpin_12505 = 12505
const val itemShellHairpin_12506 = 12506
const val itemHornHairpin_12507 = 12507
const val itemCoralHairpin_12508 = 12508
const val itemLegionnairesCap_12509 = 12509
const val itemRylFtmBandana_12510 = 12510
const val itemFightersMask_12511 = 12511
const val itemTempleCrown_12512 = 12512
const val itemWarlocksChapeau_12513 = 12513
const val itemRoguesBonnet_12514 = 12514
const val itemGallantCoronet_12515 = 12515
const val itemChaosBurgeonet_12516 = 12516
const val itemBeastHelm_12517 = 12517
const val itemHuntersBeret_12518 = 12518
const val itemDrachenArmet_12519 = 12519
const val itemEvokersHorn_12520 = 12520
const val itemBlueRibbon_12521 = 12521
const val itemRustyCap_12522 = 12522
const val itemJudgesHelm_12523 = 12523
const val itemIronMask1_12524 = 12524
const val itemStrongCap_12525 = 12525
const val itemCopperHairpin1_12526 = 12526
const val itemCirclet1_12527 = 12527
const val itemBrassCap1_12528 = 12528
const val itemBrassHairpin1_12529 = 12529
const val itemSagesCirclet_12530 = 12530
const val itemSilverHairpin1_12531 = 12531
const val itemBrassMask1_12532 = 12532
const val itemSilverMask1_12533 = 12533
const val itemHachimaki1_12534 = 12534
const val itemGreatHeadgear_12535 = 12535
const val itemErdHeadband_12536 = 12536
const val itemCtnHachimaki1_12537 = 12537
const val itemRedCap1_12538 = 12538
const val itemSoilHachimaki1_12539 = 12539
const val itemAlluringHeadband_12540 = 12540
const val itemWoolCap1_12541 = 12541
const val itemLthBandana1_12542 = 12542
const val itemWindshearHat_12543 = 12543
const val itemBreastplate_12544 = 12544
const val itemMtlBreastplate_12545 = 12545
const val itemGoldCuirass_12546 = 12546
const val itemDarksteelCuirass_12547 = 12547
const val itemAdamanCuirass_12548 = 12548
const val itemKoenigCuirass_12549 = 12549
const val itemIrnMskCuirass_12550 = 12550
const val itemJudgesCuirass_12551 = 12551
const val itemChainmail_12552 = 12552
const val itemSilverMail_12553 = 12553
const val itemBandedMail_12554 = 12554
const val itemHaubergeon_12555 = 12555
const val itemHauberk_12556 = 12556
const val itemAdamanHauberk_12557 = 12557
const val itemRylKgtChainmail_12558 = 12558
const val itemRylSqrChainmail_12559 = 12559
const val itemScaleMail_12560 = 12560
const val itemBrassScaleMail_12561 = 12561
const val itemKirinsOsode_12562 = 12562
const val itemCoralScaleMail_12563 = 12563
const val itemDragonMail_12564 = 12564
const val itemGavialMail_12565 = 12565
const val itemCtrScaleMail_12566 = 12566
const val itemSteamScaleMail_12567 = 12567
const val itemLeatherVest_12568 = 12568
const val itemLizardJerkin_12569 = 12569
const val itemStuddedVest_12570 = 12570
const val itemCuirBouilli_12571 = 12571
const val itemRaptorJerkin_12572 = 12572
const val itemDuskJerkin_12573 = 12573
const val itemTigerJerkin_12574 = 12574
const val itemCoeurlJerkin_12575 = 12575
const val itemBronzeHarness_12576 = 12576
const val itemBrassHarness_12577 = 12577
const val itemPaddedArmor_12578 = 12578
const val itemScorpionHarness_12579 = 12579
const val itemDarksteelHarness_12580 = 12580
const val itemCoralHarness_12581 = 12581
const val itemBoneHarness_12582 = 12582
const val itemBeetleHarness_12583 = 12583
const val itemKenpogi_12584 = 12584
const val itemCottonDogi_12585 = 12585
const val itemSoilGi_12586 = 12586
const val itemHaraAte_12587 = 12587
const val itemShinobiGi_12588 = 12588
const val itemScpBrstplate1_12589 = 12589
const val itemPowerGi_12590 = 12590
const val itemDoublet1_12591 = 12591
const val itemDoublet_12592 = 12592
const val itemCottonDoublet_12593 = 12593
const val itemGambison_12594 = 12594
const val itemWoolGambison_12595 = 12595
const val itemBattleJupon_12596 = 12596
const val itemWarAketon_12597 = 12597
const val itemMrcCptDoublet_12598 = 12598
const val itemLeatherVest1_12599 = 12599
const val itemRobe_12600 = 12600
const val itemLinenRobe_12601 = 12601
const val itemWoolRobe_12602 = 12602
const val itemVelvetRobe_12603 = 12603
const val itemSilkCoat_12604 = 12604
const val itemNoblesTunic_12605 = 12605
const val itemTctMgcCoat_12606 = 12606
const val itemBronzeHarness1_12607 = 12607
const val itemTunic_12608 = 12608
const val itemBlackTunic_12609 = 12609
const val itemCloak_12610 = 12610
const val itemWhiteCloak_12611 = 12611
const val itemSilkCloak_12612 = 12612
const val itemJurfuCloak_12613 = 12613
const val itemCmbCstCloak_12614 = 12614
const val itemRobe1_12615 = 12615
const val itemTunic1_12616 = 12616
const val itemWarShinobiGi_12617 = 12617
const val itemYashaSamue_12618 = 12618
const val itemOnionHarness_12619 = 12619
const val itemGrimCuirass1_12620 = 12620
const val itemScpBreastplate_12621 = 12621
const val itemJuogi1_12622 = 12622
const val itemYhelJacket1_12623 = 12623
const val itemCottonDogi1_12624 = 12624
const val itemGambison1_12625 = 12625
const val itemLinenRobe1_12626 = 12626
const val itemWoolRobe1_12627 = 12627
const val itemBattleJupon1_12628 = 12628
const val itemLgnHarness_12629 = 12629
const val itemRylFtmVest_12630 = 12630
const val itemHumeTunic_12631 = 12631
const val itemHumeVest_12632 = 12632
const val itemElvaanJerkin_12633 = 12633
const val itemElvaanBodice_12634 = 12634
const val itemTarutaruKaftan_12635 = 12635
const val itemMithranSeparates_12636 = 12636
const val itemGalkanSurcoat_12637 = 12637
const val itemFightersLorica_12638 = 12638
const val itemTempleCyclas_12639 = 12639
const val itemHealersBliaut_12640 = 12640
const val itemWizardsCoat_12641 = 12641
const val itemWarlocksTabard_12642 = 12642
const val itemRoguesVest_12643 = 12643
const val itemGallantSurcoat_12644 = 12644
const val itemChaosCuirass_12645 = 12645
const val itemBeastJackcoat_12646 = 12646
const val itemChoralJstcorps_12647 = 12647
const val itemHuntersJerkin_12648 = 12648
const val itemDrachenMail_12649 = 12649
const val itemEvokersDoublet_12650 = 12650
const val itemWhiteCloak1_12651 = 12651
const val itemSilkCoat1_12652 = 12652
const val itemMercenarysGi_12653 = 12653
const val itemCustomTunic_12654 = 12654
const val itemCustomVest_12655 = 12655
const val itemMagnaJerkin_12656 = 12656
const val itemMagnaBodice_12657 = 12657
const val itemWonderKaftan_12658 = 12658
const val itemSavageSeparates_12659 = 12659
const val itemEldersSurcoat_12660 = 12660
const val itemSolidMail_12661 = 12661
const val itemChainmail1_12662 = 12662
const val itemStrongHarness_12663 = 12663
const val itemBrassHarness1_12664 = 12664
const val itemBrsScaleMail1_12665 = 12665
const val itemSilverMail1_12666 = 12666
const val itemBandedMail1_12667 = 12667
const val itemKenpogi1_12668 = 12668
const val itemGreatDoublet_12669 = 12669
const val itemCloak1_12670 = 12670
const val itemSoilGi1_12671 = 12671
const val itemGauntlets_12672 = 12672
const val itemMythrilGauntlets_12673 = 12673
const val itemGoldGauntlets_12674 = 12674
const val itemDstGauntlets_12675 = 12675
const val itemAdamanGauntlets_12676 = 12676
const val itemKngHandschuhs_12677 = 12677
const val itemIrnMskGauntlets_12678 = 12678
const val itemJudgesGauntlets_12679 = 12679
const val itemChainMittens_12680 = 12680
const val itemSilverMittens_12681 = 12681
const val itemMufflers_12682 = 12682
const val itemDarksteelMufflers_12683 = 12683
const val itemThickMufflers_12684 = 12684
const val itemAdamanMufflers_12685 = 12685
const val itemRylKgtMufflers_12686 = 12686
const val itemRylSqrMufflers_12687 = 12687
const val itemScaleFngGnt_12688 = 12688
const val itemBrassFngGnt_12689 = 12689
const val itemSeiryusKote_12690 = 12690
const val itemCoralFngGnt_12691 = 12691
const val itemDragonFngGnt_12692 = 12692
const val itemGavialFngGnt_12693 = 12693
const val itemCtrFGauntlets_12694 = 12694
const val itemBronzeMittens1_12695 = 12695
const val itemLeatherGloves_12696 = 12696
const val itemLizardGloves_12697 = 12697
const val itemStuddedGloves_12698 = 12698
const val itemCuirGloves_12699 = 12699
const val itemRaptorGloves_12700 = 12700
const val itemDuskGloves_12701 = 12701
const val itemTigerGloves_12702 = 12702
const val itemCoeurlGloves_12703 = 12703
const val itemBronzeMittens_12704 = 12704
const val itemBrassMittens_12705 = 12705
const val itemIronMittens_12706 = 12706
const val itemScorpionMittens_12707 = 12707
const val itemDarksteelMittens_12708 = 12708
const val itemCoralMittens_12709 = 12709
const val itemBoneMittens_12710 = 12710
const val itemBeetleMittens_12711 = 12711
const val itemTekko_12712 = 12712
const val itemCottonTekko_12713 = 12713
const val itemSoilTekko_12714 = 12714
const val itemKote_12715 = 12715
const val itemShinobiTekko_12716 = 12716
const val itemScpGnt1_12717 = 12717
const val itemIronMittens1_12718 = 12718
const val itemMrcTekko_12719 = 12719
const val itemGloves_12720 = 12720
const val itemCottonGloves_12721 = 12721
const val itemBracers_12722 = 12722
const val itemWoolBracers_12723 = 12723
const val itemBattleBracers_12724 = 12724
const val itemWarGloves_12725 = 12725
const val itemMrcCptGloves_12726 = 12726
const val itemEngineersGloves_12727 = 12727
const val itemCuffs_12728 = 12728
const val itemLinenCuffs_12729 = 12729
const val itemWoolCuffs_12730 = 12730
const val itemVelvetCuffs_12731 = 12731
const val itemSilkCuffs_12732 = 12732
const val itemNoblesMitts_12733 = 12733
const val itemTctMgcCuffs_12734 = 12734
const val itemMitts_12736 = 12736
const val itemWhiteMitts_12737 = 12737
const val itemLinenMitts_12738 = 12738
const val itemBlackMitts_12739 = 12739
const val itemSilkMitts_12740 = 12740
const val itemLudicMitts_12741 = 12741
const val itemRuneBangles_12742 = 12742
const val itemCmbCstMitts_12743 = 12743
const val itemCuffs1_12744 = 12744
const val itemPerleMoufles_12745 = 12745
const val itemAuroreGloves_12746 = 12746
const val itemTealCuffs_12747 = 12747
const val itemThiefsKote_12748 = 12748
const val itemScentlessArmlets_12749 = 12749
const val itemNewMoonArmlets_12750 = 12750
const val itemScpGauntlets_12751 = 12751
const val itemLgnMittens_12752 = 12752
const val itemRylFtmGloves_12753 = 12753
const val itemHumeMGloves_12754 = 12754
const val itemElvaanGloves_12755 = 12755
const val itemTarutaruMitts_12756 = 12756
const val itemMithranGauntlets_12757 = 12757
const val itemGalkanBracers_12758 = 12758
const val itemElvaanGauntlets_12759 = 12759
const val itemHumeFGloves_12760 = 12760
const val itemCustomMGloves_12761 = 12761
const val itemCustomFGloves_12762 = 12762
const val itemMagnaGauntlets_12763 = 12763
const val itemMagnaGloves_12764 = 12764
const val itemWonderMitts_12765 = 12765
const val itemSavageGauntlets_12766 = 12766
const val itemEldersBracers_12767 = 12767
const val itemSolidFngGnt_12768 = 12768
const val itemChainMittens1_12769 = 12769
const val itemBrassMittens1_12770 = 12770
const val itemBrassFngGnt1_12771 = 12771
const val itemSilverMittens1_12772 = 12772
const val itemGloves1_12773 = 12773
const val itemTekko1_12774 = 12774
const val itemMitts1_12775 = 12775
const val itemGreatGloves_12776 = 12776
const val itemCottonTekko1_12777 = 12777
const val itemLinenCuffs1_12778 = 12778
const val itemBracers1_12779 = 12779
const val itemLinenMitts1_12780 = 12780
const val itemSoilTekko1_12781 = 12781
const val itemWoolCuffs1_12782 = 12782
const val itemWoolBracers1_12783 = 12783
const val itemLeatherGloves1_12784 = 12784
const val itemFineGloves_12785 = 12785
const val itemStrongGloves_12786 = 12786
const val itemCuirGloves1_12787 = 12787
const val itemBoneMittens1_12788 = 12788
const val itemBeetleMittens1_12789 = 12789
const val itemCpcMittens1_12790 = 12790
const val itemGauntlets1_12791 = 12791
const val itemMufflers1_12792 = 12792
const val itemMagesCuffs_12793 = 12793
const val itemMagesMitts_12794 = 12794
const val itemDinoGloves_12795 = 12795
const val itemAsbestosMitts_12796 = 12796
const val itemCoarseGauntlets_12797 = 12797
const val itemZealotsMitts_12798 = 12798
const val itemBattleGloves_12799 = 12799
const val itemCuisses_12800 = 12800
const val itemMythrilCuisses_12801 = 12801
const val itemGoldCuisses_12802 = 12802
const val itemDarksteelCuisses_12803 = 12803
const val itemAdamanCuisses_12804 = 12804
const val itemKoenigDiechlings_12805 = 12805
const val itemIrnMskCuisses_12806 = 12806
const val itemJudgesCuisses_12807 = 12807
const val itemChainHose_12808 = 12808
const val itemSilverHose_12809 = 12809
const val itemBreeches_12810 = 12810
const val itemDstBreeches_12811 = 12811
const val itemThickBreeches_12812 = 12812
const val itemAdamanBreeches_12813 = 12813
const val itemRylKgtBreeches_12814 = 12814
const val itemRylSqrBreeches_12815 = 12815
const val itemScaleCuisses_12816 = 12816
const val itemBrassCuisses_12817 = 12817
const val itemByakkosHaidate_12818 = 12818
const val itemCoralCuisses_12819 = 12819
const val itemDragonCuisses_12820 = 12820
const val itemGavialCuisses_12821 = 12821
const val itemCtrCuisses_12822 = 12822
const val itemBrzSubligar1_12823 = 12823
const val itemLeatherTrousers_12824 = 12824
const val itemLizardTrousers_12825 = 12825
const val itemStuddedTrousers_12826 = 12826
const val itemCuirTrousers_12827 = 12827
const val itemRaptorTrousers_12828 = 12828
const val itemBeakTrousers_12829 = 12829
const val itemTigerTrousers_12830 = 12830
const val itemCoeurlTrousers_12831 = 12831
const val itemBronzeSubligar_12832 = 12832
const val itemBrassSubligar_12833 = 12833
const val itemBoneSubligar_12834 = 12834
const val itemBeetleSubligar_12835 = 12835
const val itemIronSubligar_12836 = 12836
const val itemCarapaceSubligar_12837 = 12837
const val itemScorpionSubligar_12838 = 12838
const val itemDarksteelSubligar_12839 = 12839
const val itemSitabaki_12840 = 12840
const val itemCottonSitabaki_12841 = 12841
const val itemSoilSitabaki_12842 = 12842
const val itemHaidate_12843 = 12843
const val itemShinobiHakama_12844 = 12844
const val itemWukongsHakama_12846 = 12846
const val itemYashaHakama_12847 = 12847
const val itemBrais_12848 = 12848
const val itemCottonBrais_12849 = 12849
const val itemHose_12850 = 12850
const val itemWoolHose_12851 = 12851
const val itemBattleHose_12852 = 12852
const val itemWarBrais_12853 = 12853
const val itemMrcCptHose_12854 = 12854
const val itemMrcSitabaki_12855 = 12855
const val itemSlops_12856 = 12856
const val itemLinenSlops_12857 = 12857
const val itemWoolSlops_12858 = 12858
const val itemVelvetSlops_12859 = 12859
const val itemSilkSlops_12860 = 12860
const val itemNoblesSlacks_12861 = 12861
const val itemTctMgcSlops_12862 = 12862
const val itemSolidCuisses_12863 = 12863
const val itemSlacks_12864 = 12864
const val itemBlackSlacks_12865 = 12865
const val itemLinenSlacks_12866 = 12866
const val itemWhiteSlacks_12867 = 12867
const val itemSilkSlacks_12868 = 12868
const val itemCmbCstSlacks_12870 = 12870
const val itemCustomSlacks_12871 = 12871
const val itemCustomPants_12872 = 12872
const val itemMagnaMChausses_12873 = 12873
const val itemMagnaFChausses_12874 = 12874
const val itemWonderBraccae_12875 = 12875
const val itemSavageLoincloth_12876 = 12876
const val itemEldersBraguette_12877 = 12877
const val itemCoralSubligar_12878 = 12878
const val itemDuskTrousers_12879 = 12879
const val itemOgreTrousers_12880 = 12880
const val itemLgnSubligar_12881 = 12881
const val itemRylFtmTrousers_12882 = 12882
const val itemHumeSlacks_12883 = 12883
const val itemHumePants_12884 = 12884
const val itemElvMChausses_12885 = 12885
const val itemTarutaruBraccae_12886 = 12886
const val itemMithranLoincloth_12887 = 12887
const val itemGalkanBraguette_12888 = 12888
const val itemElvaanFChausses_12889 = 12889
const val itemChainHose1_12890 = 12890
const val itemIronSubligar1_12891 = 12891
const val itemBrassSubligar1_12892 = 12892
const val itemBrassCuisses1_12893 = 12893
const val itemSilverHose1_12894 = 12894
const val itemBreeches1_12895 = 12895
const val itemBrais1_12896 = 12896
const val itemSlops1_12897 = 12897
const val itemSlacks1_12898 = 12898
const val itemSitabaki1_12899 = 12899
const val itemGreatBrais_12900 = 12900
const val itemLinenSlops1_12901 = 12901
const val itemCtnSitabaki1_12902 = 12902
const val itemHose1_12903 = 12903
const val itemLinenSlacks1_12904 = 12904
const val itemSoilSitabaki1_12905 = 12905
const val itemWoolSlops1_12906 = 12906
const val itemWoolHose1_12907 = 12907
const val itemLthTrousers1_12908 = 12908
const val itemFineTrousers_12909 = 12909
const val itemStrongTrousers_12910 = 12910
const val itemCuirTrousers1_12911 = 12911
const val itemBoneSubligar1_12912 = 12912
const val itemBeetleSubligar1_12913 = 12913
const val itemCpcSubligar1_12914 = 12914
const val itemFreeswordsSlops_12915 = 12915
const val itemCuisses1_12916 = 12916
const val itemMagesSlacks_12917 = 12917
const val itemMagesSlops_12918 = 12918
const val itemDinoTrousers_12919 = 12919
const val itemMatreBragezenn_12920 = 12920
const val itemAcesHose_12921 = 12921
const val itemMartialSlacks_12922 = 12922
const val itemJujitsuSitabaki_12923 = 12923
const val itemMagicCuisses_12924 = 12924
const val itemShnHakama1_12925 = 12925
const val itemWhiteSlacks1_12926 = 12926
const val itemSilkSlops1_12927 = 12927
const val itemPlateLeggings_12928 = 12928
const val itemMythrilLeggings_12929 = 12929
const val itemGoldSabatons_12930 = 12930
const val itemDstSabatons_12931 = 12931
const val itemAdamanSabatons_12932 = 12932
const val itemKoenigSchuhs_12933 = 12933
const val itemIrnMskSabatons_12934 = 12934
const val itemJudgesGreaves_12935 = 12935
const val itemGreaves_12936 = 12936
const val itemSilverGreaves_12937 = 12937
const val itemSollerets_12938 = 12938
const val itemDstSollerets_12939 = 12939
const val itemThickSollerets_12940 = 12940
const val itemAdamanSollerets_12941 = 12941
const val itemRylKgtSollerets_12942 = 12942
const val itemRylSqrSollerets_12943 = 12943
const val itemScaleGreaves_12944 = 12944
const val itemBrassGreaves_12945 = 12945
const val itemSuzakusSuneAte_12946 = 12946
const val itemCoralGreaves_12947 = 12947
const val itemDragonGreaves_12948 = 12948
const val itemGavialGreaves_12949 = 12949
const val itemCtrGreaves_12950 = 12950
const val itemBrzLeggings1_12951 = 12951
const val itemLeatherHighboots_12952 = 12952
const val itemLizardLedelsens_12953 = 12953
const val itemStuddedBoots_12954 = 12954
const val itemCuirHighboots_12955 = 12955
const val itemRaptorLedelsens_12956 = 12956
const val itemDuskLedelsens_12957 = 12957
const val itemTigerLedelsens_12958 = 12958
const val itemCoeurlLedelsens_12959 = 12959
const val itemBronzeLeggings_12960 = 12960
const val itemBrassLeggings_12961 = 12961
const val itemLeggings_12962 = 12962
const val itemScorpionLeggings_12963 = 12963
const val itemDstLeggings_12964 = 12964
const val itemCoralLeggings_12965 = 12965
const val itemBoneLeggings_12966 = 12966
const val itemBeetleLeggings_12967 = 12967
const val itemKyahan_12968 = 12968
const val itemCottonKyahan_12969 = 12969
const val itemSoilKyahan_12970 = 12970
const val itemLthHighboots1_12971 = 12971
const val itemShinobiKyahan_12972 = 12972
const val itemMannequinPumps_12973 = 12973
const val itemSuneAte_12974 = 12974
const val itemMrcKyahan_12975 = 12975
const val itemGaiters_12976 = 12976
const val itemCottonGaiters_12977 = 12977
const val itemSocks_12978 = 12978
const val itemWoolSocks_12979 = 12979
const val itemBattleBoots_12980 = 12980
const val itemWarBoots_12981 = 12981
const val itemMrcCptGaiters_12982 = 12982
const val itemAshClogs1_12983 = 12983
const val itemAshClogs_12984 = 12984
const val itemHollyClogs_12985 = 12985
const val itemChestnutSabots_12986 = 12986
const val itemEbonySabots_12987 = 12987
const val itemPigaches_12988 = 12988
const val itemNoblesPumps_12989 = 12989
const val itemTctMgcPigaches_12990 = 12990
const val itemHollyClogs1_12991 = 12991
const val itemSolea_12992 = 12992
const val itemSandals_12993 = 12993
const val itemShoes_12994 = 12994
const val itemMoccasins_12995 = 12995
const val itemSilkPumps_12996 = 12996
const val itemDanzoSuneAte_12997 = 12997
const val itemCmbCstShoes_12998 = 12998
const val itemSusurrusSabatons_12999 = 12999
const val itemPraedaSabatons_13000 = 13000
const val itemAugursGaiters_13001 = 13001
const val itemYashaSuneAte_13002 = 13002
const val itemLgnLeggings_13003 = 13003
const val itemRylFtmBoots_13004 = 13004
const val itemHumeMBoots_13005 = 13005
const val itemElvMLedelsens_13006 = 13006
const val itemTarutaruClomps_13007 = 13007
const val itemMithranGaiters_13008 = 13008
const val itemGalkanSandals_13009 = 13009
const val itemHumeFBoots_13010 = 13010
const val itemElvFLedelsens_13011 = 13011
const val itemPowerSandals_13012 = 13012
const val itemStumblingSandals_13013 = 13013
const val itemLeapingBoots_13014 = 13014
const val itemCustomMBoots_13015 = 13015
const val itemCustomFBoots_13016 = 13016
const val itemMgnMLedelsens_13017 = 13017
const val itemMgnFLedelsens_13018 = 13018
const val itemWonderClomps_13019 = 13019
const val itemSavageGaiters_13020 = 13020
const val itemEldersSandals_13021 = 13021
const val itemChsSabots1_13022 = 13022
const val itemEbonySabots1_13023 = 13023
const val itemSolidGreaves_13024 = 13024
const val itemGreaves1_13025 = 13025
const val itemLeggings1_13026 = 13026
const val itemBrassLeggings1_13027 = 13027
const val itemBrassGreaves1_13028 = 13028
const val itemSilverGreaves1_13029 = 13029
const val itemGaiters1_13030 = 13030
const val itemKyahan1_13031 = 13031
const val itemGreatGaiters_13032 = 13032
const val itemCottonKyahan1_13033 = 13033
const val itemSocks1_13034 = 13034
const val itemSoilKyahan1_13035 = 13035
const val itemWoolSocks1_13036 = 13036
const val itemSolea1_13037 = 13037
const val itemFineLedelsens_13038 = 13038
const val itemStrongBoots_13039 = 13039
const val itemShoes1_13040 = 13040
const val itemCuirHighboots1_13041 = 13041
const val itemBoneLeggings1_13042 = 13042
const val itemBtlLeggings1_13043 = 13043
const val itemCpcLeggings1_13044 = 13044
const val itemRylFtmClogs_13045 = 13045
const val itemPlateLeggings1_13046 = 13046
const val itemSollerets1_13047 = 13047
const val itemMagesSandals_13048 = 13048
const val itemDinoLedelsens_13049 = 13049
const val itemMoccasins1_13050 = 13050
const val itemCoarseLeggings_13051 = 13051
const val itemLightSoleas_13052 = 13052
const val itemCalmPigaches_13053 = 13053
const val itemFumaKyahan_13054 = 13054
const val itemSpiritMoccasins_13055 = 13055
const val itemPeacockCharm_13056 = 13056
const val itemBuburimuGorget_13057 = 13057
const val itemBloodbeadAmulet_13058 = 13058
const val itemFineGorget_13059 = 13059
const val itemFeatherCollar1_13060 = 13060
const val itemSpikeNecklace_13061 = 13061
const val itemGreenGorget_13062 = 13062
const val itemBlueGorget_13063 = 13063
const val itemIrnMskGorget_13064 = 13064
const val itemGorget1_13065 = 13065
const val itemRedChoker_13066 = 13066
const val itemNoblesGorget_13067 = 13067
const val itemHempGorget1_13068 = 13068
const val itemLeatherGorget1_13069 = 13069
const val itemWolfGorget1_13070 = 13070
const val itemScaleGorget_13071 = 13071
const val itemBirdWhistle_13072 = 13072
const val itemHolyPhial_13073 = 13073
const val itemJudgesGorget_13074 = 13074
const val itemFeatherCollar_13075 = 13075
const val itemFangNecklace_13076 = 13076
const val itemStarPendant_13077 = 13077
const val itemPortafurnace_13078 = 13078
const val itemDarksteelGorget_13079 = 13079
const val itemGorget_13080 = 13080
const val itemLeatherGorget_13081 = 13081
const val itemChainGorget_13082 = 13082
const val itemChainChoker_13083 = 13083
const val itemMythrilGorget_13084 = 13084
const val itemHempGorget_13085 = 13085
const val itemCeruleanPendant_13086 = 13086
const val itemJeweledCollar_13087 = 13087
const val itemDarksteelNodowa_13088 = 13088
const val itemWolfGorget_13089 = 13089
const val itemBeetleGorget_13090 = 13090
const val itemCarapaceGorget_13091 = 13091
const val itemCoeurlGorget_13092 = 13092
const val itemJusticeBadge_13093 = 13093
const val itemFlowerNecklace_13094 = 13094
const val itemSandCharm_13095 = 13095
const val itemDogCollar_13096 = 13096
const val itemBrisingamen_13097 = 13097
const val itemRepBronzeMedal_13098 = 13098
const val itemRepIronMedal_13099 = 13099
const val itemRepMythrilMedal_13100 = 13100
const val itemGreenScarf_13101 = 13101
const val itemPaisleyScarf_13102 = 13102
const val itemCheckeredScarf_13103 = 13103
const val itemRylSqrCollar_13104 = 13104
const val itemTKArmyCollar_13105 = 13105
const val itemRylGrdCollar_13106 = 13106
const val itemRKArmyCollar_13107 = 13107
const val itemCoralGorget_13108 = 13108
const val itemHarmoniasTorque_13109 = 13109
const val itemBeastWhistle_13110 = 13110
const val itemNodowa_13111 = 13111
const val itemRabbitCharm_13112 = 13112
const val itemBlackNeckerchief_13113 = 13113
const val itemMoonAmulet_13114 = 13114
const val itemElementalCharm_13115 = 13115
const val itemSilverNameTag_13116 = 13116
const val itemRangersNecklace_13117 = 13117
const val itemShieldPendant_13118 = 13118
const val itemTigerStole_13119 = 13119
const val itemClayAmulet_13120 = 13120
const val itemBeastCollar_13121 = 13121
const val itemMinersPendant_13122 = 13122
const val itemMermansGorget_13123 = 13123
const val itemNodowa1_13124 = 13124
const val itemTorque_13125 = 13125
const val itemTorque1_13126 = 13126
const val itemGuardingGorget_13127 = 13127
const val itemSpectacles_13128 = 13128
const val itemSpiritTorque_13129 = 13129
const val itemJeweledCollar1_13130 = 13130
const val itemDstGorget1_13131 = 13131
const val itemToramaGorget_13132 = 13132
const val itemDstNodowa1_13133 = 13133
const val itemAshuraNecklace_13134 = 13134
const val itemPromiseBadge_13135 = 13135
const val itemStarNecklace_13136 = 13136
const val itemSpiderTorque_13137 = 13137
const val itemFenrirsTorque_13138 = 13138
const val itemYinyangLorgnette_13139 = 13139
const val itemGrandTKCollar_13140 = 13140
const val itemRepGoldMedal_13141 = 13141
const val itemWindurstianScarf_13142 = 13142
const val itemOpoopoNecklace_13143 = 13143
const val itemWingGorget_13144 = 13144
const val itemUggalepihPendant_13145 = 13145
const val itemTernNecklace_13146 = 13146
const val itemUggNecklace_13147 = 13147
const val itemEvasionTorque_13148 = 13148
const val itemParryingTorque_13149 = 13149
const val itemShieldTorque_13150 = 13150
const val itemGuardingTorque_13151 = 13151
const val itemDivineTorque_13152 = 13152
const val itemDarkTorque_13153 = 13153
const val itemEnhancingTorque_13154 = 13154
const val itemEnfeeblingTorque_13155 = 13155
const val itemElementalTorque_13156 = 13156
const val itemHealingTorque_13157 = 13157
const val itemSmnTorque_13158 = 13158
const val itemNinjutsuTorque_13159 = 13159
const val itemStringTorque_13160 = 13160
const val itemWindTorque_13161 = 13161
const val itemBrisingamen1_13162 = 13162
const val itemMedievalCollar_13163 = 13163
const val itemAgileGorget_13164 = 13164
const val itemJagdGorget_13165 = 13165
const val itemHatefulCollar_13166 = 13166
const val itemStormGorget_13167 = 13167
const val itemIntellectTorque_13168 = 13168
const val itemBenignNecklace_13169 = 13169
const val itemStoneskinTorque_13170 = 13170
const val itemReraiseGorget_13171 = 13171
const val itemPchCollar_13172 = 13172
const val itemMementoMuffler_13173 = 13173
const val itemWillpowerTorque_13174 = 13174
const val itemAjariNecklace_13175 = 13175
const val itemPhilomathStole_13176 = 13176
const val itemStoneGorget_13177 = 13177
const val itemAuditoryTorque_13178 = 13178
const val itemKgdStableCollar_13179 = 13179
const val itemRepStableMedal_13180 = 13180
const val itemFedStableScarf_13181 = 13181
const val itemOscarScarf_13182 = 13182
const val itemWingPendant_13183 = 13183
const val itemWhiteBelt_13184 = 13184
const val itemMuscleBelt_13185 = 13185
const val itemBlackBelt_13186 = 13186
const val itemTigerBelt_13187 = 13187
const val itemStarSash_13188 = 13188
const val itemSpeedBelt_13189 = 13189
const val itemHekoObi1_13190 = 13190
const val itemLizardBelt1_13191 = 13191
const val itemLeatherBelt_13192 = 13192
const val itemLizardBelt_13193 = 13193
const val itemWarriorsBelt_13194 = 13194
const val itemMagicBelt_13195 = 13195
const val itemSilverBelt_13196 = 13196
const val itemKoenigsBelt_13197 = 13197
const val itemSwordbelt_13198 = 13198
const val itemBloodStone_13199 = 13199
const val itemWaistbelt_13200 = 13200
const val itemPurpleBelt_13201 = 13201
const val itemBrownBelt_13202 = 13202
const val itemBarbariansBelt_13203 = 13203
const val itemHekoObi_13204 = 13204
const val itemSilverObi_13205 = 13205
const val itemGoldObi_13206 = 13206
const val itemBrocadeObi_13207 = 13207
const val itemRainbowObi_13208 = 13208
const val itemChainBelt_13209 = 13209
const val itemLeatherBelt1_13210 = 13210
const val itemFriarsRope_13211 = 13211
const val itemTarutaruSash_13212 = 13212
const val itemChainBelt1_13213 = 13213
const val itemWaistbelt1_13214 = 13214
const val itemJudgesBelt_13215 = 13215
const val itemGoldMogBelt_13216 = 13216
const val itemSilverMogBelt_13217 = 13217
const val itemBronzeMogBelt_13218 = 13218
const val itemMagicBelt1_13219 = 13219
const val itemRylKgtBelt_13220 = 13220
const val itemMrcCptBelt_13221 = 13221
const val itemForceBelt_13222 = 13222
const val itemSilverBelt1_13223 = 13223
const val itemSilverObi1_13224 = 13224
const val itemBraveBelt_13225 = 13225
const val itemBloodStone1_13226 = 13226
const val itemPlateBelt_13227 = 13227
const val itemShamansBelt_13228 = 13228
const val itemOraclesBelt_13229 = 13229
const val itemAdeptsRope_13230 = 13230
const val itemLifeBelt_13231 = 13231
const val itemSwordbelt1_13232 = 13232
const val itemGoldObi1_13233 = 13233
const val itemBrocadeObi1_13234 = 13234
const val itemPrismObi_13235 = 13235
const val itemMasterBelt_13236 = 13236
const val itemSurvivalBelt_13237 = 13237
const val itemDruidsRope_13238 = 13238
const val itemKaiserBelt_13239 = 13239
const val itemWarriorsBelt1_13240 = 13240
const val itemFireBelt_13241 = 13241
const val itemIceBelt_13242 = 13242
const val itemWindBelt_13243 = 13243
const val itemEarthBelt_13244 = 13244
const val itemLightningBelt_13245 = 13245
const val itemWaterBelt_13246 = 13246
const val itemMithranStone_13247 = 13247
const val itemFlagellantsRope_13248 = 13248
const val itemSonicBelt_13249 = 13249
const val itemSonicBelt1_13250 = 13250
const val itemOceanBelt_13251 = 13251
const val itemForestBelt_13252 = 13252
const val itemSteppeBelt_13253 = 13253
const val itemJungleBelt_13254 = 13254
const val itemDesertBelt_13255 = 13255
const val itemOceanStone_13256 = 13256
const val itemForestStone_13257 = 13257
const val itemSteppeStone_13258 = 13258
const val itemJungleStone_13259 = 13259
const val itemDesertStone_13260 = 13260
const val itemOceanSash_13261 = 13261
const val itemForestSash_13262 = 13262
const val itemSteppeSash_13263 = 13263
const val itemJungleSash_13264 = 13264
const val itemDesertSash_13265 = 13265
const val itemOceanRope_13266 = 13266
const val itemForestRope_13267 = 13267
const val itemSteppeRope_13268 = 13268
const val itemJungleRope_13269 = 13269
const val itemDesertRope_13270 = 13270
const val itemCorsette_13271 = 13271
const val itemCorsette1_13272 = 13272
const val itemTwinthreadObi_13273 = 13273
const val itemTwinthreadObi1_13274 = 13274
const val itemArachneObi_13275 = 13275
const val itemArachneObi1_13276 = 13276
const val itemRKBelt1_13277 = 13277
const val itemRKBelt2_13278 = 13278
const val itemMuscleBelt1_13279 = 13279
const val itemSnipersRing_13280 = 13280
const val itemSnipersRing1_13281 = 13281
const val itemSaintlyRing_13282 = 13282
const val itemSaintlyRing1_13283 = 13283
const val itemEremitesRing_13284 = 13284
const val itemEremitesRing1_13285 = 13285
const val itemSoldiersRing_13286 = 13286
const val itemKampferRing_13287 = 13287
const val itemMedicineRing_13288 = 13288
const val itemSorcerersRing_13289 = 13289
const val itemFencersRing_13290 = 13290
const val itemRoguesRing_13291 = 13291
const val itemGuardiansRing_13292 = 13292
const val itemSlayersRing_13293 = 13293
const val itemTamersRing_13294 = 13294
const val itemMinstrelsRing_13295 = 13295
const val itemTrackersRing_13296 = 13296
const val itemRoninRing_13297 = 13297
const val itemShinobiRing_13298 = 13298
const val itemDrakeRing_13299 = 13299
const val itemConjurersRing_13300 = 13300
const val itemVivianRing_13301 = 13301
const val itemBloodbeadRing_13302 = 13302
const val itemJellyRing_13303 = 13303
const val itemNimbleRing_13304 = 13304
const val itemTriumphRing_13305 = 13305
const val itemOmniscientRing_13306 = 13306
const val itemAdroitRing_13307 = 13307
const val itemCommunionRing_13308 = 13308
const val itemRobustRing_13309 = 13309
const val itemHadesRing_13310 = 13310
const val itemHeavensRing_13311 = 13311
const val itemCoralEarring_13312 = 13312
const val itemShellEarring_13313 = 13313
const val itemShellEarring1_13314 = 13314
const val itemGoldEarring_13315 = 13315
const val itemPlatinumEarring_13316 = 13316
const val itemPearlEarring_13317 = 13317
const val itemTopazEarring_13318 = 13318
const val itemPeridotEarring_13319 = 13319
const val itemBlackEarring_13320 = 13320
const val itemBoneEarring_13321 = 13321
const val itemWingEarring_13322 = 13322
const val itemBeetleEarring_13323 = 13323
const val itemTortoiseEarring_13324 = 13324
const val itemFangEarring_13325 = 13325
const val itemBeetleEarring1_13326 = 13326
const val itemSilverEarring_13327 = 13327
const val itemMythrilEarring_13328 = 13328
const val itemOclEarring_13329 = 13329
const val itemTmlEarring_13330 = 13330
const val itemSardonyxEarring_13331 = 13331
const val itemClearEarring_13332 = 13332
const val itemAmethystEarring_13333 = 13333
const val itemLapisLazEarring_13334 = 13334
const val itemAmberEarring_13335 = 13335
const val itemOnyxEarring_13336 = 13336
const val itemOpalEarring_13337 = 13337
const val itemBloodEarring_13338 = 13338
const val itemGosheniteEarring_13339 = 13339
const val itemAmetrineEarring_13340 = 13340
const val itemTurquoiseEarring_13341 = 13341
const val itemSpheneEarring_13342 = 13342
const val itemGreenEarring_13343 = 13343
const val itemSunEarring_13344 = 13344
const val itemZirconEarring_13345 = 13345
const val itemPurpleEarring_13346 = 13346
const val itemAquamrneEarring_13347 = 13347
const val itemYellowEarring_13348 = 13348
const val itemNightEarring_13349 = 13349
const val itemMoonEarring_13350 = 13350
const val itemEmeraldEarring_13351 = 13351
const val itemRubyEarring_13352 = 13352
const val itemDiamondEarring_13353 = 13353
const val itemSpinelEarring_13354 = 13354
const val itemSapphireEarring_13355 = 13355
const val itemDeathEarring_13356 = 13356
const val itemAngelsEarring_13357 = 13357
const val itemJudgesEarring_13358 = 13358
const val itemBloodbeadEarring_13359 = 13359
const val itemTwinstoneEarring_13360 = 13360
const val itemDroneEarring_13361 = 13361
const val itemBoneEarring1_13362 = 13362
const val itemTorEarring1_13363 = 13363
const val itemValorEarring_13364 = 13364
const val itemShieldEarring_13365 = 13365
const val itemDodgeEarring_13366 = 13366
const val itemBullEarring_13367 = 13367
const val itemAvengersEarring_13368 = 13368
const val itemSpikeEarring_13369 = 13369
const val itemSilverEarring1_13370 = 13370
const val itemMythrilEarring1_13371 = 13371
const val itemGoldEarring1_13372 = 13372
const val itemReflexEarring_13373 = 13373
const val itemCourageEarring_13374 = 13374
const val itemKnowledgeEarring_13375 = 13375
const val itemBalanceEarring_13376 = 13376
const val itemTranquilityEarring_13377 = 13377
const val itemStaminaEarring_13378 = 13378
const val itemEnergyEarring_13379 = 13379
const val itemHopeEarring_13380 = 13380
const val itemAlacrityEarring_13381 = 13381
const val itemPuissanceEarring_13382 = 13382
const val itemWisdomEarring_13383 = 13383
const val itemDeftEarring_13384 = 13384
const val itemSolaceEarring_13385 = 13385
const val itemVerveEarring_13386 = 13386
const val itemAuraEarring_13387 = 13387
const val itemLoyaltyEarring_13388 = 13388
const val itemCelerityEarring_13389 = 13389
const val itemVictoryEarring_13390 = 13390
const val itemGeniusEarring_13391 = 13391
const val itemGraceEarring_13392 = 13392
const val itemSerenityEarring_13393 = 13393
const val itemVigorEarring_13394 = 13394
const val itemManaEarring_13395 = 13395
const val itemAllureEarring_13396 = 13396
const val itemPtmEarring1_13397 = 13397
const val itemPhysicalEarring_13398 = 13398
const val itemFenrirsEarring_13399 = 13399
const val itemBitterEarring_13400 = 13400
const val itemAretedelSol_13401 = 13401
const val itemCassieEarring_13402 = 13402
const val itemAssaultEarring_13403 = 13403
const val itemNemesisEarring_13404 = 13404
const val itemEnhancingEarring_13405 = 13405
const val itemMermansEarring_13406 = 13406
const val itemNimbleEarring_13407 = 13407
const val itemTriumphEarring_13408 = 13408
const val itemOmnEarring_13409 = 13409
const val itemAdroitEarring_13410 = 13410
const val itemCmnEarring_13411 = 13411
const val itemRobustEarring_13412 = 13412
const val itemHadesEarring_13413 = 13413
const val itemHeavensEarring_13414 = 13414
const val itemPixieEarring_13415 = 13415
const val itemBatEarring_13416 = 13416
const val itemErisEarring_13417 = 13417
const val itemErisEarring1_13418 = 13418
const val itemSoldiersEarring_13419 = 13419
const val itemKampferEarring_13420 = 13420
const val itemMedicineEarring_13421 = 13421
const val itemSorcerersEarring_13422 = 13422
const val itemFencersEarring_13423 = 13423
const val itemRoguesEarring_13424 = 13424
const val itemGuardianEarring_13425 = 13425
const val itemSlayersEarring_13426 = 13426
const val itemTamersEarring_13427 = 13427
const val itemMinstrelsEarring_13428 = 13428
const val itemTrackersEarring_13429 = 13429
const val itemRoninEarring_13430 = 13430
const val itemShinobiEarring_13431 = 13431
const val itemDrakeEarring_13432 = 13432
const val itemConjurersEarring_13433 = 13433
const val itemTritonEarring_13434 = 13434
const val itemMercenEarring_13435 = 13435
const val itemWrestlersEarring_13436 = 13436
const val itemHealersEarring_13437 = 13437
const val itemWizardsEarring_13438 = 13438
const val itemWarlocksEarring_13439 = 13439
const val itemAsceticsRing_13440 = 13440
const val itemBoneRing_13441 = 13441
const val itemShellRing_13442 = 13442
const val itemOpalRing_13443 = 13443
const val itemSardonyxRing_13444 = 13444
const val itemGoldRing_13445 = 13445
const val itemMythrilRing_13446 = 13446
const val itemPlatinumRing_13447 = 13447
const val itemEmeraldRing_13448 = 13448
const val itemRubyRing_13449 = 13449
const val itemDiamondRing_13450 = 13450
const val itemSpinelRing_13451 = 13451
const val itemSapphireRing_13452 = 13452
const val itemTopazRing_13453 = 13453
const val itemCopperRing_13454 = 13454
const val itemCoralRing_13455 = 13455
const val itemSilverRing_13456 = 13456
const val itemBeetleRing_13457 = 13457
const val itemScorpionRing_13458 = 13458
const val itemHornRing_13459 = 13459
const val itemBehemothRing_13460 = 13460
const val itemCarapaceRing_13461 = 13461
const val itemDeathRing_13462 = 13462
const val itemAngelsRing_13463 = 13463
const val itemDemonsRing_13464 = 13464
const val itemBrassRing_13465 = 13465
const val itemOrichalcumRing_13466 = 13466
const val itemDragonRing_13467 = 13467
const val itemTourmalineRing_13468 = 13468
const val itemLeatherRing_13469 = 13469
const val itemClearRing_13470 = 13470
const val itemAmethystRing_13471 = 13471
const val itemLapisLazuliRing_13472 = 13472
const val itemAmberRing_13473 = 13473
const val itemOnyxRing_13474 = 13474
const val itemHermitsRing_13475 = 13475
const val itemPeridotRing_13476 = 13476
const val itemGarnetRing_13477 = 13477
const val itemGosheniteRing_13478 = 13478
const val itemAmetrineRing_13479 = 13479
const val itemTurquoiseRing_13480 = 13480
const val itemSpheneRing_13481 = 13481
const val itemBlackRing_13482 = 13482
const val itemPearlRing_13483 = 13483
const val itemJadeiteRing_13484 = 13484
const val itemSunRing_13485 = 13485
const val itemZirconRing_13486 = 13486
const val itemFluoriteRing_13487 = 13487
const val itemAquamarineRing_13488 = 13488
const val itemChrysoberylRing_13489 = 13489
const val itemPainiteRing_13490 = 13490
const val itemMoonRing_13491 = 13491
const val itemCopperRing1_13492 = 13492
const val itemBrassRing1_13493 = 13493
const val itemShellRing1_13494 = 13494
const val itemSandOrianRing_13495 = 13495
const val itemWindurstianRing_13496 = 13496
const val itemBastokanRing_13497 = 13497
const val itemPlatinumRing1_13498 = 13498
const val itemLeatherRing1_13499 = 13499
const val itemBoneRing1_13500 = 13500
const val itemBeetleRing1_13501 = 13501
const val itemHornRing1_13502 = 13502
const val itemCarapaceRing1_13503 = 13503
const val itemMermansRing_13504 = 13504
const val itemJudgesRing_13505 = 13505
const val itemBombRing_13506 = 13506
const val itemMalfloodRing_13507 = 13507
const val itemMaldustRing_13508 = 13508
const val itemMalfrostRing_13509 = 13509
const val itemMalflameRing_13510 = 13510
const val itemMalflashRing_13511 = 13511
const val itemMalgustRing_13512 = 13512
const val itemScorpionRing1_13513 = 13513
const val itemArchersRing_13514 = 13514
const val itemElectrumRing_13515 = 13515
const val itemPhalanxRing_13516 = 13516
const val itemWeddingRing_13517 = 13517
const val itemSilverRing1_13518 = 13518
const val itemMythrilRing1_13519 = 13519
const val itemGoldRing1_13520 = 13520
const val itemReflexRing_13521 = 13521
const val itemCourageRing_13522 = 13522
const val itemKnowledgeRing_13523 = 13523
const val itemBalanceRing_13524 = 13524
const val itemTranquilityRing_13525 = 13525
const val itemStaminaRing_13526 = 13526
const val itemEnergyRing_13527 = 13527
const val itemHopeRing_13528 = 13528
const val itemAlacrityRing_13529 = 13529
const val itemPuissanceRing_13530 = 13530
const val itemWisdomRing_13531 = 13531
const val itemDeftRing_13532 = 13532
const val itemSolaceRing_13533 = 13533
const val itemVerveRing_13534 = 13534
const val itemAuraRing_13535 = 13535
const val itemLoyaltyRing_13536 = 13536
const val itemCelerityRing_13537 = 13537
const val itemVictoryRing_13538 = 13538
const val itemGeniusRing_13539 = 13539
const val itemGraceRing_13540 = 13540
const val itemSerenityRing_13541 = 13541
const val itemVigorRing_13542 = 13542
const val itemMysticRing_13543 = 13543
const val itemAllureRing_13544 = 13544
const val itemDemonsRing1_13545 = 13545
const val itemHardLeatherRing_13546 = 13546
const val itemTigerRing_13547 = 13547
const val itemAstralRing_13548 = 13548
const val itemEtherRing_13549 = 13549
const val itemCrossbowmanRing_13550 = 13550
const val itemKshamaRingNo8_13551 = 13551
const val itemSerketRing_13552 = 13552
const val itemBlitzRing_13553 = 13553
const val itemAegisRing_13554 = 13554
const val itemPeaceRing_13555 = 13555
const val itemBehemothRing1_13556 = 13556
const val itemGndKgtRing_13557 = 13557
const val itemGldMskRing_13558 = 13558
const val itemPtrPrtRing_13559 = 13559
const val itemFireRing_13560 = 13560
const val itemIceRing_13561 = 13561
const val itemWindRing_13562 = 13562
const val itemEarthRing_13563 = 13563
const val itemLightningRing_13564 = 13564
const val itemWaterRing_13565 = 13565
const val itemDefendingRing_13566 = 13566
const val itemBombQueenRing_13567 = 13567
const val itemScarletRibbon_13568 = 13568
const val itemPurpleRibbon_13569 = 13569
const val itemRamMantle_13570 = 13570
const val itemWolfMantle_13571 = 13571
const val itemFenrirsCape_13572 = 13572
const val itemSearingCape_13573 = 13573
const val itemBlackRibbon_13574 = 13574
const val itemRamMantle1_13575 = 13575
const val itemNightCape_13576 = 13576
const val itemBlackCape_13577 = 13577
const val itemBlueCape_13578 = 13578
const val itemJestersCape_13579 = 13579
const val itemRylArmyMantle_13580 = 13580
const val itemFedArmyMantle_13581 = 13581
const val itemRepArmyMantle_13582 = 13582
const val itemCape_13583 = 13583
const val itemCottonCape_13584 = 13584
const val itemWhiteCape_13585 = 13585
const val itemRedCape_13586 = 13586
const val itemRainbowCape_13587 = 13587
const val itemDhalmelMantle_13588 = 13588
const val itemTigerMantle_13589 = 13589
const val itemGreenRibbon_13590 = 13590
const val itemBehemothMantle_13591 = 13591
const val itemLizardMantle_13592 = 13592
const val itemRaptorMantle_13593 = 13593
const val itemRabbitMantle_13594 = 13594
const val itemCoeurlMantle_13595 = 13595
const val itemGreenCape_13596 = 13596
const val itemBeakMantle_13597 = 13597
const val itemBatCape_13598 = 13598
const val itemRabbitMantle1_13599 = 13599
const val itemDhalmelMantle1_13600 = 13600
const val itemCottonCape1_13601 = 13601
const val itemFeralMantle_13602 = 13602
const val itemToramaMantle_13603 = 13603
const val itemBehemMantle1_13604 = 13604
const val itemCape1_13605 = 13605
const val itemJudgesCape_13606 = 13606
const val itemMistSilkCape_13607 = 13607
const val itemLizardMantle1_13608 = 13608
const val itemWolfMantle1_13609 = 13609
const val itemBlackCape1_13610 = 13610
const val itemRedCape1_13611 = 13611
const val itemDinoMantle_13612 = 13612
const val itemTravelersMantle_13613 = 13613
const val itemBonzeCape_13614 = 13614
const val itemSentinelsMantle_13615 = 13615
const val itemDodgeCape_13616 = 13616
const val itemLightningMantle_13617 = 13617
const val itemWhiteCape1_13618 = 13618
const val itemTernCape_13619 = 13619
const val itemJestersCape1_13620 = 13620
const val itemBeakMantle1_13621 = 13621
const val itemAmityCape_13622 = 13622
const val itemEarthMantle_13623 = 13623
const val itemEnhancingMantle_13624 = 13624
const val itemTundraMantle_13625 = 13625
const val itemBlueCape1_13626 = 13626
const val itemPrismCape_13627 = 13627
const val itemHexereiCape_13628 = 13628
const val itemPeaceCape_13629 = 13629
const val itemPeaceCape1_13630 = 13630
const val itemNomadsMantle_13631 = 13631
const val itemNomadsMantle1_13632 = 13632
const val itemEmpwrMantle_13633 = 13633
const val itemEmpwrMantle1_13634 = 13634
const val itemCvlMantle_13635 = 13635
const val itemCvlMantle1_13636 = 13636
const val itemGaiaMantle_13637 = 13637
const val itemGaiaMantle1_13638 = 13638
const val itemAuroraMantle_13639 = 13639
const val itemAuroraMantle1_13640 = 13640
const val itemBlackMantle_13641 = 13641
const val itemBlackMantle1_13642 = 13642
const val itemSarcenetCape_13643 = 13643
const val itemMidnightCape_13644 = 13644
const val itemAmemetMantle_13645 = 13645
const val itemAmemetMantle1_13646 = 13646
const val itemSettlersCape_13647 = 13647
const val itemGigantMantle_13648 = 13648
const val itemTaffetaCape_13649 = 13649
const val itemTaffetaCape1_13650 = 13650
const val itemCheviotCape_13651 = 13651
const val itemUmbraCape_13652 = 13652
const val itemDesertMantle_13653 = 13653
const val itemDesertMantle1_13654 = 13654
const val itemSandMantle_13655 = 13655
const val itemErrantCape_13656 = 13656
const val itemMahatmaCape_13657 = 13657
const val itemShadowMantle_13658 = 13658
const val itemMercenMantle_13659 = 13659
const val itemWrestlersMantle_13660 = 13660
const val itemHealersMantle_13661 = 13661
const val itemWizardsMantle_13662 = 13662
const val itemWarlocksMantle_13663 = 13663
const val itemPilferersMantle_13664 = 13664
const val itemEsquiresMantle_13665 = 13665
const val itemKillerMantle_13666 = 13666
const val itemTrimmersMantle_13667 = 13667
const val itemSingersMantle_13668 = 13668
const val itemBeatersMantle_13669 = 13669
const val itemAshigaruMantle_13670 = 13670
const val itemGeninMantle_13671 = 13671
const val itemWyvernMantle_13672 = 13672
const val itemMagiciansMantle_13673 = 13673
const val itemAgileMantle_13674 = 13674
const val itemRearguardMantle_13675 = 13675
const val itemHeavyMantle_13676 = 13676
const val itemEsotericMantle_13677 = 13677
const val itemSnipersMantle_13678 = 13678
const val itemTemplarsMantle_13679 = 13679
const val itemVariableMantle_13680 = 13680
const val itemVariableCape_13681 = 13681
const val itemEtherTank_13682 = 13682
const val itemWaterTank_13683 = 13683
const val itemPotionTank_13684 = 13684
const val itemInvisibleMantle_13685 = 13685
const val itemJaguarMantle_13686 = 13686
const val itemSapientCape_13687 = 13687
const val itemHiPotionTank_13688 = 13688
const val itemHiEtherTank_13689 = 13689
const val itemForagersMantle_13690 = 13690
const val itemKnightlyMantle_13691 = 13691
const val itemSkulkersCape_13692 = 13692
const val itemAriesMantle_13693 = 13693
const val itemPsilosMantle_13694 = 13694
const val itemCommandersCape_13695 = 13695
const val itemWoolGambison1_13696 = 13696
const val itemFineJerkin_13697 = 13697
const val itemBeakHelm_13698 = 13698
const val itemBeakJerkin_13699 = 13699
const val itemBeakGloves_13700 = 13700
const val itemBeakHelm1_13701 = 13701
const val itemBeakLedelsens_13702 = 13702
const val itemBrigandine_13703 = 13703
const val itemOgreMask_13704 = 13704
const val itemOgreJerkin_13705 = 13705
const val itemOgreGloves_13706 = 13706
const val itemStrongVest_13707 = 13707
const val itemOgreLedelsens_13708 = 13708
const val itemCuirBouilli1_13709 = 13709
const val itemBrigandine1_13710 = 13710
const val itemCarapaceMask_13711 = 13711
const val itemCarapaceHarness_13712 = 13712
const val itemCarapaceMittens_13713 = 13713
const val itemCpcHarness1_13714 = 13714
const val itemCpcLeggings_13715 = 13715
const val itemBoneHarness1_13716 = 13716
const val itemBeetleHarness1_13717 = 13717
const val itemRylFtmTunic_13718 = 13718
const val itemRylSqrRobe_13719 = 13719
const val itemRylKgtCloak_13720 = 13720
const val itemIrnMskGambison_13721 = 13721
const val itemRylKgtAketon_13722 = 13722
const val itemPyroRobe_13723 = 13723
const val itemBreastplate1_13724 = 13724
const val itemMagesTunic_13725 = 13725
const val itemMagesRobe_13726 = 13726
const val itemDinoJerkin_13727 = 13727
const val itemJujitsuGi_13728 = 13728
const val itemPriestsRobe_13729 = 13729
const val itemFrostRobe_13730 = 13730
const val itemFaerieTunic_13731 = 13731
const val itemEarthDoublet_13732 = 13732
const val itemShinobiGi1_13733 = 13733
const val itemScpHarness1_13734 = 13734
const val itemHaubergeon1_13735 = 13735
const val itemStolidBreastplate_13736 = 13736
const val itemMtlBrstplate1_13737 = 13737
const val itemGiltCuirass_13738 = 13738
const val itemBeakJerkin1_13739 = 13739
const val itemByrnie_13740 = 13740
const val itemByrnie1_13741 = 13741
const val itemAketon_13742 = 13742
const val itemAketon1_13743 = 13743
const val itemJustaucorps_13744 = 13744
const val itemJustaucorps1_13745 = 13745
const val itemGemCuirass_13746 = 13746
const val itemGavialMail1_13747 = 13747
const val itemVermillionCloak_13748 = 13748
const val itemRoyalCloak_13749 = 13749
const val itemLinenDoublet_13750 = 13750
const val itemLinenDoublet1_13751 = 13751
const val itemWoolDoublet_13752 = 13752
const val itemWoolDoublet1_13753 = 13753
const val itemBlackCotehardie_13754 = 13754
const val itemFloraCotehardie_13755 = 13755
const val itemDstCuirass1_13756 = 13756
const val itemLordsCuirass_13757 = 13757
const val itemKingsCuirass_13758 = 13758
const val itemPerleHauberk_13759 = 13759
const val itemAuroreDoublet_13760 = 13760
const val itemCorScaleMail1_13761 = 13761
const val itemDragonMail1_13762 = 13762
const val itemFeralJerkin_13763 = 13763
const val itemToramaJerkin_13764 = 13764
const val itemDstHarness1_13765 = 13765
const val itemMermansHarness_13766 = 13766
const val itemDemonsHarness_13767 = 13767
const val itemDmnHarness1_13768 = 13768
const val itemHaraAte1_13769 = 13769
const val itemWarShinobiGi1_13770 = 13770
const val itemWarAketon1_13771 = 13771
const val itemBloodyAketon_13772 = 13772
const val itemCarnageAketon_13773 = 13773
const val itemAristocratsCoat_13774 = 13774
const val itemBlueCotehardie_13775 = 13775
const val itemBlueCotehard1_13776 = 13776
const val itemSilkCloak1_13777 = 13777
const val itemTealSaio_13778 = 13778
const val itemBlackCloak_13779 = 13779
const val itemDemonsCloak_13780 = 13780
const val itemMyochinDomaru_13781 = 13781
const val itemNinjaChainmail_13782 = 13782
const val itemIronScaleMail_13783 = 13783
const val itemIronScaleMail1_13784 = 13784
const val itemSteelScaleMail_13785 = 13785
const val itemStlScaleMail1_13786 = 13786
const val itemDalmatica_13787 = 13787
const val itemDalmatica1_13788 = 13788
const val itemCpcBreastplate_13789 = 13789
const val itemCpcBrstplate1_13790 = 13790
const val itemTimarliJawshan_13791 = 13791
const val itemGrimCuirass_13792 = 13792
const val itemHauberk1_13793 = 13793
const val itemHeavyCuirass_13794 = 13794
const val itemArhatsGi_13795 = 13795
const val itemBishopsRobe_13796 = 13796
const val itemBishopsRobe1_13797 = 13797
const val itemGaiaDoublet_13798 = 13798
const val itemGaiaDoublet1_13799 = 13799
const val itemMastersGi_13800 = 13800
const val itemMastersGi1_13801 = 13801
const val itemArhatsGi1_13802 = 13802
const val itemShamansCloak_13803 = 13803
const val itemMinstrelsCoat_13804 = 13804
const val itemAssaultJerkin_13805 = 13805
const val itemVgdTunica_13806 = 13806
const val itemNomadsTunica_13807 = 13807
const val itemFshTunica_13808 = 13808
const val itemAnglersTunica_13809 = 13809
const val itemChocJackCoat_13810 = 13810
const val itemRidersJackCoat_13811 = 13811
const val itemHolyBreastplate_13812 = 13812
const val itemDivineBreastplate_13813 = 13813
const val itemAustereRobe_13814 = 13814
const val itemPenanceRobe_13815 = 13815
const val itemNarasimhasVest_13816 = 13816
const val itemVishnusVest_13817 = 13817
const val itemGarrisonTunica_13818 = 13818
const val itemOnokoYukata_13819 = 13819
const val itemOminaYukata_13820 = 13820
const val itemLordsYukata_13821 = 13821
const val itemLadysYukata_13822 = 13822
const val itemRegenCuirass_13823 = 13823
const val itemStrongBandana_13824 = 13824
const val itemBoneHairpin1_13825 = 13825
const val itemBoneMask1_13826 = 13826
const val itemBeetleMask1_13827 = 13827
const val itemHornHairpin1_13828 = 13828
const val itemCarapaceMask1_13829 = 13829
const val itemLgnCirclet_13830 = 13830
const val itemSallet1_13831 = 13831
const val itemBandedHelm1_13832 = 13832
const val itemNoblesRibbon_13833 = 13833
const val itemMagesHat_13834 = 13834
const val itemDinoHelm_13835 = 13835
const val itemShellHairpin1_13836 = 13836
const val itemBonzesCirclet_13837 = 13837
const val itemDodgeHeadband_13838 = 13838
const val itemMarineHat_13839 = 13839
const val itemElectrumHairpin_13840 = 13840
const val itemValkyriesMask_13841 = 13841
const val itemTavnazianMask_13842 = 13842
const val itemSilkHat1_13843 = 13843
const val itemShnHachigane1_13844 = 13844
const val itemCelata1_13845 = 13845
const val itemScorpionHelm_13846 = 13846
const val itemMythrilSallet1_13847 = 13847
const val itemGiltArmet_13848 = 13848
const val itemGoldHairpin1_13849 = 13849
const val itemMermansHairpin_13850 = 13850
const val itemSilkHeadband1_13851 = 13851
const val itemSuijinKabuto_13852 = 13852
const val itemFeroxVizor_13853 = 13853
const val itemGreenRibbon1_13854 = 13854
const val itemHealersCap_13855 = 13855
const val itemWizardsPetasos_13856 = 13856
const val itemChoralRoundlet_13857 = 13857
const val itemPrismHeadband_13858 = 13858
const val itemCoralVisor1_13859 = 13859
const val itemDragonMask1_13860 = 13860
const val itemFeralHelm_13861 = 13861
const val itemToramaMask_13862 = 13862
const val itemDarksteelCap1_13863 = 13863
const val itemMermansCap_13864 = 13864
const val itemZunariKabuto1_13865 = 13865
const val itemGreenBeret1_13866 = 13866
const val itemWarBeret1_13867 = 13867
const val itemMyochinKabuto_13868 = 13868
const val itemNinjaHatsuburi_13869 = 13869
const val itemOpoopoCrown_13870 = 13870
const val itemIronVisor_13871 = 13871
const val itemIronVisor1_13872 = 13872
const val itemSteelVisor_13873 = 13873
const val itemSteelVisor1_13874 = 13874
const val itemMsnJinpachi_13875 = 13875
const val itemZenithCrown_13876 = 13876
const val itemZenithCrown1_13877 = 13877
const val itemCarapaceHelm_13878 = 13878
const val itemCarapaceHelm1_13879 = 13879
const val itemPresidentHairpin_13880 = 13880
const val itemArhatsJinpachi_13881 = 13881
const val itemCorsairsHat_13882 = 13882
const val itemCorsairsHat1_13883 = 13883
const val itemJestersHeadband_13884 = 13884
const val itemJglHeadband_13885 = 13885
const val itemArhJinpachi1_13886 = 13886
const val itemBlackSallet_13887 = 13887
const val itemOnyxSallet_13888 = 13888
const val itemBastokanCap_13889 = 13889
const val itemRepublicCap_13890 = 13890
const val itemSandOrianHelm_13891 = 13891
const val itemKingdomHelm_13892 = 13892
const val itemIrnMskArmet1_13893 = 13893
const val itemIrnMskArmet2_13894 = 13894
const val itemSanBandana_13895 = 13895
const val itemKingdomBandana_13896 = 13896
const val itemBastokanVisor_13897 = 13897
const val itemRepublicVisor_13898 = 13898
const val itemBastokanCirclet_13899 = 13899
const val itemRepublicCirclet_13900 = 13900
const val itemWinHachimaki_13901 = 13901
const val itemFedHachimaki_13902 = 13902
const val itemWinHeadgear_13903 = 13903
const val itemFedHeadgear_13904 = 13904
const val itemTMHat1_13905 = 13905
const val itemTMHat2_13906 = 13906
const val itemOgreMask1_13907 = 13907
const val itemCrimsonMask_13908 = 13908
const val itemBloodMask_13909 = 13909
const val itemRoshiJinpachi_13910 = 13910
const val itemKaiserSchaller_13911 = 13911
const val itemShadowMask_13912 = 13912
const val itemMushroomHelm_13913 = 13913
const val itemAegishjalmr_13914 = 13914
const val itemOpticalHat_13915 = 13915
const val itemPumpkinHead_13916 = 13916
const val itemHorrorHead_13917 = 13917
const val itemTigerMask_13918 = 13918
const val itemFeralMask_13919 = 13919
const val itemWyvernHelm_13920 = 13920
const val itemWyvernHelm1_13921 = 13921
const val itemDemonHelm_13922 = 13922
const val itemDemonHelm1_13923 = 13923
const val itemArmadaCelata_13924 = 13924
const val itemRstJinpachi_13925 = 13925
const val itemRstJinpachi1_13926 = 13926
const val itemHecatombCap_13927 = 13927
const val itemHecatombCap1_13928 = 13928
const val itemErrantHat_13929 = 13929
const val itemMahatmaHat_13930 = 13930
const val itemLilacCorsage_13931 = 13931
const val itemGalaCorsage_13932 = 13932
const val itemBridalCorsage_13933 = 13933
const val itemShrZnrKabuto_13934 = 13934
const val itemShrZnrKabuto1_13935 = 13935
const val itemDragonCap_13936 = 13936
const val itemDragonCap1_13937 = 13937
const val itemDuskMask1_13938 = 13938
const val itemAustereHat_13939 = 13939
const val itemPenanceHat_13940 = 13940
const val itemGemBarbuta_13941 = 13941
const val itemPantherMask_13942 = 13942
const val itemPantherMask1_13943 = 13943
const val itemGavialMask1_13944 = 13944
const val itemShadedSpecs_13945 = 13945
const val itemMagnifyingSpecs_13946 = 13946
const val itemProtectiveSpecs_13947 = 13947
const val itemChefsHat_13948 = 13948
const val itemRoshiJinpachi1_13949 = 13949
const val itemEliteBeret_13950 = 13950
const val itemEliteBeret1_13951 = 13951
const val itemOchiudosKote_13952 = 13952
const val itemWhiteMitts1_13953 = 13953
const val itemSilkCuffs1_13954 = 13954
const val itemShinobiTekko1_13955 = 13955
const val itemScpMittens1_13956 = 13956
const val itemYashaTekko_13957 = 13957
const val itemMythrilGnt1_13958 = 13958
const val itemGiltGauntlets_13959 = 13959
const val itemBeakGloves1_13960 = 13960
const val itemFightersMufflers_13961 = 13961
const val itemTempleGloves_13962 = 13962
const val itemHealersMitts_13963 = 13963
const val itemWizardsGloves_13964 = 13964
const val itemWarlocksGloves_13965 = 13965
const val itemRoguesArmlets_13966 = 13966
const val itemGallantGauntlets_13967 = 13967
const val itemChaosGauntlets_13968 = 13968
const val itemBeastGloves_13969 = 13969
const val itemChoralCuffs_13970 = 13970
const val itemHuntersBracers_13971 = 13971
const val itemMyochinKote_13972 = 13972
const val itemNinjaTekko_13973 = 13973
const val itemDrachenFngGnt_13974 = 13974
const val itemEvokersBracers_13975 = 13975
const val itemDstMufflers1_13976 = 13976
const val itemLightGauntlets_13977 = 13977
const val itemAimingBracelets_13978 = 13978
const val itemSilverBangles_13979 = 13979
const val itemSilverBangles1_13980 = 13980
const val itemTurtleBangles_13981 = 13981
const val itemTurtleBangles1_13982 = 13982
const val itemGoldBangles_13983 = 13983
const val itemGoldBangles1_13984 = 13984
const val itemPlatinumBangles_13985 = 13985
const val itemPtmBangles1_13986 = 13986
const val itemCoralBangles_13987 = 13987
const val itemMermansBangles_13988 = 13988
const val itemDstGauntlets1_13989 = 13989
const val itemCoralFngGnt1_13990 = 13990
const val itemDragonFGnt1_13991 = 13991
const val itemFeralGloves_13992 = 13992
const val itemToramaGloves_13993 = 13993
const val itemDstMittens1_13994 = 13994
const val itemMermansMittens_13995 = 13995
const val itemKote1_13996 = 13996
const val itemBattleBracers1_13997 = 13997
const val itemWarGloves1_13998 = 13998
const val itemAristocratsMitts_13999 = 13999
const val itemSilkMitts1_14000 = 14000
const val itemIronFngGnt_14001 = 14001
const val itemIronFngGnt1_14002 = 14002
const val itemSteelFngGnt_14003 = 14003
const val itemSteelFngGnt1_14004 = 14004
const val itemMonsoonTekko_14005 = 14005
const val itemZenithMitts_14006 = 14006
const val itemZenithMitts1_14007 = 14007
const val itemCpcGauntlets_14008 = 14008
const val itemCpcGauntlets1_14009 = 14009
const val itemBlackGadlings_14010 = 14010
const val itemOnyxGadlings_14011 = 14011
const val itemThickMufflers1_14012 = 14012
const val itemGndTKGauntlets_14013 = 14013
const val itemGndTKBangles_14014 = 14014
const val itemPrfGloves_14015 = 14015
const val itemMstCstMitts_14016 = 14016
const val itemMstCstBracelets_14017 = 14017
const val itemGigasBracelets_14018 = 14018
const val itemOgygossBrc_14019 = 14019
const val itemEnkeladossBrc_14020 = 14020
const val itemPallassBracelets_14021 = 14021
const val itemAlkyoneussBrc_14022 = 14022
const val itemArhatsTekko_14023 = 14023
const val itemDevoteesMitts_14024 = 14024
const val itemDvtMitts1_14025 = 14025
const val itemHailstormTekko_14026 = 14026
const val itemHailstTekko1_14027 = 14027
const val itemArhatsTekko1_14028 = 14028
const val itemRKMufflers1_14029 = 14029
const val itemRKMufflers2_14030 = 14030
const val itemBastokanMittens_14031 = 14031
const val itemRepublicMittens_14032 = 14032
const val itemSanMufflers_14033 = 14033
const val itemKingdomMufflers_14034 = 14034
const val itemIrnMskGnt1_14035 = 14035
const val itemIrnMskGnt2_14036 = 14036
const val itemSanGloves_14037 = 14037
const val itemKingdomGloves_14038 = 14038
const val itemBasFGauntlets_14039 = 14039
const val itemRepFGauntlets_14040 = 14040
const val itemSusurrusGauntlets_14041 = 14041
const val itemPraedaGauntlets_14042 = 14042
const val itemWindurstianTekko_14043 = 14043
const val itemFederationTekko_14044 = 14044
const val itemWinGloves_14045 = 14045
const val itemFederationGloves_14046 = 14046
const val itemCCMitts1_14047 = 14047
const val itemCCMitts2_14048 = 14048
const val itemTMCuffs1_14049 = 14049
const val itemTMCuffs2_14050 = 14050
const val itemAlumineMoufles_14051 = 14051
const val itemLuisantMoufles_14052 = 14052
const val itemTradersCuffs_14053 = 14053
const val itemBaronsCuffs_14054 = 14054
const val itemUnicornMittens_14055 = 14055
const val itemUcnMittens1_14056 = 14056
const val itemOgreGloves1_14057 = 14057
const val itemCrimsonFngGnt_14058 = 14058
const val itemBloodFngGnt_14059 = 14059
const val itemTimarliDastanas_14060 = 14060
const val itemKaiserHandschuhs_14061 = 14061
const val itemCarbuncleMitts_14062 = 14062
const val itemPrtBangles_14063 = 14063
const val itemSandGloves_14064 = 14064
const val itemGardenBangles_14065 = 14065
const val itemFeroniasBangles_14066 = 14066
const val itemTarasqueMitts_14067 = 14067
const val itemVgdGloves_14068 = 14068
const val itemNomadsGloves_14069 = 14069
const val itemFshGloves_14070 = 14070
const val itemAnglersGloves_14071 = 14071
const val itemChocoboGloves_14072 = 14072
const val itemRidersGloves_14073 = 14073
const val itemTarasqueMitts1_14074 = 14074
const val itemAndvaranauts_14075 = 14075
const val itemHecatombMittens_14076 = 14076
const val itemHctMittens1_14077 = 14077
const val itemErrantCuffs_14078 = 14078
const val itemMahatmaCuffs_14079 = 14079
const val itemStriderBoots_14080 = 14080
const val itemPigaches1_14081 = 14081
const val itemShnKyahan1_14082 = 14082
const val itemScpLeggings1_14083 = 14083
const val itemDstSollerets1_14084 = 14084
const val itemSerpentesSabots_14085 = 14085
const val itemMtlLeggings1_14086 = 14086
const val itemGiltSabatons_14087 = 14087
const val itemBkLedelsens1_14088 = 14088
const val itemFightersCalligae_14089 = 14089
const val itemTempleGaiters_14090 = 14090
const val itemHealersDuckbills_14091 = 14091
const val itemWizardsSabots_14092 = 14092
const val itemWarlocksBoots_14093 = 14093
const val itemRoguesPoulaines_14094 = 14094
const val itemGallantLeggings_14095 = 14095
const val itemChaosSollerets_14096 = 14096
const val itemBeastGaiters_14097 = 14097
const val itemChoralSlippers_14098 = 14098
const val itemHuntersSocks_14099 = 14099
const val itemMyochinSuneAte_14100 = 14100
const val itemNinjaKyahan_14101 = 14101
const val itemDrachenGreaves_14102 = 14102
const val itemEvokersPigaches_14103 = 14103
const val itemBattleBoots1_14104 = 14104
const val itemDstSabatons1_14105 = 14105
const val itemCoralGreaves1_14106 = 14106
const val itemDrgGreaves1_14107 = 14107
const val itemFeralLedelsens_14108 = 14108
const val itemToramaLedelsens_14109 = 14109
const val itemDstLeggings1_14110 = 14110
const val itemMmnLeggings_14111 = 14111
const val itemSuneAte1_14112 = 14112
const val itemWarBoots1_14113 = 14113
const val itemAristoPumps_14114 = 14114
const val itemSilkPumps1_14115 = 14115
const val itemOpalineBoots_14116 = 14116
const val itemRustyLeggings_14117 = 14117
const val itemIronGreaves_14118 = 14118
const val itemIronGreaves1_14119 = 14119
const val itemSteelGreaves_14120 = 14120
const val itemSteelGreaves1_14121 = 14121
const val itemMonsoonKyahan_14122 = 14122
const val itemZenithPumps_14123 = 14123
const val itemZenithPumps1_14124 = 14124
const val itemCeremonialBoots_14125 = 14125
const val itemWeddingBoots_14126 = 14126
const val itemThickSollerets1_14127 = 14127
const val itemKungFuShoes_14128 = 14128
const val itemArhatsSuneAte_14129 = 14129
const val itemWulongShoes_14130 = 14130
const val itemWulongShoes1_14131 = 14131
const val itemWingedBoots_14132 = 14132
const val itemWingedBoots1_14133 = 14133
const val itemAirSolea_14134 = 14134
const val itemAirSolea1_14135 = 14135
const val itemArhSuneAte1_14136 = 14136
const val itemRKSollerets1_14137 = 14137
const val itemRKSollerets2_14138 = 14138
const val itemBasLeggings_14139 = 14139
const val itemRepublicLeggings_14140 = 14140
const val itemSanSollerets_14141 = 14141
const val itemKingdomSollerets_14142 = 14142
const val itemIrnMskSbtn1_14143 = 14143
const val itemIrnMskSbtn2_14144 = 14144
const val itemSandOrianBoots_14145 = 14145
const val itemKingdomBoots_14146 = 14146
const val itemBastokanGreaves_14147 = 14147
const val itemRepublicGreaves_14148 = 14148
const val itemSandOrianClogs_14149 = 14149
const val itemKingdomClogs_14150 = 14150
const val itemWinKyahan_14151 = 14151
const val itemFedKyahan_14152 = 14152
const val itemWinGaiters_14153 = 14153
const val itemFederationGaiters_14154 = 14154
const val itemCCShoes1_14155 = 14155
const val itemCCShoes2_14156 = 14156
const val itemTMPigaches1_14157 = 14157
const val itemTMPigaches2_14158 = 14158
const val itemOgreLedelsens1_14159 = 14159
const val itemCrimsonGreaves_14160 = 14160
const val itemBloodGreaves_14161 = 14161
const val itemAgronasLeggings_14162 = 14162
const val itemKaiserSchuhs_14163 = 14163
const val itemInfernoSabots_14164 = 14164
const val itemInfernoSabots1_14165 = 14165
const val itemDesertBoots_14166 = 14166
const val itemDesertBoots1_14167 = 14167
const val itemDuneBoots_14168 = 14168
const val itemVagabondsBoots_14169 = 14169
const val itemNomadsBoots_14170 = 14170
const val itemFishermansBoots_14171 = 14171
const val itemAnglersBoots_14172 = 14172
const val itemChocoboBoots_14173 = 14173
const val itemRidersBoots_14174 = 14174
const val itemArmadaSollerets_14175 = 14175
const val itemFieldBoots_14176 = 14176
const val itemWorkerBoots_14177 = 14177
const val itemRasetsuSuneAte_14178 = 14178
const val itemRstSuneAte1_14179 = 14179
const val itemHctLeggings_14180 = 14180
const val itemHctLeggings1_14181 = 14181
const val itemErrantPigaches_14182 = 14182
const val itemMahatmaPigaches_14183 = 14183
const val itemShuraSuneAte_14184 = 14184
const val itemShrSuneAte1_14185 = 14185
const val itemDragonLeggings_14186 = 14186
const val itemDrnLeggings1_14187 = 14187
const val itemDuskLedelsens1_14188 = 14188
const val itemAustereSabots_14189 = 14189
const val itemPenanceSabots_14190 = 14190
const val itemHeroicBoots_14191 = 14191
const val itemHeroicBoots1_14192 = 14192
const val itemGemSabatons_14193 = 14193
const val itemGavialGreaves1_14194 = 14194
const val itemWaders_14195 = 14195
const val itemDanceShoes_14196 = 14196
const val itemDanceShoes1_14197 = 14197
const val itemMarineMBoots_14198 = 14198
const val itemMarineFBoots_14199 = 14199
const val itemWoodMLedelsens_14200 = 14200
const val itemWoodFLedelsens_14201 = 14201
const val itemCreekMClomps_14202 = 14202
const val itemCreekFClomps_14203 = 14203
const val itemRiverGaiters_14204 = 14204
const val itemDuneSandals_14205 = 14205
const val itemGarrisonBoots_14206 = 14206
const val itemNoctGaiters1_14207 = 14207
const val itemScpSubligar1_14208 = 14208
const val itemDstBreeches1_14209 = 14209
const val itemPerleBrayettes_14210 = 14210
const val itemMythrilCuisses1_14211 = 14211
const val itemGiltCuisses_14212 = 14212
const val itemBeakTrousers1_14213 = 14213
const val itemFightersCuisses_14214 = 14214
const val itemTempleHose_14215 = 14215
const val itemHealersPantaln_14216 = 14216
const val itemWizardsTonban_14217 = 14217
const val itemWarlocksTights_14218 = 14218
const val itemRoguesCulottes_14219 = 14219
const val itemGallantBreeches_14220 = 14220
const val itemChaosFlanchard_14221 = 14221
const val itemBeastTrousers_14222 = 14222
const val itemChoralCannions_14223 = 14223
const val itemHuntersBraccae_14224 = 14224
const val itemMyochinHaidate_14225 = 14225
const val itemNinjaHakama_14226 = 14226
const val itemDrachenBrais_14227 = 14227
const val itemEvokersSpats_14228 = 14228
const val itemDstCuisses1_14229 = 14229
const val itemCoralCuisses1_14230 = 14230
const val itemDragonCuisses1_14231 = 14231
const val itemFeralTrousers_14232 = 14232
const val itemToramaTrousers_14233 = 14233
const val itemDstSubligar1_14234 = 14234
const val itemMermansSubligar_14235 = 14235
const val itemHaidate1_14236 = 14236
const val itemBattleHose1_14237 = 14237
const val itemWarBrais1_14238 = 14238
const val itemAristoSlacks_14239 = 14239
const val itemSilkSlacks1_14240 = 14240
const val itemPortentPants_14241 = 14241
const val itemRustySubligar_14242 = 14242
const val itemIronCuisses_14243 = 14243
const val itemIronCuisses1_14244 = 14244
const val itemSteelCuisses_14245 = 14245
const val itemSteelCuisses1_14246 = 14246
const val itemZenithSlacks_14247 = 14247
const val itemZenithSlacks1_14248 = 14248
const val itemOpalineHose_14249 = 14249
const val itemCeremonialHose_14250 = 14250
const val itemWeddingHose_14251 = 14251
const val itemThickBreeches1_14252 = 14252
const val itemArhatsHakama_14253 = 14253
const val itemMastersSitabaki_14254 = 14254
const val itemMstSitabaki1_14255 = 14255
const val itemArhatsHakama1_14256 = 14256
const val itemAuroreBrais_14257 = 14257
const val itemTealSlops_14258 = 14258
const val itemBastokanSubligar_14259 = 14259
const val itemRepublicSubligar_14260 = 14260
const val itemRylSqrBrch1_14261 = 14261
const val itemRylSqrBrch2_14262 = 14262
const val itemIMCuisses1_14263 = 14263
const val itemIMCuisses2_14264 = 14264
const val itemSanTrousers_14265 = 14265
const val itemKingdomTrousers_14266 = 14266
const val itemBastokanCuisses_14267 = 14267
const val itemRepublicCuisses_14268 = 14268
const val itemWinSitabaki_14269 = 14269
const val itemFedSitabaki_14270 = 14270
const val itemWindurstianBrais_14271 = 14271
const val itemFederationBrais_14272 = 14272
const val itemWindurstianSlops_14273 = 14273
const val itemFederationSlops_14274 = 14274
const val itemCCSlacks1_14275 = 14275
const val itemCCSlacks2_14276 = 14276
const val itemTMSlops1_14277 = 14277
const val itemTMSlops2_14278 = 14278
const val itemOgreTrousers1_14279 = 14279
const val itemCrimsonCuisses_14280 = 14280
const val itemBloodCuisses_14281 = 14281
const val itemArcaneSlops_14282 = 14282
const val itemKaiserDiechlings_14283 = 14283
const val itemNorthernJerkin_14284 = 14284
const val itemTundraJerkin_14285 = 14285
const val itemFrogTrousers_14286 = 14286
const val itemLunaSubligar_14287 = 14287
const val itemClownsSubligar_14288 = 14288
const val itemClnSubligar1_14289 = 14289
const val itemVagabondsHose_14290 = 14290
const val itemNomadsHose_14291 = 14291
const val itemFishermansHose_14292 = 14292
const val itemAnglersHose_14293 = 14293
const val itemChocoboHose_14294 = 14294
const val itemRidersHose_14295 = 14295
const val itemArmadaBreeches_14296 = 14296
const val itemFieldHose_14297 = 14297
const val itemWorkerHose_14298 = 14298
const val itemRstHakama_14299 = 14299
const val itemRstHakama1_14300 = 14300
const val itemErrantSlops_14301 = 14301
const val itemMahatmaSlops_14302 = 14302
const val itemShuraHaidate_14303 = 14303
const val itemShuraHaidate1_14304 = 14304
const val itemDragonSubligar_14305 = 14305
const val itemDrnSubligar1_14306 = 14306
const val itemDuskTrousers1_14307 = 14307
const val itemHecatombSubligar_14308 = 14308
const val itemHctSubligar1_14309 = 14309
const val itemAustereSlops_14310 = 14310
const val itemPenanceSlops_14311 = 14311
const val itemGemCuisses_14312 = 14312
const val itemGavialCuisses1_14313 = 14313
const val itemGarrisonHose_14314 = 14314
const val itemShairSeraweels_14315 = 14315
const val itemSheikhSeraweels_14316 = 14316
const val itemBaroneCosciales_14317 = 14317
const val itemConteCosciales_14318 = 14318
const val itemBisonKecks_14319 = 14319
const val itemBravesKecks_14320 = 14320
const val itemIgqiraLappas_14321 = 14321
const val itemGenieLappas_14322 = 14322
const val itemNoctBrais_14323 = 14323
const val itemMistSlacks_14324 = 14324
const val itemSeersSlacks_14325 = 14325
const val itemGarishSlacks_14326 = 14326
const val itemShadeTights_14327 = 14327
const val itemSeersSlacks1_14328 = 14328
const val itemEisendiechlings_14329 = 14329
const val itemRubiousSlacks_14330 = 14330
const val itemShadeTights1_14331 = 14331
const val itemKampfdiechlings_14332 = 14332
const val itemNoctBrais1_14333 = 14333
const val itemShmHaidate_14334 = 14334
const val itemNokizaruHakama_14335 = 14335
const val itemJuogi_14336 = 14336
const val itemLokisKaftan_14337 = 14337
const val itemBastokanHarness_14338 = 14338
const val itemRepublicHarness_14339 = 14339
const val itemRylSqrChnml1_14340 = 14340
const val itemRylSqrChnml2_14341 = 14341
const val itemIMCuirass1_14342 = 14342
const val itemIMCuirass2_14343 = 14343
const val itemSandOrianVest_14344 = 14344
const val itemKingdomVest_14345 = 14345
const val itemBasScaleMail_14346 = 14346
const val itemRepScaleMail_14347 = 14347
const val itemSandOrianTunic_14348 = 14348
const val itemKingdomTunic_14349 = 14349
const val itemWindurstianGi_14350 = 14350
const val itemFederationGi_14351 = 14351
const val itemWinDoublet_14352 = 14352
const val itemFedDoublet_14353 = 14353
const val itemCCCloak1_14354 = 14354
const val itemCCCloak2_14355 = 14355
const val itemIrnMskGmbsn1_14356 = 14356
const val itemIrnMskGmbsn2_14357 = 14357
const val itemRylSqrRobe1_14358 = 14358
const val itemRylSqrRobe2_14359 = 14359
const val itemRKCloak1_14360 = 14360
const val itemRKCloak2_14361 = 14361
const val itemTMCoat1_14362 = 14362
const val itemTMCoat2_14363 = 14363
const val itemYhelJacket_14364 = 14364
const val itemAugursJaseran_14365 = 14365
const val itemOgreJerkin1_14366 = 14366
const val itemCrmScaleMail_14367 = 14367
const val itemBloodScaleMail_14368 = 14368
const val itemArcaneRobe_14369 = 14369
const val itemKaiserCuirass_14370 = 14370
const val itemArmadaHauberk_14371 = 14371
const val itemCardinalVest_14372 = 14372
const val itemBachelorVest_14373 = 14373
const val itemFieldTunica_14374 = 14374
const val itemWorkerTunica_14375 = 14375
const val itemRasetsuSamue_14376 = 14376
const val itemRasetsuSamue1_14377 = 14377
const val itemHecatombHarness_14378 = 14378
const val itemHctHarness1_14379 = 14379
const val itemErrantHpl_14380 = 14380
const val itemMahatmaHpl_14381 = 14381
const val itemPlastron_14382 = 14382
const val itemPlastron1_14383 = 14383
const val itemOpalineDress_14384 = 14384
const val itemCeremonialDress_14385 = 14385
const val itemWeddingDress_14386 = 14386
const val itemShuraTogi_14387 = 14387
const val itemShuraTogi1_14388 = 14388
const val itemDragonHarness_14389 = 14389
const val itemDragonHarness1_14390 = 14390
const val itemDuskJerkin1_14391 = 14391
const val itemCarpentersApron_14392 = 14392
const val itemBlacksmithsApn_14393 = 14393
const val itemGoldsmithsApron_14394 = 14394
const val itemWeaversApron_14395 = 14395
const val itemTannersApron_14396 = 14396
const val itemBoneworkersApn_14397 = 14397
const val itemAlchemistsApron_14398 = 14398
const val itemCulinariansApron_14399 = 14399
const val itemFishermansApron_14400 = 14400
const val itemDuendeCotehardie_14401 = 14401
const val itemNokizaruGi_14402 = 14402
const val itemRappareeHarness_14403 = 14403
const val itemShmHaraAte_14404 = 14404
const val itemWyvernMail_14405 = 14405
const val itemShikareeAketon_14406 = 14406
const val itemCeriseDoublet_14407 = 14407
const val itemGlamorJupon_14408 = 14408
const val itemGloomBreastplate_14409 = 14409
const val itemNimbusDoublet_14410 = 14410
const val itemAikidoGi_14411 = 14411
const val itemParadeCuirass_14412 = 14412
const val itemGaudyHarness_14413 = 14413
const val itemShairManteel_14414 = 14414
const val itemSheikhManteel_14415 = 14415
const val itemBaroneCorazza_14416 = 14416
const val itemConteCorazza_14417 = 14417
const val itemBisonJacket_14418 = 14418
const val itemBravesJacket_14419 = 14419
const val itemIgqiraWeskit_14420 = 14420
const val itemGenieWeskit_14421 = 14421
const val itemNoctDoublet_14422 = 14422
const val itemMistTunic_14423 = 14423
const val itemSeersTunic_14424 = 14424
const val itemGarishTunic_14425 = 14425
const val itemShadeHarness_14426 = 14426
const val itemSeersTunic1_14427 = 14427
const val itemKingdomAketon_14428 = 14428
const val itemRepublicAketon_14429 = 14429
const val itemFederationAketon_14430 = 14430
const val itemEisenbrust_14431 = 14431
const val itemRubiousTunic_14432 = 14432
const val itemShadeHarness1_14433 = 14433
const val itemNoctDoublet1_14434 = 14434
const val itemKampfbrust_14435 = 14435
const val itemBlessedBliaut_14436 = 14436
const val itemHachimanDomaru_14437 = 14437
const val itemBlessedBliaut1_14438 = 14438
const val itemHmnDomaru1_14439 = 14439
const val itemChasuble_14440 = 14440
const val itemChasuble1_14441 = 14441
const val itemYashaSamue1_14442 = 14442
const val itemVampireCloak_14443 = 14443
const val itemAlumineHaubert_14444 = 14444
const val itemLuisantHaubert_14445 = 14445
const val itemTradersSaio_14446 = 14446
const val itemBaronsSaio_14447 = 14447
const val itemUnicornHarness_14448 = 14448
const val itemUcnHarness1_14449 = 14449
const val itemHumeGilet_14450 = 14450
const val itemHumeTop_14451 = 14451
const val itemElvaanGilet_14452 = 14452
const val itemElvaanTop_14453 = 14453
const val itemTarutaruMaillot_14454 = 14454
const val itemMithraTop_14455 = 14455
const val itemGalkaGilet_14456 = 14456
const val itemHumeGilet1_14457 = 14457
const val itemHumeTop1_14458 = 14458
const val itemElvaanGilet1_14459 = 14459
const val itemElvaanTop1_14460 = 14460
const val itemTaruMaillot1_14461 = 14461
const val itemMithraTop1_14462 = 14462
const val itemGalkaGilet1_14463 = 14463
const val itemTrailersTunica_14464 = 14464
const val itemNanbanKariginu_14465 = 14465
const val itemFomorTunic_14466 = 14466
const val itemArchersJupon_14467 = 14467
const val itemYinyangRobe_14468 = 14468
const val itemReverendMail_14469 = 14469
const val itemAssaultBrstplate_14470 = 14470
const val itemTarutaruTop_14471 = 14471
const val itemTarutaruTop1_14472 = 14472
const val itemFtrLorica1_14473 = 14473
const val itemTplCyclas1_14474 = 14474
const val itemHlrBliaut1_14475 = 14475
const val itemWzdCoat1_14476 = 14476
const val itemWlkTabard1_14477 = 14477
const val itemRogVest1_14478 = 14478
const val itemGltSurcoat1_14479 = 14479
const val itemChsCuirass1_14480 = 14480
const val itemBstJackcoat1_14481 = 14481
const val itemChlJstcorps1_14482 = 14482
const val itemHtrJerkin1_14483 = 14483
const val itemMynDomaru1_14484 = 14484
const val itemNinChainmail1_14485 = 14485
const val itemDrnMail1_14486 = 14486
const val itemEvkDoublet1_14487 = 14487
const val itemHomamCorazza_14488 = 14488
const val itemNashiraManteel_14489 = 14489
const val itemManaTunic_14490 = 14490
const val itemManaCloak_14491 = 14491
const val itemHighManaCloak_14492 = 14492
const val itemHealingVest_14493 = 14493
const val itemHealingMail_14494 = 14494
const val itemHealingHarness_14495 = 14495
const val itemHealingJstcorps_14496 = 14496
const val itemHighHealHarness_14497 = 14497
const val itemCrowJupon_14498 = 14498
const val itemRavenJupon_14499 = 14499
const val itemWarLorica1_14500 = 14500
const val itemMelCyclas1_14501 = 14501
const val itemClrBliaut1_14502 = 14502
const val itemSrcCoat1_14503 = 14503
const val itemDlsTabard1_14504 = 14504
const val itemAsnVest1_14505 = 14505
const val itemVlrSurcoat1_14506 = 14506
const val itemAbsCuirass1_14507 = 14507
const val itemMstJackcoat1_14508 = 14508
const val itemBrdJstcorps1_14509 = 14509
const val itemSctJerkin1_14510 = 14510
const val itemSaoDomaru1_14511 = 14511
const val itemKogChainmail1_14512 = 14512
const val itemWymMail1_14513 = 14513
const val itemSmnDoublet1_14514 = 14514
const val itemHydraDoublet_14515 = 14515
const val itemHydraHarness_14516 = 14516
const val itemHydraHaubert_14517 = 14517
const val itemHydraJupon_14518 = 14518
const val itemDreamRobe_14519 = 14519
const val itemDreamRobe1_14520 = 14520
const val itemMagusJubbah_14521 = 14521
const val itemCorsairsFrac_14522 = 14522
const val itemPupTobe_14523 = 14523
const val itemSipahiJawshan_14524 = 14524
const val itemAmirKorazin_14525 = 14525
const val itemJaridahPeti_14526 = 14526
const val itemYigitGomlek_14527 = 14527
const val itemAbtalJawshan_14528 = 14528
const val itemAkinjiPeti_14529 = 14529
const val itemPlnKhazagand_14530 = 14530
const val itemBannaretMail_14531 = 14531
const val itemOtokoYukata_14532 = 14532
const val itemOnagoYukata_14533 = 14533
const val itemOtokogimiYukata_14534 = 14534
const val itemOnnagimiYukata_14535 = 14535
const val itemArakanSamue_14536 = 14536
const val itemHydraMail_14537 = 14537
const val itemHydraMail1_14538 = 14538
const val itemKyudogi_14539 = 14539
const val itemKyudogi1_14540 = 14540
const val itemTaikyokuKenpogi_14541 = 14541
const val itemSilkenCoat_14542 = 14542
const val itemMagiCoat_14543 = 14543
const val itemCorselet_14544 = 14544
const val itemCorselet1_14545 = 14545
const val itemAresCuirass_14546 = 14546
const val itemEnyosBrstplate_14547 = 14547
const val itemPhobossCuirass_14548 = 14548
const val itemDeimossCuirass_14549 = 14549
const val itemSkadisCuirie_14550 = 14550
const val itemNjordsJerkin_14551 = 14551
const val itemFreyrsJerkin_14552 = 14552
const val itemFreyasJerkin_14553 = 14553
const val itemUsukaneHaramaki_14554 = 14554
const val itemHoshikazuGi_14555 = 14555
const val itemTsukikazuTogi_14556 = 14556
const val itemHikazuHaraAte_14557 = 14557
const val itemMarduksJubbah_14558 = 14558
const val itemAnusDoublet_14559 = 14559
const val itemEasDoublet_14560 = 14560
const val itemEnlilsGambison_14561 = 14561
const val itemMorrigansRobe_14562 = 14562
const val itemNemainsRobe_14563 = 14563
const val itemBodbsRobe_14564 = 14564
const val itemMachasCoat_14565 = 14565
const val itemKhimairaJacket_14566 = 14566
const val itemStoutJacket_14567 = 14567
const val itemAskarKorazin_14568 = 14568
const val itemDenaliJacket_14569 = 14569
const val itemGoliardSaio_14570 = 14570
const val itemTabinJupon_14571 = 14571
const val itemTabinJupon1_14572 = 14572
const val itemShadowBrstplate_14573 = 14573
const val itemValkBreastplate_14574 = 14574
const val itemShadowCoat_14575 = 14575
const val itemValkyriesCoat_14576 = 14576
const val itemValhallaBrstplate_14577 = 14577
const val itemDancersCasaque_14578 = 14578
const val itemDancersCasaque_14579 = 14579
const val itemScholarsGown_14580 = 14580
const val itemIRChainmail_14581 = 14581
const val itemFourthCuirass_14582 = 14582
const val itemCobraCoat_14583 = 14583
const val itemIRJackCoat_14584 = 14584
const val itemFourthTunica_14585 = 14585
const val itemCobraTunica_14586 = 14586
const val itemPilgrimTunica_14587 = 14587
const val itemIronRamHauberk_14588 = 14588
const val itemFourthBrunne_14589 = 14589
const val itemCobraHarness_14590 = 14590
const val itemCobraRobe_14591 = 14591
const val itemReflexRing1_14592 = 14592
const val itemCourageRing1_14593 = 14593
const val itemKldgRing1_14594 = 14594
const val itemBalanceRing1_14595 = 14595
const val itemTrqRing1_14596 = 14596
const val itemStaminaRing1_14597 = 14597
const val itemEnergyRing1_14598 = 14598
const val itemHopeRing1_14599 = 14599
const val itemAlacrityRing1_14600 = 14600
const val itemPuissanceRing1_14601 = 14601
const val itemWisdomRing1_14602 = 14602
const val itemDeftRing1_14603 = 14603
const val itemSolaceRing1_14604 = 14604
const val itemVerveRing1_14605 = 14605
const val itemAuraRing1_14606 = 14606
const val itemLoyaltyRing1_14607 = 14607
const val itemCelerityRing1_14608 = 14608
const val itemVictoryRing1_14609 = 14609
const val itemGeniusRing1_14610 = 14610
const val itemGraceRing1_14611 = 14611
const val itemSerenityRing1_14612 = 14612
const val itemVigorRing1_14613 = 14613
const val itemMysticRing1_14614 = 14614
const val itemAllureRing1_14615 = 14615
const val itemTritonRing_14616 = 14616
const val itemNimbleRing1_14617 = 14617
const val itemTriumphRing1_14618 = 14618
const val itemOmnRing1_14619 = 14619
const val itemAdroitRing1_14620 = 14620
const val itemCmnRing1_14621 = 14621
const val itemRobustRing1_14622 = 14622
const val itemHadesRing1_14623 = 14623
const val itemHeavensRing1_14624 = 14624
const val itemEvokersRing_14625 = 14625
const val itemMermaidRing_14626 = 14626
const val itemDragonRing1_14627 = 14627
const val itemCastorsRing_14628 = 14628
const val itemPolluxsRing_14629 = 14629
const val itemFlameRing_14630 = 14630
const val itemVulcansRing_14631 = 14631
const val itemAquaRing_14632 = 14632
const val itemNeptunesRing_14633 = 14633
const val itemSoilRing_14634 = 14634
const val itemTerrasRing_14635 = 14635
const val itemBreezeRing_14636 = 14636
const val itemAustersRing_14637 = 14637
const val itemThunderRing_14638 = 14638
const val itemJupitersRing_14639 = 14639
const val itemSnowRing_14640 = 14640
const val itemAquilosRing_14641 = 14641
const val itemLightRing_14642 = 14642
const val itemApollosRing_14643 = 14643
const val itemDarkRing_14644 = 14644
const val itemPlutosRing_14645 = 14645
const val itemShadowRing_14646 = 14646
const val itemCastorsRing_14647 = 14647
const val itemPolluxsRing_14648 = 14648
const val itemTelluricRing_14649 = 14649
const val itemMarksmansRing_14650 = 14650
const val itemManaRing_14651 = 14651
const val itemProteanRing_14652 = 14652
const val itemVariableRing_14653 = 14653
const val itemPoisonaRing_14654 = 14654
const val itemVenererRing_14655 = 14655
const val itemPoseidonsRing_14656 = 14656
const val itemDclGrdRing_14657 = 14657
const val itemAtlauasRing_14658 = 14658
const val itemHerculesRing_14659 = 14659
const val itemBowyerRing_14660 = 14660
const val itemHollaRing_14661 = 14661
const val itemDemRing_14662 = 14662
const val itemMeaRing_14663 = 14663
const val itemVahzlRing_14664 = 14664
const val itemYhoatRing_14665 = 14665
const val itemAltepRing_14666 = 14666
const val itemCarectRing_14667 = 14667
const val itemZoredoniteRing_14668 = 14668
const val itemJaegerRing_14669 = 14669
const val itemSafeguardRing_14670 = 14670
const val itemAlliedRing_14671 = 14671
const val itemTavnazianRing_14672 = 14672
const val itemSereneRing_14673 = 14673
const val itemToreadorsRing_14674 = 14674
const val itemWoodsmanRing_14675 = 14675
const val itemAssailantsRing_14676 = 14676
const val itemSanationRing_14677 = 14677
const val itemAssassinsRing_14678 = 14678
const val itemTacticalRing_14679 = 14679
const val itemPacifistRing_14680 = 14680
const val itemGetsulRing_14681 = 14681
const val itemKshamaRingNo2_14682 = 14682
const val itemKshamaRingNo4_14683 = 14683
const val itemKshamaRingNo3_14684 = 14684
const val itemKshamaRingNo5_14685 = 14685
const val itemKshamaRingNo9_14686 = 14686
const val itemKshamaRingNo6_14687 = 14687
const val itemReflexEarring1_14688 = 14688
const val itemCrgEarring1_14689 = 14689
const val itemKldgEarring1_14690 = 14690
const val itemBlcEarring1_14691 = 14691
const val itemTrqEarring1_14692 = 14692
const val itemStmEarring1_14693 = 14693
const val itemEnergyEarring1_14694 = 14694
const val itemHopeEarring1_14695 = 14695
const val itemAlcEarring1_14696 = 14696
const val itemPuisEarring1_14697 = 14697
const val itemWisdomEarring1_14698 = 14698
const val itemDeftEarring1_14699 = 14699
const val itemSolaceEarring1_14700 = 14700
const val itemVerveEarring1_14701 = 14701
const val itemAuraEarring1_14702 = 14702
const val itemLytEarring1_14703 = 14703
const val itemCelEarring1_14704 = 14704
const val itemVictoryEarring1_14705 = 14705
const val itemGeniusEarring1_14706 = 14706
const val itemGraceEarring1_14707 = 14707
const val itemSerEarring1_14708 = 14708
const val itemVigorEarring1_14709 = 14709
const val itemManaEarring1_14710 = 14710
const val itemAllureEarring1_14711 = 14711
const val itemNimbleEarring1_14712 = 14712
const val itemTmphEarring1_14713 = 14713
const val itemOmnEarring1_14714 = 14714
const val itemAdroitEarring1_14715 = 14715
const val itemCmnEarring1_14716 = 14716
const val itemRobustEarring1_14717 = 14717
const val itemHadesEarring1_14718 = 14718
const val itemHvnEarring1_14719 = 14719
const val itemMorionEarring_14720 = 14720
const val itemMorionEarring1_14721 = 14721
const val itemPigeonEarring_14722 = 14722
const val itemPigeonEarring1_14723 = 14723
const val itemMoldaviteEarring_14724 = 14724
const val itemMelodyEarring_14725 = 14725
const val itemMelodyEarring1_14726 = 14726
const val itemPhantomEarring_14727 = 14727
const val itemPhtmEarring1_14728 = 14728
const val itemPilferersEarring_14729 = 14729
const val itemEsquiresEarring_14730 = 14730
const val itemKillerEarring_14731 = 14731
const val itemTrimmersEarring_14732 = 14732
const val itemSingersEarring_14733 = 14733
const val itemBeatersEarring_14734 = 14734
const val itemAshigaruEarring_14735 = 14735
const val itemGeninEarring_14736 = 14736
const val itemWyvernEarring_14737 = 14737
const val itemMagiciansEarring_14738 = 14738
const val itemSuppanomimi_14739 = 14739
const val itemKnightsEarring_14740 = 14740
const val itemAbyssalEarring_14741 = 14741
const val itemBeastlyEarring_14742 = 14742
const val itemBushinomimi_14743 = 14743
const val itemUndeadEarring_14744 = 14744
const val itemArcanaEarring_14745 = 14745
const val itemVerminEarring_14746 = 14746
const val itemBirdEarring_14747 = 14747
const val itemAmorphEarring_14748 = 14748
const val itemLizardEarring_14749 = 14749
const val itemAquanEarring_14750 = 14750
const val itemPlantoidEarring_14751 = 14751
const val itemBeastEarring_14752 = 14752
const val itemDemonEarring_14753 = 14753
const val itemDragonEarring_14754 = 14754
const val itemRefreshEarring_14755 = 14755
const val itemAccurateEarring_14756 = 14756
const val itemMecurialEarring_14757 = 14757
const val itemKnightlyEarring_14758 = 14758
const val itemCuragaEarring_14759 = 14759
const val itemCunningEarring_14760 = 14760
const val itemElusiveEarring_14761 = 14761
const val itemAttilasEarring_14762 = 14762
const val itemBorokaEarring_14763 = 14763
const val itemMinuetEarring_14764 = 14764
const val itemTitanisEarring_14765 = 14765
const val itemGeistEarring_14766 = 14766
const val itemEvasionEarring_14767 = 14767
const val itemParryingEarring_14768 = 14768
const val itemBucklerEarring_14769 = 14769
const val itemGuardingEarring_14770 = 14770
const val itemDivineEarring_14771 = 14771
const val itemDarkEarring_14772 = 14772
const val itemAugmentEarring_14773 = 14773
const val itemEnfeeblingEarring_14774 = 14774
const val itemElementalEarring_14775 = 14775
const val itemHealingEarring_14776 = 14776
const val itemSmnEarring_14777 = 14777
const val itemNinjutsuEarring_14778 = 14778
const val itemSingingEarring_14779 = 14779
const val itemStringEarring_14780 = 14780
const val itemWindEarring_14781 = 14781
const val itemAstralEarring_14782 = 14782
const val itemVampireEarring_14783 = 14783
const val itemSanghaEarring_14784 = 14784
const val itemJanizaryEarring_14785 = 14785
const val itemCounterEarring_14786 = 14786
const val itemDeadeyeEarring_14787 = 14787
const val itemGamusharaEarring_14788 = 14788
const val itemNarukoEarring_14789 = 14789
const val itemReraiseEarring_14790 = 14790
const val itemSanativeEarring_14791 = 14791
const val itemRelaxingEarring_14792 = 14792
const val itemBelinkysEarring_14793 = 14793
const val itemQuantzsEarring_14794 = 14794
const val itemDesamilionEarring_14795 = 14795
const val itemMelninasEarring_14796 = 14796
const val itemWaetotosEarring_14797 = 14797
const val itemMorukakaEarring_14798 = 14798
const val itemRyakhosEarring_14799 = 14799
const val itemFeyuhsEarring_14800 = 14800
const val itemZedomasEarring_14801 = 14801
const val itemGayanjsEarring_14802 = 14802
const val itemOpticalEarring_14803 = 14803
const val itemHarvestEarring_14804 = 14804
const val itemHeimsEarring_14805 = 14805
const val itemIntruderEarring_14806 = 14806
const val itemHospitalerEarring_14807 = 14807
const val itemNovioEarring_14808 = 14808
const val itemNoviaEarring_14809 = 14809
const val itemSignalPearl_14810 = 14810
const val itemTacticsPearl_14811 = 14811
const val itemLoquacEarring_14812 = 14812
const val itemBrutalEarring_14813 = 14813
const val itemDiabolossEarring_14814 = 14814
const val itemStealthEarring_14815 = 14815
const val itemArmadaMufflers_14816 = 14816
const val itemFieldGloves_14817 = 14817
const val itemWorkerGloves_14818 = 14818
const val itemRasetsuTekko_14819 = 14819
const val itemRasetsuTekko1_14820 = 14820
const val itemShuraKote_14821 = 14821
const val itemShuraKote1_14822 = 14822
const val itemDragonMittens_14823 = 14823
const val itemDragonMittens1_14824 = 14824
const val itemDuskGloves1_14825 = 14825
const val itemAustereCuffs_14826 = 14826
const val itemPenanceCuffs_14827 = 14827
const val itemGemGauntlets_14828 = 14828
const val itemGavialFngGnt1_14829 = 14829
const val itemCarpentersGloves_14830 = 14830
const val itemSmithysMitts_14831 = 14831
const val itemTannersGloves_14832 = 14832
const val itemMarineMGloves_14833 = 14833
const val itemMarineFGloves_14834 = 14834
const val itemWoodGauntlets_14835 = 14835
const val itemWoodGloves_14836 = 14836
const val itemCreekMMitts_14837 = 14837
const val itemCreekFMitts_14838 = 14838
const val itemRiverGauntlets_14839 = 14839
const val itemDuneBracers_14840 = 14840
const val itemGarrisonGloves_14841 = 14841
const val itemIvoryMitts_14842 = 14842
const val itemSpikedFngGnt_14843 = 14843
const val itemRushGloves_14844 = 14844
const val itemSlyGauntlets_14845 = 14845
const val itemShairGages_14846 = 14846
const val itemSheikhGages_14847 = 14847
const val itemBaroneManopolas_14848 = 14848
const val itemConteManopolas_14849 = 14849
const val itemBisonWristbands_14850 = 14850
const val itemBrvWristbands_14851 = 14851
const val itemIgqiraManillas_14852 = 14852
const val itemGenieManillas_14853 = 14853
const val itemNoctGloves_14854 = 14854
const val itemMistMitts_14855 = 14855
const val itemSeersMitts_14856 = 14856
const val itemGarishMitts_14857 = 14857
const val itemShadeMittens_14858 = 14858
const val itemSeersMitts1_14859 = 14859
const val itemEisenhentzes_14860 = 14860
const val itemRubiousMitts_14861 = 14861
const val itemShadeMittens1_14862 = 14862
const val itemKampfhentzes_14863 = 14863
const val itemPalmersBangles_14864 = 14864
const val itemNoctGloves1_14865 = 14865
const val itemConcealingCuffs_14866 = 14866
const val itemMagicalMitts_14867 = 14867
const val itemArcaneCuffs_14868 = 14868
const val itemNoritsuneKote_14869 = 14869
const val itemTrainersWrist_14870 = 14870
const val itemTrainersGloves_14871 = 14871
const val itemOstregerMitts_14872 = 14872
const val itemBandomushaKote_14873 = 14873
const val itemHoromushaKote_14874 = 14874
const val itemBlessedMitts_14875 = 14875
const val itemHachimanKote_14876 = 14876
const val itemBlessedMitts1_14877 = 14877
const val itemHachimanKote1_14878 = 14878
const val itemLordsGauntlets_14879 = 14879
const val itemWiseGloves_14880 = 14880
const val itemWiseGloves1_14881 = 14881
const val itemYashaTekko1_14882 = 14882
const val itemKingsGauntlets_14883 = 14883
const val itemMycophileCuffs_14884 = 14884
const val itemSennightBangles_14885 = 14885
const val itemHeavyGauntlets_14886 = 14886
const val itemOcelotGloves_14887 = 14887
const val itemAugursGloves_14888 = 14888
const val itemBarbarianMittens_14889 = 14889
const val itemFtrMufflers1_14890 = 14890
const val itemTplGloves1_14891 = 14891
const val itemHlrMitts1_14892 = 14892
const val itemWzdGloves1_14893 = 14893
const val itemWlkGloves1_14894 = 14894
const val itemRogArmlets1_14895 = 14895
const val itemGltGauntlets1_14896 = 14896
const val itemChsGauntlets1_14897 = 14897
const val itemBstGloves1_14898 = 14898
const val itemChlCuffs1_14899 = 14899
const val itemHtrBracers1_14900 = 14900
const val itemMynKote1_14901 = 14901
const val itemNinTekko1_14902 = 14902
const val itemDrnFngGnt1_14903 = 14903
const val itemEvkBracers1_14904 = 14904
const val itemHomamManopolas_14905 = 14905
const val itemNashiraGages_14906 = 14906
const val itemCrowBracers_14907 = 14907
const val itemRavenBracers_14908 = 14908
const val itemWarMufflers1_14909 = 14909
const val itemMelGloves1_14910 = 14910
const val itemClrMitts1_14911 = 14911
const val itemSrcGloves1_14912 = 14912
const val itemDlsGloves1_14913 = 14913
const val itemAsnArmlets1_14914 = 14914
const val itemVlrGauntlets1_14915 = 14915
const val itemAbsGauntlets1_14916 = 14916
const val itemMstGloves1_14917 = 14917
const val itemBrdCuffs1_14918 = 14918
const val itemSctBracers1_14919 = 14919
const val itemSaoKote1_14920 = 14920
const val itemKogTekko1_14921 = 14921
const val itemWymFngGnt1_14922 = 14922
const val itemSmnBracers1_14923 = 14923
const val itemHydraGloves_14924 = 14924
const val itemHydraMittens_14925 = 14925
const val itemHydraMoufles_14926 = 14926
const val itemHydraBracers_14927 = 14927
const val itemMagusBazubands_14928 = 14928
const val itemCorsairsGants_14929 = 14929
const val itemPupDastanas_14930 = 14930
const val itemCarbunclesCuffs_14931 = 14931
const val itemSipahiDastanas_14932 = 14932
const val itemAmirKolluks_14933 = 14933
const val itemJaridahBazubands_14934 = 14934
const val itemYigitGages_14935 = 14935
const val itemStormManopolas_14936 = 14936
const val itemStormGages_14937 = 14937
const val itemAbtalDastanas_14938 = 14938
const val itemAkinjiBazubands_14939 = 14939
const val itemPlnDastanas_14940 = 14940
const val itemMaridMittens_14941 = 14941
const val itemMaridMittens1_14942 = 14942
const val itemBarbMoufles_14943 = 14943
const val itemDeadeyeGloves_14944 = 14944
const val itemFencingBracers_14945 = 14945
const val itemNightmareGloves_14946 = 14946
const val itemHanzoTekko_14947 = 14947
const val itemGenieGages_14948 = 14948
const val itemHydraFngGnt_14949 = 14949
const val itemHydraFngGnt1_14950 = 14950
const val itemDragonKote_14951 = 14951
const val itemIceGauntlets_14952 = 14952
const val itemSadhuBracelets_14953 = 14953
const val itemSadhuCuffs_14954 = 14954
const val itemSilkenCuffs_14955 = 14955
const val itemMagiCuffs_14956 = 14956
const val itemAimingGloves_14957 = 14957
const val itemBeastBazubands_14958 = 14958
const val itemMrcDastanas_14959 = 14959
const val itemEvokersGages_14960 = 14960
const val itemAresGauntlets_14961 = 14961
const val itemEnyosGauntlets_14962 = 14962
const val itemPhobossGnt_14963 = 14963
const val itemDeimossGnt_14964 = 14964
const val itemSkadisBazubands_14965 = 14965
const val itemNjordsGloves_14966 = 14966
const val itemFreyrsGloves_14967 = 14967
const val itemFreyasGloves_14968 = 14968
const val itemUsukaneGote_14969 = 14969
const val itemHoshikazuTekko_14970 = 14970
const val itemTsukikazuGote_14971 = 14971
const val itemHikazuGote_14972 = 14972
const val itemMarduksDastanas_14973 = 14973
const val itemAnusGages_14974 = 14974
const val itemEasDastanas_14975 = 14975
const val itemEnlilsKolluks_14976 = 14976
const val itemMorrigansCuffs_14977 = 14977
const val itemNemainsCuffs_14978 = 14978
const val itemBodbsCuffs_14979 = 14979
const val itemMachasCuffs_14980 = 14980
const val itemKhimairaWrist_14981 = 14981
const val itemStoutWristbands_14982 = 14982
const val itemAskarManopolas_14983 = 14983
const val itemDenaliWristbands_14984 = 14984
const val itemGoliardCuffs_14985 = 14985
const val itemOchimushaKote_14986 = 14986
const val itemThunderMittens_14987 = 14987
const val itemStoneBangles_14988 = 14988
const val itemAeroMufflers_14989 = 14989
const val itemBlizzardGloves_14990 = 14990
const val itemFireBracers_14991 = 14991
const val itemWaterMitts_14992 = 14992
const val itemTabinBracers_14993 = 14993
const val itemTabinBracers1_14994 = 14994
const val itemShadowGauntlets_14995 = 14995
const val itemValkGauntlets_14996 = 14996
const val itemShadowCuffs_14997 = 14997
const val itemValkyriesCuffs_14998 = 14998
const val itemVampiricMitts_14999 = 14999
const val itemCaballeroGnt_15000 = 15000
const val itemBreederMufflers_15001 = 15001
const val itemDancersBangles_15002 = 15002
const val itemDancersBangles_15003 = 15003
const val itemScholarsBracers_15004 = 15004
const val itemIronRamMufflers_15005 = 15005
const val itemFourthGauntlets_15006 = 15006
const val itemCobraCuffs_15007 = 15007
const val itemTraineeGloves_15008 = 15008
const val itemIRDastanas_15009 = 15009
const val itemFourthHentzes_15010 = 15010
const val itemCobraMittens_15011 = 15011
const val itemCobraGloves_15012 = 15012
const val itemViciousMufflers_15013 = 15013
const val itemPatriciansCuffs_15014 = 15014
const val itemHachiryuKote_15015 = 15015
const val itemOrcishGauntlets_15016 = 15016
const val itemToadMittens_15017 = 15017
const val itemRitterhentzes_15018 = 15018
const val itemSerpentesCuffs_15019 = 15019
const val itemHeafocMitts_15020 = 15020
const val itemAurumGauntlets_15021 = 15021
const val itemOraclesGloves_15022 = 15022
const val itemEnkidusMittens_15023 = 15023
const val itemMagBazubands1_15024 = 15024
const val itemMirageBazubands_15025 = 15025
const val itemMrgBazubands1_15026 = 15026
const val itemCorsairsGants1_15027 = 15027
const val itemCommodoreGants_15028 = 15028
const val itemCommGants1_15029 = 15029
const val itemPupDastanas1_15030 = 15030
const val itemPantinDastanas_15031 = 15031
const val itemPantinDastanas1_15032 = 15032
const val itemDanzoTekko_15033 = 15033
const val itemStoneMufflers_15034 = 15034
const val itemDncBangles1_15035 = 15035
const val itemDncBangles1_15036 = 15036
const val itemSchBracers1_15037 = 15037
const val itemEtoileBangles_15038 = 15038
const val itemEtoileBangles1_15039 = 15039
const val itemArguteBracers_15040 = 15040
const val itemArguteBracers1_15041 = 15041
const val itemGothicGauntlets_15042 = 15042
const val itemCarpentersCuffs_15043 = 15043
const val itemBlksmithCuffs_15044 = 15044
const val itemGoldsmithsCuffs_15045 = 15045
const val itemWeaversCuffs_15046 = 15046
const val itemTannersCuffs_15047 = 15047
const val itemBonewrkCuffs_15048 = 15048
const val itemAlchemistsCuffs_15049 = 15049
const val itemCulinariansCuffs_15050 = 15050
const val itemFishermansCuffs_15051 = 15051
const val itemGuerillaGloves_15052 = 15052
const val itemCombatMittens_15053 = 15053
const val itemBeaconCuffs_15054 = 15054
const val itemFinesseGloves_15055 = 15055
const val itemRoversGloves_15056 = 15056
const val itemBrictasCuffs_15057 = 15057
const val itemCombatMittens1_15058 = 15058
const val itemFinesseGloves1_15059 = 15059
const val itemSymbiosGloves_15060 = 15060
const val itemSasukeTekko_15061 = 15061
const val itemSeraphMittens_15062 = 15062
const val itemThriftGloves_15063 = 15063
const val itemSlitherGloves_15064 = 15064
const val itemMedbsGauntlets_15065 = 15065
const val itemRelicShield_15066 = 15066
const val itemBulwarkShield_15067 = 15067
const val itemDynamisShield_15068 = 15068
const val itemAncile_15069 = 15069
const val itemAegis_15070 = 15070
const val itemSpartanHoplon_15071 = 15071
const val itemWarriorsMask_15072 = 15072
const val itemMeleeCrown_15073 = 15073
const val itemClericsCap_15074 = 15074
const val itemSorcerersPetas_15075 = 15075
const val itemDuelistsChapeau_15076 = 15076
const val itemAssassinsBonnet_15077 = 15077
const val itemValorCoronet_15078 = 15078
const val itemAbyssBurgeonet_15079 = 15079
const val itemMonsterHelm_15080 = 15080
const val itemBardsRoundlet_15081 = 15081
const val itemScoutsBeret_15082 = 15082
const val itemSaotomeKabuto_15083 = 15083
const val itemKogaHatsuburi_15084 = 15084
const val itemWyrmArmet_15085 = 15085
const val itemSummonersHorn_15086 = 15086
const val itemWarriorsLorica_15087 = 15087
const val itemMeleeCyclas_15088 = 15088
const val itemClericsBliaut_15089 = 15089
const val itemSorcerersCoat_15090 = 15090
const val itemDuelistsTabard_15091 = 15091
const val itemAssassinsVest_15092 = 15092
const val itemValorSurcoat_15093 = 15093
const val itemAbyssCuirass_15094 = 15094
const val itemMonsterJackcoat_15095 = 15095
const val itemBardsJstcorps_15096 = 15096
const val itemScoutsJerkin_15097 = 15097
const val itemSaotomeDomaru_15098 = 15098
const val itemKogaChainmail_15099 = 15099
const val itemWyrmMail_15100 = 15100
const val itemSummonersDblt_15101 = 15101
const val itemWarriorsMufflers_15102 = 15102
const val itemMeleeGloves_15103 = 15103
const val itemClericsMitts_15104 = 15104
const val itemSorcerersGloves_15105 = 15105
const val itemDuelistsGloves_15106 = 15106
const val itemAssassinsArmlets_15107 = 15107
const val itemValorGauntlets_15108 = 15108
const val itemAbyssGauntlets_15109 = 15109
const val itemMonsterGloves_15110 = 15110
const val itemBardsCuffs_15111 = 15111
const val itemScoutsBracers_15112 = 15112
const val itemSaotomeKote_15113 = 15113
const val itemKogaTekko_15114 = 15114
const val itemWyrmFngGnt_15115 = 15115
const val itemSummonersBrcr_15116 = 15116
const val itemWarriorsCuisses_15117 = 15117
const val itemMeleeHose_15118 = 15118
const val itemClericsPantaln_15119 = 15119
const val itemSorcerersTonban_15120 = 15120
const val itemDuelistsTights_15121 = 15121
const val itemAssassinsCulottes_15122 = 15122
const val itemValorBreeches_15123 = 15123
const val itemAbyssFlanchard_15124 = 15124
const val itemMonsterTrousers_15125 = 15125
const val itemBardsCannions_15126 = 15126
const val itemScoutsBraccae_15127 = 15127
const val itemSaotomeHaidate_15128 = 15128
const val itemKogaHakama_15129 = 15129
const val itemWyrmBrais_15130 = 15130
const val itemSummonersSpats_15131 = 15131
const val itemWarriorsCalligae_15132 = 15132
const val itemMeleeGaiters_15133 = 15133
const val itemClericsDuckbills_15134 = 15134
const val itemSorcerersSabots_15135 = 15135
const val itemDuelistsBoots_15136 = 15136
const val itemAssassinsPouln_15137 = 15137
const val itemValorLeggings_15138 = 15138
const val itemAbyssSollerets_15139 = 15139
const val itemMonsterGaiters_15140 = 15140
const val itemBardsSlippers_15141 = 15141
const val itemScoutsSocks_15142 = 15142
const val itemSaotomeSuneAte_15143 = 15143
const val itemKogaKyahan_15144 = 15144
const val itemWyrmGreaves_15145 = 15145
const val itemSummonersPgch_15146 = 15146
const val itemGarrisonSallet_15147 = 15147
const val itemManaCirclet_15148 = 15148
const val itemRivalRibbon_15149 = 15149
const val itemShockMask_15150 = 15150
const val itemSuperRibbon_15151 = 15151
const val itemCactuarRibbon_15152 = 15152
const val itemShairTurban_15153 = 15153
const val itemSheikhTurban_15154 = 15154
const val itemBaroneZucchetto_15155 = 15155
const val itemConteZucchetto_15156 = 15156
const val itemBisonWarbonnet_15157 = 15157
const val itemBrvWarbonnet_15158 = 15158
const val itemIgqiraTiara_15159 = 15159
const val itemGenieTiara_15160 = 15160
const val itemNoctBeret_15161 = 15161
const val itemMistCrown_15162 = 15162
const val itemSeersCrown_15163 = 15163
const val itemGarishCrown_15164 = 15164
const val itemShadeTiara_15165 = 15165
const val itemSeersCrown1_15166 = 15166
const val itemEisenschaller_15167 = 15167
const val itemRubiousCrown_15168 = 15168
const val itemShadeTiara1_15169 = 15169
const val itemBlinkBand_15170 = 15170
const val itemKampfschaller_15171 = 15171
const val itemNoctBeret1_15172 = 15172
const val itemKosshin_15173 = 15173
const val itemFrenzySallet_15174 = 15174
const val itemRevilersHelm_15175 = 15175
const val itemPumpkinHeadII_15176 = 15176
const val itemHorrorHeadII_15177 = 15177
const val itemDreamHat_15178 = 15178
const val itemDreamHat1_15179 = 15179
const val itemCachenez_15180 = 15180
const val itemPinealHat_15181 = 15181
const val itemZoolaterHat_15182 = 15182
const val itemDobsonBandana_15183 = 15183
const val itemVoyagerSallet_15184 = 15184
const val itemWalkureMask_15185 = 15185
const val itemTrumpCrown_15186 = 15186
const val itemHmnJinpachi1_15187 = 15187
const val itemHachimanJinpachi_15188 = 15188
const val itemLordsArmet_15189 = 15189
const val itemWiseCap_15190 = 15190
const val itemWiseCap1_15191 = 15191
const val itemYashaJinpachi1_15192 = 15192
const val itemKingsArmet_15193 = 15193
const val itemMaatsCap_15194 = 15194
const val itemFaerieHairpin_15195 = 15195
const val itemElegantRibbon_15196 = 15196
const val itemVampireMask_15197 = 15197
const val itemSproutBeret_15198 = 15198
const val itemGuideBeret_15199 = 15199
const val itemOrcHelm_15200 = 15200
const val itemQuadavBarbut_15201 = 15201
const val itemYagudoHeadgear_15202 = 15202
const val itemGoblinCoif_15203 = 15203
const val itemMandragoraBeret_15204 = 15204
const val itemAlumineSalade_15205 = 15205
const val itemLuisantSalade_15206 = 15206
const val itemTradersChapeau_15207 = 15207
const val itemBaronsChapeau_15208 = 15208
const val itemUnicornCap_15209 = 15209
const val itemUnicornCap1_15210 = 15210
const val itemReraiseHairpin_15211 = 15211
const val itemStarsCap_15212 = 15212
const val itemLaurelCrown_15213 = 15213
const val itemGadzraddsHelm_15214 = 15214
const val itemDaVhusBarbut_15215 = 15215
const val itemTsoosHeadgear_15216 = 15216
const val itemChoplixsCoif_15217 = 15217
const val itemEntrancingRibbon_15218 = 15218
const val itemSinisterMask_15219 = 15219
const val itemRainHat_15220 = 15220
const val itemPatroclussHelm_15221 = 15221
const val itemSpelunkersHat_15222 = 15222
const val itemAcesHelm_15223 = 15223
const val itemEmpressHairpin_15224 = 15224
const val itemFtrMask1_15225 = 15225
const val itemTplCrown1_15226 = 15226
const val itemHlrCap1_15227 = 15227
const val itemWzdPetasos1_15228 = 15228
const val itemWlkChapeau1_15229 = 15229
const val itemRogBonnet1_15230 = 15230
const val itemGltCoronet1_15231 = 15231
const val itemChsBurgeonet1_15232 = 15232
const val itemBstHelm1_15233 = 15233
const val itemChlRoundlet1_15234 = 15234
const val itemHtrBeret1_15235 = 15235
const val itemMynKabuto1_15236 = 15236
const val itemNinHatsuburi1_15237 = 15237
const val itemDrnArmet1_15238 = 15238
const val itemEvkHorn1_15239 = 15239
const val itemHomamZucchetto_15240 = 15240
const val itemNashiraTurban_15241 = 15241
const val itemCrowBeret_15242 = 15242
const val itemRavenBeret_15243 = 15243
const val itemFlawlessRibbon_15244 = 15244
const val itemWarMask1_15245 = 15245
const val itemMelCrown1_15246 = 15246
const val itemClrCap1_15247 = 15247
const val itemSrcPetasos1_15248 = 15248
const val itemDlsChapeau1_15249 = 15249
const val itemAsnBonnet1_15250 = 15250
const val itemVlrCoronet1_15251 = 15251
const val itemAbsBurgeonet1_15252 = 15252
const val itemMstHelm1_15253 = 15253
const val itemBrdRoundlet1_15254 = 15254
const val itemSctBeret1_15255 = 15255
const val itemSaoKabuto1_15256 = 15256
const val itemKogHatsuburi1_15257 = 15257
const val itemWymArmet1_15258 = 15258
const val itemSmnHorn1_15259 = 15259
const val itemHydraBeret_15260 = 15260
const val itemHydraTiara_15261 = 15261
const val itemHydraSalade_15262 = 15262
const val itemHydraCap_15263 = 15263
const val itemBahamutsMask_15264 = 15264
const val itemMagusKeffiyeh_15265 = 15265
const val itemCorsairsTricorne_15266 = 15266
const val itemPupTaj_15267 = 15267
const val itemEldBoneHairpin_15268 = 15268
const val itemEldHornHairpin_15269 = 15269
const val itemWalahraTurban_15270 = 15270
const val itemAxeBelt_15271 = 15271
const val itemCestusBelt_15272 = 15272
const val itemMaceBelt_15273 = 15273
const val itemStaffBelt_15274 = 15274
const val itemRapierBelt_15275 = 15275
const val itemDaggerBelt_15276 = 15276
const val itemShieldBelt_15277 = 15277
const val itemScytheBelt_15278 = 15278
const val itemPickBelt_15279 = 15279
const val itemSongBelt_15280 = 15280
const val itemGunBelt_15281 = 15281
const val itemKatanaObi_15282 = 15282
const val itemSarashi_15283 = 15283
const val itemLanceBelt_15284 = 15284
const val itemAvatarBelt_15285 = 15285
const val itemTiltBelt_15286 = 15286
const val itemMantraBelt_15287 = 15287
const val itemPelletBelt_15288 = 15288
const val itemBoltBelt_15289 = 15289
const val itemHasteBelt_15290 = 15290
const val itemHojutsuBelt_15291 = 15291
const val itemPenitentsRope_15292 = 15292
const val itemGleemansBelt_15293 = 15293
const val itemWarwolfBelt_15294 = 15294
const val itemHierarchBelt_15295 = 15295
const val itemTathlumBelt_15296 = 15296
const val itemRabbitBelt_15297 = 15297
const val itemWormBelt_15298 = 15298
const val itemMandragoraBelt_15299 = 15299
const val itemNebimoniteBelt_15300 = 15300
const val itemVenturersBelt_15301 = 15301
const val itemScoutersRope_15302 = 15302
const val itemShairCrackows_15303 = 15303
const val itemSheikhCrackows_15304 = 15304
const val itemBaroneGambieras_15305 = 15305
const val itemConteGambieras_15306 = 15306
const val itemBisonGamashes_15307 = 15307
const val itemBravesGamashes_15308 = 15308
const val itemIgqiraHuaraches_15309 = 15309
const val itemGenieHuaraches_15310 = 15310
const val itemNoctGaiters_15311 = 15311
const val itemMistPumps_15312 = 15312
const val itemSeersPumps_15313 = 15313
const val itemGarishPumps_15314 = 15314
const val itemShadeLeggings_15315 = 15315
const val itemSeersPumps1_15316 = 15316
const val itemEisenschuhs_15317 = 15317
const val itemRubiousPumps_15318 = 15318
const val itemShadeLeggings1_15319 = 15319
const val itemPowderBoots_15320 = 15320
const val itemKampfschuhs_15321 = 15321
const val itemHeraldsGaiters_15322 = 15322
const val itemCureClogs_15323 = 15323
const val itemCaitiffsSocks_15324 = 15324
const val itemEvokersBoots_15325 = 15325
const val itemGargoyleBoots_15326 = 15326
const val itemFumaSuneAte_15327 = 15327
const val itemRootSabots_15328 = 15328
const val itemBlessedPumps_15329 = 15329
const val itemHmnSuneAte_15330 = 15330
const val itemBlessedPumps1_15331 = 15331
const val itemHmnSuneAte1_15332 = 15332
const val itemLordsSabatons_15333 = 15333
const val itemWisePigaches_15334 = 15334
const val itemWisePigaches1_15335 = 15335
const val itemYshSuneAte1_15336 = 15336
const val itemKingsSabatons_15337 = 15337
const val itemVampireBoots_15338 = 15338
const val itemBlackSollerets_15339 = 15339
const val itemOnyxSollerets_15340 = 15340
const val itemAlumineSollerets_15341 = 15341
const val itemLuisantSollerets_15342 = 15342
const val itemTradersPigaches_15343 = 15343
const val itemBaronsPigaches_15344 = 15344
const val itemUnicornLeggings_15345 = 15345
const val itemUcnLeggings1_15346 = 15346
const val itemVolansGreaves_15347 = 15347
const val itemMountainGaiters_15348 = 15348
const val itemRutterSabatons_15349 = 15349
const val itemRostrumPumps_15350 = 15350
const val itemBoundingBoots_15351 = 15351
const val itemFtrCalligae1_15352 = 15352
const val itemTplGaiters1_15353 = 15353
const val itemHlrDuckbills1_15354 = 15354
const val itemWzdSabots1_15355 = 15355
const val itemWlkBoots1_15356 = 15356
const val itemRogPoulaines1_15357 = 15357
const val itemGltLeggings1_15358 = 15358
const val itemChsSollerets1_15359 = 15359
const val itemBstGaiters1_15360 = 15360
const val itemChlSlippers1_15361 = 15361
const val itemHtrSocks1_15362 = 15362
const val itemMynSuneAte1_15363 = 15363
const val itemNinKyahan1_15364 = 15364
const val itemDrnGreaves1_15365 = 15365
const val itemEvkPigaches1_15366 = 15366
const val itemFalconersHose_15367 = 15367
const val itemWarHose_15368 = 15368
const val itemAikidoKoshita_15369 = 15369
const val itemSableCuisses_15370 = 15370
const val itemDstCodpiece_15371 = 15371
const val itemMagicSlacks_15372 = 15372
const val itemBravosSubligar_15373 = 15373
const val itemDruidsSlops_15374 = 15374
const val itemAriesSubligar_15375 = 15375
const val itemTaurusSubligar_15376 = 15376
const val itemGeminiSubligar_15377 = 15377
const val itemCancerSubligar_15378 = 15378
const val itemLeoSubligar_15379 = 15379
const val itemVirgoSubligar_15380 = 15380
const val itemLibraSubligar_15381 = 15381
const val itemScorpiusSubligar_15382 = 15382
const val itemSagitSubligar_15383 = 15383
const val itemCapriSubligar_15384 = 15384
const val itemAquariusSubligar_15385 = 15385
const val itemPiscesSubligar_15386 = 15386
const val itemTrackersKecks_15387 = 15387
const val itemOphiuSubligar_15388 = 15388
const val itemVirSubligar_15389 = 15389
const val itemFeminaSubligar_15390 = 15390
const val itemBlessedTrousers_15391 = 15391
const val itemHachimanHakama_15392 = 15392
const val itemBlsTrousers1_15393 = 15393
const val itemHmnHakama1_15394 = 15394
const val itemLordsCuisses_15395 = 15395
const val itemWiseBraconi_15396 = 15396
const val itemWiseBraconi1_15397 = 15397
const val itemYashaHakama1_15398 = 15398
const val itemKingsCuisses_15399 = 15399
const val itemBlackCuisses_15400 = 15400
const val itemOnyxCuisses_15401 = 15401
const val itemAlumineBrayettes_15402 = 15402
const val itemLuisantBrayettes_15403 = 15403
const val itemTradersSlops_15404 = 15404
const val itemBaronsSlops_15405 = 15405
const val itemUnicornSubligar_15406 = 15406
const val itemUcnSubligar1_15407 = 15407
const val itemHumeTrunks_15408 = 15408
const val itemHumeShorts_15409 = 15409
const val itemElvaanTrunks_15410 = 15410
const val itemElvaanShorts_15411 = 15411
const val itemTarutaruTrunks_15412 = 15412
const val itemMithraShorts_15413 = 15413
const val itemGalkaTrunks_15414 = 15414
const val itemHumeTrunks1_15415 = 15415
const val itemHumeShorts1_15416 = 15416
const val itemElvaanTrunks1_15417 = 15417
const val itemElvaanShorts1_15418 = 15418
const val itemTaruTrunks1_15419 = 15419
const val itemMithraShorts1_15420 = 15420
const val itemGalkaTrunks1_15421 = 15421
const val itemBlackHose_15422 = 15422
const val itemTarutaruShorts_15423 = 15423
const val itemTaruShorts1_15424 = 15424
const val itemGalliardTrousers_15425 = 15425
const val itemTorrentSubligar_15426 = 15426
const val itemTeutatesSubligar_15427 = 15427
const val itemOcelotTrousers_15428 = 15428
const val itemWiccaSubligar_15429 = 15429
const val itemAugursBrais_15430 = 15430
const val itemAstralRope_15431 = 15431
const val itemQuickBelt_15432 = 15432
const val itemReverendSash_15433 = 15433
const val itemVanguardBelt_15434 = 15434
const val itemKarinObi_15435 = 15435
const val itemHyorinObi_15436 = 15436
const val itemFurinObi_15437 = 15437
const val itemDorinObi_15438 = 15438
const val itemRairinObi_15439 = 15439
const val itemSuirinObi_15440 = 15440
const val itemKorinObi_15441 = 15441
const val itemAnrinObi_15442 = 15442
const val itemPowerfulRope_15443 = 15443
const val itemCarpentersBelt_15444 = 15444
const val itemBlacksmithsBlt_15445 = 15445
const val itemGoldsmithsBelt_15446 = 15446
const val itemWeaversBelt_15447 = 15447
const val itemTannersBelt_15448 = 15448
const val itemBoneworkersBlt_15449 = 15449
const val itemAlchemistsBelt_15450 = 15450
const val itemCulinariansBelt_15451 = 15451
const val itemFishermansBelt_15452 = 15452
const val itemLugwormBelt_15453 = 15453
const val itemLittleWormBelt_15454 = 15454
const val itemRedSash_15455 = 15455
const val itemDashSash_15456 = 15456
const val itemSwiftBelt_15457 = 15457
const val itemNinurtasSash_15458 = 15458
const val itemSagacGoldObi_15459 = 15459
const val itemDeductGoldObi_15460 = 15460
const val itemEnthrallGoldObi_15461 = 15461
const val itemSagacBrocObi_15462 = 15462
const val itemSafetyMantle_15463 = 15463
const val itemCorseCape_15464 = 15464
const val itemToreadorsCape_15465 = 15465
const val itemBirdmanCape_15466 = 15466
const val itemLucentCape_15467 = 15467
const val itemResentmentCape_15468 = 15468
const val itemBellicoseMantle_15469 = 15469
const val itemGramaryCape_15470 = 15470
const val itemMercifulCape_15471 = 15471
const val itemAltruisticCape_15472 = 15472
const val itemAstuteCape_15473 = 15473
const val itemHarmonyCape_15474 = 15474
const val itemChargerMantle_15475 = 15475
const val itemJaegerMantle_15476 = 15476
const val itemBoxersMantle_15477 = 15477
const val itemMeleeCape_15478 = 15478
const val itemAbyssCape_15479 = 15479
const val itemAssassinsCape_15480 = 15480
const val itemValorCape_15481 = 15481
const val itemBardsCape_15482 = 15482
const val itemStormMantle_15483 = 15483
const val itemSummonersCape_15484 = 15484
const val itemTalismanCape_15485 = 15485
const val itemBreathMantle_15486 = 15486
const val itemHighBrthMantle_15487 = 15487
const val itemGunnersMantle_15488 = 15488
const val itemStormCape_15489 = 15489
const val itemMiraculousCape_15490 = 15490
const val itemBullseyeCape_15491 = 15491
const val itemIntensifyingCape_15492 = 15492
const val itemBushidoCape_15493 = 15493
const val itemInvigoratingCape_15494 = 15494
const val itemFlameGorget_15495 = 15495
const val itemSnowGorget_15496 = 15496
const val itemBreezeGorget_15497 = 15497
const val itemSoilGorget_15498 = 15498
const val itemThunderGorget_15499 = 15499
const val itemAquaGorget_15500 = 15500
const val itemLightGorget_15501 = 15501
const val itemShadowGorget_15502 = 15502
const val itemVanPendant_15503 = 15503
const val itemAjaseBeads_15504 = 15504
const val itemDhalmelWhistle_15505 = 15505
const val itemParadeGorget_15506 = 15506
const val itemPurgatoryCollar_15507 = 15507
const val itemJusticeTorque_15508 = 15508
const val itemHopeTorque_15509 = 15509
const val itemPrudenceTorque_15510 = 15510
const val itemFortitudeTorque_15511 = 15511
const val itemFaithTorque_15512 = 15512
const val itemTempTorque_15513 = 15513
const val itemLoveTorque_15514 = 15514
const val itemPeacockAmulet_15515 = 15515
const val itemDiabolossTorque_15516 = 15516
const val itemSnipersCollar_15517 = 15517
const val itemMNo17sLocket_15518 = 15518
const val itemStormMuffler_15519 = 15519
const val itemStormTorque_15520 = 15520
const val itemTemperedChain_15521 = 15521
const val itemEnlightenedChain_15522 = 15522
const val itemChivalrousChain_15523 = 15523
const val itemFortifiedChain_15524 = 15524
const val itemGrandioseChain_15525 = 15525
const val itemRegenCollar_15526 = 15526
const val itemPraecisGorget_15527 = 15527
const val itemSacrificeTorque_15528 = 15528
const val itemAcesLocket_15529 = 15529
const val itemBerserkersTorque_15530 = 15530
const val itemQiqirnCollar_15531 = 15531
const val itemSharkNecklace_15532 = 15532
const val itemChocoboWhistle_15533 = 15533
const val itemMuNecklace_15534 = 15534
const val itemChiNecklace_15535 = 15535
const val itemRhoNecklace_15536 = 15536
const val itemKappaNecklace_15537 = 15537
const val itemPhiNecklace_15538 = 15538
const val itemOrochiNodowa_15539 = 15539
const val itemOrochiNodowa1_15540 = 15540
const val itemHomingRing_15541 = 15541
const val itemReturnRing_15542 = 15542
const val itemRajasRing_15543 = 15543
const val itemSattvaRing_15544 = 15544
const val itemTamasRing_15545 = 15545
const val itemFastingRing_15546 = 15546
const val itemVilmasRing_15547 = 15547
const val itemMarssRing_15548 = 15548
const val itemBellonasRing_15549 = 15549
const val itemMinervasRing_15550 = 15550
const val itemShikareeRing_15551 = 15551
const val itemAlbatrossRing_15552 = 15552
const val itemPenguinRing_15553 = 15553
const val itemPelicanRing_15554 = 15554
const val itemAlbatrossRing_15555 = 15555
const val itemPenguinRing_15556 = 15556
const val itemDiabolossRing_15557 = 15557
const val itemMightyRing_15558 = 15558
const val itemVisionRing_15559 = 15559
const val itemTroopersRing_15560 = 15560
const val itemFtrCuisses1_15561 = 15561
const val itemTplHose1_15562 = 15562
const val itemHlrPantaln1_15563 = 15563
const val itemWzdTonban1_15564 = 15564
const val itemWlkTights1_15565 = 15565
const val itemRogCulottes1_15566 = 15566
const val itemGltBreeches1_15567 = 15567
const val itemChsFlanchard1_15568 = 15568
const val itemBstTrousers1_15569 = 15569
const val itemChlCannions1_15570 = 15570
const val itemHtrBraccae1_15571 = 15571
const val itemMynHaidate1_15572 = 15572
const val itemNinHakama1_15573 = 15573
const val itemDrnBrais1_15574 = 15574
const val itemEvkSpats1_15575 = 15575
const val itemHomamCosciales_15576 = 15576
const val itemNashiraSeraweels_15577 = 15577
const val itemCrowHose_15578 = 15578
const val itemRavenHose_15579 = 15579
const val itemWarCuisses1_15580 = 15580
const val itemMelHose1_15581 = 15581
const val itemClrPantaln1_15582 = 15582
const val itemSrcTonban1_15583 = 15583
const val itemDlsTights1_15584 = 15584
const val itemAsnCulottes1_15585 = 15585
const val itemVlrBreeches1_15586 = 15586
const val itemAbsFlanchard1_15587 = 15587
const val itemMstTrousers1_15588 = 15588
const val itemBrdCannions1_15589 = 15589
const val itemSctBraccae1_15590 = 15590
const val itemSaoHaidate1_15591 = 15591
const val itemKogHakama1_15592 = 15592
const val itemWymBrais1_15593 = 15593
const val itemSmnSpats1_15594 = 15594
const val itemHydraBrais_15595 = 15595
const val itemHydraTights_15596 = 15596
const val itemHydraBrayettes_15597 = 15597
const val itemHydraHose_15598 = 15598
const val itemBahamutsHose_15599 = 15599
const val itemMagusShalwar_15600 = 15600
const val itemCorsairsCulottes_15601 = 15601
const val itemPupChuridars_15602 = 15602
const val itemSipahiZerehs_15603 = 15603
const val itemAmirDirs_15604 = 15604
const val itemJaridahSalvars_15605 = 15605
const val itemYigitSeraweels_15606 = 15606
const val itemAbtalZerehs_15607 = 15607
const val itemAkinjiSalvars_15608 = 15608
const val itemPlnSeraweels_15609 = 15609
const val itemSturdyTrousers_15610 = 15610
const val itemSturdySlacks_15611 = 15611
const val itemStrikeSubligar_15612 = 15612
const val itemJetSeraweels_15613 = 15613
const val itemExorcistHose_15614 = 15614
const val itemHydraCuisses_15615 = 15615
const val itemHydraCuisses1_15616 = 15616
const val itemBarbZerehs_15617 = 15617
const val itemVendorsSlops_15618 = 15618
const val itemPrincesSlops_15619 = 15619
const val itemSilkenSlops_15620 = 15620
const val itemMagiSlops_15621 = 15621
const val itemMrcTrousers_15622 = 15622
const val itemVolunteersBrais_15623 = 15623
const val itemMrcSubligar_15624 = 15624
const val itemAresFlanchard_15625 = 15625
const val itemEnyosCuisses_15626 = 15626
const val itemPhobossCuisses_15627 = 15627
const val itemDeimossCuisses_15628 = 15628
const val itemSkadisChausses_15629 = 15629
const val itemNjordsTrousers_15630 = 15630
const val itemFreyrsTrousers_15631 = 15631
const val itemFreyasTrousers_15632 = 15632
const val itemUsukaneHizayoroi_15633 = 15633
const val itemHoshikazuHakama_15634 = 15634
const val itemTsukikazuHaidate_15635 = 15635
const val itemHikazuHakama_15636 = 15636
const val itemMarduksShalwar_15637 = 15637
const val itemAnusBrais_15638 = 15638
const val itemEasBrais_15639 = 15639
const val itemEnlilsBrayettes_15640 = 15640
const val itemMorrigansSlops_15641 = 15641
const val itemNemainsSlops_15642 = 15642
const val itemBodbsSlops_15643 = 15643
const val itemMachasSlops_15644 = 15644
const val itemKhimairaKecks_15645 = 15645
const val itemStoutKecks_15646 = 15646
const val itemAskarDirs_15647 = 15647
const val itemDenaliKecks_15648 = 15648
const val itemGoliardTrews_15649 = 15649
const val itemShockSubligar_15650 = 15650
const val itemIceTrousers_15651 = 15651
const val itemBlazeHose_15652 = 15652
const val itemTabinHose_15653 = 15653
const val itemTabinHose1_15654 = 15654
const val itemShadowCuishes_15655 = 15655
const val itemValkyriesCuishes_15656 = 15656
const val itemShadowTrews_15657 = 15657
const val itemValkyriesTrews_15658 = 15658
const val itemDancersTights_15659 = 15659
const val itemDancersTights_15660 = 15660
const val itemHomamGambieras_15661 = 15661
const val itemNashiraCrackows_15662 = 15662
const val itemCrowGaiters_15663 = 15663
const val itemRavenGaiters_15664 = 15664
const val itemWarCalligae1_15665 = 15665
const val itemMelGaiters1_15666 = 15666
const val itemClrDuckbills1_15667 = 15667
const val itemSrcSabots1_15668 = 15668
const val itemDlsBoots1_15669 = 15669
const val itemAsnPoulaines1_15670 = 15670
const val itemVlrLeggings1_15671 = 15671
const val itemAbsSollerets1_15672 = 15672
const val itemMstGaiters1_15673 = 15673
const val itemBrdSlippers1_15674 = 15674
const val itemSctSocks1_15675 = 15675
const val itemSaoSuneAte1_15676 = 15676
const val itemKogKyahan1_15677 = 15677
const val itemWymGreaves1_15678 = 15678
const val itemSmnPigaches1_15679 = 15679
const val itemHydraGaiters_15680 = 15680
const val itemHydraSpats_15681 = 15681
const val itemHydraSollerets_15682 = 15682
const val itemHydraBoots_15683 = 15683
const val itemMagusCharuqs_15684 = 15684
const val itemCorsairsBottes_15685 = 15685
const val itemPupBabouches_15686 = 15686
const val itemSipahiBoots_15687 = 15687
const val itemAmirBoots_15688 = 15688
const val itemJaridahNails_15689 = 15689
const val itemYigitCrackows_15690 = 15690
const val itemStormGambieras_15691 = 15691
const val itemStormCrackows_15692 = 15692
const val itemAbtalBoots_15693 = 15693
const val itemAkinjiNails_15694 = 15694
const val itemPlnCrackows_15695 = 15695
const val itemMaridLeggings_15696 = 15696
const val itemMaridLeggings1_15697 = 15697
const val itemSneakingBoots_15698 = 15698
const val itemTemplarSabatons_15699 = 15699
const val itemSkandaBoots_15700 = 15700
const val itemArboristNails_15701 = 15701
const val itemSpagyricNails_15702 = 15702
const val itemHydraGreaves_15703 = 15703
const val itemHydraGreaves1_15704 = 15704
const val itemAtaracticSolea_15705 = 15705
const val itemSilkenPigaches_15706 = 15706
const val itemMagiPigaches_15707 = 15707
const val itemEarthGreaves_15708 = 15708
const val itemMercenarysBoots_15709 = 15709
const val itemVolunteersNails_15710 = 15710
const val itemAresSollerets_15711 = 15711
const val itemEnyosLeggings_15712 = 15712
const val itemPhobossSabat_15713 = 15713
const val itemDeimossLeggings_15714 = 15714
const val itemSkadisJambeaux_15715 = 15715
const val itemNjordsLedelsens_15716 = 15716
const val itemFreyrsLedelsens_15717 = 15717
const val itemFreyasLedelsens_15718 = 15718
const val itemUsukaneSuneAte_15719 = 15719
const val itemHkazuKyahan_15720 = 15720
const val itemTkazuSuneAte_15721 = 15721
const val itemHikazuSuneAte_15722 = 15722
const val itemMarduksCrackows_15723 = 15723
const val itemAnusGaiters_15724 = 15724
const val itemEasCrackows_15725 = 15725
const val itemEnlilsCrackows_15726 = 15726
const val itemMorrigansPgch_15727 = 15727
const val itemNemainsSabots_15728 = 15728
const val itemBodbsPigaches_15729 = 15729
const val itemMachasPigaches_15730 = 15730
const val itemKhimairaGamash_15731 = 15731
const val itemStoutGamashes_15732 = 15732
const val itemAskarGambieras_15733 = 15733
const val itemDenaliGamashes_15734 = 15734
const val itemGoliardClogs_15735 = 15735
const val itemTrotterBoots_15736 = 15736
const val itemSarutobiKyahan_15737 = 15737
const val itemTabinBoots_15738 = 15738
const val itemTabinBoots1_15739 = 15739
const val itemShadowSabatons_15740 = 15740
const val itemValkSabatons_15741 = 15741
const val itemShadowClogs_15742 = 15742
const val itemValkyriesClogs_15743 = 15743
const val itemBowmansLed_15744 = 15744
const val itemVampiricBoots_15745 = 15745
const val itemDancersToeShoes_15746 = 15746
const val itemDancersToeShoes_15747 = 15747
const val itemScholarsLoafers_15748 = 15748
const val itemIRSollerets_15749 = 15749
const val itemFourthSabatons_15750 = 15750
const val itemCobraPigaches_15751 = 15751
const val itemDreamBoots_15752 = 15752
const val itemDreamBoots1_15753 = 15753
const val itemSprintersShoes_15754 = 15754
const val itemIronRamGreaves_15755 = 15755
const val itemFourthSchuhs_15756 = 15756
const val itemCobraLeggings_15757 = 15757
const val itemCobraCrackows_15758 = 15758
const val itemMahantSandals_15759 = 15759
const val itemMaraboutSandals_15760 = 15760
const val itemChariotBand_15761 = 15761
const val itemEmpressBand_15762 = 15762
const val itemEmperorBand_15763 = 15763
const val itemOlduumRing_15769 = 15769
const val itemRandomRing_15770 = 15770
const val itemShiningRing_15771 = 15771
const val itemScintillantRing_15772 = 15772
const val itemImperialRing_15773 = 15773
const val itemStormRing_15774 = 15774
const val itemUnfetteredRing_15775 = 15775
const val itemEbullientRing_15776 = 15776
const val itemHaleRing_15777 = 15777
const val itemUnyieldingRing_15778 = 15778
const val itemGarrulousRing_15779 = 15779
const val itemCerberusRing_15780 = 15780
const val itemCerberusRing1_15781 = 15781
const val itemManashellRing_15782 = 15782
const val itemArmoredRing_15783 = 15783
const val itemDominionRing_15784 = 15784
const val itemGobniusRing_15785 = 15785
const val itemDivisorRing_15786 = 15786
const val itemHorizonRing_15787 = 15787
const val itemMaridRing_15788 = 15788
const val itemMaridRing1_15789 = 15789
const val itemMultipleRing_15790 = 15790
const val itemVolunteersRing_15791 = 15791
const val itemMercenarysRing_15792 = 15792
const val itemAnniversaryRing_15793 = 15793
const val itemOmicronRing_15794 = 15794
const val itemTauRing_15795 = 15795
const val itemPsiRing_15796 = 15796
const val itemPiRing_15797 = 15797
const val itemEpsilonRing_15798 = 15798
const val itemIotaRing_15799 = 15799
const val itemOmegaRing_15800 = 15800
const val itemTigereyeRing_15801 = 15801
const val itemFeralRing_15802 = 15802
const val itemCrimsonRing_15803 = 15803
const val itemHarmoniusRing_15804 = 15804
const val itemStarRing_15805 = 15805
const val itemCelestialRing_15806 = 15806
const val itemBalrahnsRing_15807 = 15807
const val itemUlthalamsRing_15808 = 15808
const val itemJalzahnsRing_15809 = 15809
const val itemLuzafsRing_15810 = 15810
const val itemWivreRing_15811 = 15811
const val itemWivreRing1_15812 = 15812
const val itemTrumpetRing_15813 = 15813
const val itemNereidRing_15814 = 15814
const val itemLadybugRing_15815 = 15815
const val itemLadybugRing1_15816 = 15816
const val itemEcphoriaRing_15817 = 15817
const val itemMolionessRing_15818 = 15818
const val itemCarpentersRing_15819 = 15819
const val itemSmithsRing_15820 = 15820
const val itemGoldsmithsRing_15821 = 15821
const val itemTailorsRing_15822 = 15822
const val itemTannersRing_15823 = 15823
const val itemBonecraftersRing_15824 = 15824
const val itemAlchemistsRing_15825 = 15825
const val itemChefsRing_15826 = 15826
const val itemInsectRing_15827 = 15827
const val itemBloodRing_15828 = 15828
const val itemSkirmishersRing_15829 = 15829
const val itemPatriotsRing_15830 = 15830
const val itemFenianRing_15831 = 15831
const val itemHeadsmansRing_15832 = 15832
const val itemDivertersRing_15833 = 15833
const val itemBlindRing_15834 = 15834
const val itemDesperadoRing_15835 = 15835
const val itemSmilodonRing_15836 = 15836
const val itemSmilodonRing1_15837 = 15837
const val itemProtectRing_15838 = 15838
const val itemAnticaRing_15839 = 15839
const val itemKupofriedsRing_15840 = 15840
const val itemJugnerRing_15841 = 15841
const val itemPashhowRing_15842 = 15842
const val itemMeriphataudRing_15843 = 15843
const val itemPatronusRing_15844 = 15844
const val itemSeagullRing_15845 = 15845
const val itemHeronRing_15846 = 15846
const val itemMatrimonyRing_15847 = 15847
const val itemMatrimonyBand_15848 = 15848
const val itemKrousisRing_15849 = 15849
const val itemLavasRing_15850 = 15850
const val itemKushasRing_15851 = 15851
const val itemNasatyasRing_15852 = 15852
const val itemDasrasRing_15853 = 15853
const val itemSortieRing_15854 = 15854
const val itemKrousisRing1_15855 = 15855
const val itemGriffonRing_15856 = 15856
const val itemExcelsisRing_15857 = 15857
const val itemZodiacRing_15858 = 15858
const val itemSuccorRing_15859 = 15859
const val itemGyokutoObi_15860 = 15860
const val itemDeductBrocObi_15861 = 15861
const val itemEnthrallBrocObi_15862 = 15862
const val itemSamsonianBelt_15863 = 15863
const val itemToughBelt_15864 = 15864
const val itemRunnersBelt_15865 = 15865
const val itemAcrobatsBelt_15866 = 15866
const val itemSultansBelt_15867 = 15867
const val itemCzarsBelt_15868 = 15868
const val itemPendragonsBelt_15869 = 15869
const val itemMaharajasBelt_15870 = 15870
const val itemWarriorsStone_15871 = 15871
const val itemClericsBelt_15872 = 15872
const val itemDuelistsBelt_15873 = 15873
const val itemSorcerersBelt_15874 = 15874
const val itemMonsterBelt_15875 = 15875
const val itemScoutsBelt_15876 = 15876
const val itemKogaSarashi_15877 = 15877
const val itemWyrmBelt_15878 = 15878
const val itemSaoKoshiAte_15879 = 15879
const val itemKeyRingBelt_15880 = 15880
const val itemTalismanObi_15881 = 15881
const val itemStormBelt_15882 = 15882
const val itemStormSash_15883 = 15883
const val itemPotentBelt_15884 = 15884
const val itemSpectralBelt_15885 = 15885
const val itemPreciseBelt_15886 = 15886
const val itemResoluteBelt_15887 = 15887
const val itemHurlingBelt_15888 = 15888
const val itemAugmentingBelt_15889 = 15889
const val itemMaridBelt_15890 = 15890
const val itemAlZahbiSash_15891 = 15891
const val itemMoonSash_15892 = 15892
const val itemMaridBelt1_15893 = 15893
const val itemBitterCorset_15894 = 15894
const val itemTranceBelt_15895 = 15895
const val itemImmortalsSash_15896 = 15896
const val itemGraceCorset_15897 = 15897
const val itemVolunteersBelt_15898 = 15898
const val itemVelociousBelt_15899 = 15899
const val itemNuSash_15900 = 15900
const val itemZetaSash_15901 = 15901
const val itemLambdaSash_15902 = 15902
const val itemKsiSash_15903 = 15903
const val itemThetaSash_15904 = 15904
const val itemMohbwaSash_15905 = 15905
const val itemMohbwaSash1_15906 = 15906
const val itemQiqirnSash_15907 = 15907
const val itemQiqirnSash1_15908 = 15908
const val itemCascadeBelt_15909 = 15909
const val itemPrimalBelt_15910 = 15910
const val itemBuccaneersBelt_15911 = 15911
const val itemLieutenantsSash_15912 = 15912
const val itemPeisteBelt_15913 = 15913
const val itemPeisteBelt1_15914 = 15914
const val itemSothicRope_15915 = 15915
const val itemCorsairsBelt_15916 = 15916
const val itemCuchulainsBelt_15917 = 15917
const val itemWitchSash_15918 = 15918
const val itemDroversBelt_15919 = 15919
const val itemCommodoreBelt_15920 = 15920
const val itemDetonatorBelt_15921 = 15921
const val itemTernStone_15922 = 15922
const val itemGrenadierBelt_15923 = 15923
const val itemDemagoguesSash_15924 = 15924
const val itemArguteBelt_15925 = 15925
const val itemBronzeBandolier_15926 = 15926
const val itemPinwheelBelt_15927 = 15927
const val itemLycopodiumSash_15928 = 15928
const val itemGoblinBelt_15929 = 15929
const val itemBugbearCest_15930 = 15930
const val itemGoblinCest_15931 = 15931
const val itemMoblinCest_15932 = 15932
const val itemStirgeBelt_15933 = 15933
const val itemCrimsonBelt_15934 = 15934
const val itemCapricornianRope_15935 = 15935
const val itemEarthyBelt_15936 = 15936
const val itemFettleBelt_15937 = 15937
const val itemEspritBelt_15938 = 15938
const val itemGriotBelt_15939 = 15939
const val itemGoshaSarashi_15940 = 15940
const val itemHeadlongBelt_15941 = 15941
const val itemSummoningBelt_15942 = 15942
const val itemVirtuosoBelt_15943 = 15943
const val itemSelemnusBelt_15944 = 15944
const val itemVolantBelt_15945 = 15945
const val itemTempestBelt_15946 = 15946
const val itemGriotBelt1_15947 = 15947
const val itemBobcatBelt_15948 = 15948
const val itemPythiaSash_15949 = 15949
const val itemPythiaSash1_15950 = 15950
const val itemToxonBelt_15951 = 15951
const val itemToxonBelt1_15952 = 15952
const val itemMarchingBelt_15953 = 15953
const val itemFierceBelt_15954 = 15954
const val itemFatalityBelt_15955 = 15955
const val itemTKQuiver_15956 = 15956
const val itemIrnMskQuiver_15957 = 15957
const val itemCmbCstQuiver_15958 = 15958
const val itemTwilightBelt_15959 = 15959
const val itemSiegelSash_15960 = 15960
const val itemMusicalEarring_15961 = 15961
const val itemStaticEarring_15962 = 15962
const val itemMagneticEarring_15963 = 15963
const val itemHollowEarring_15964 = 15964
const val itemEtherealEarring_15965 = 15965
const val itemSilverFoxEarring_15966 = 15966
const val itemTempleEarring_15967 = 15967
const val itemStormLoop_15968 = 15968
const val itemStormEarring_15969 = 15969
const val itemStoicEarring_15970 = 15970
const val itemAntivenomEarring_15971 = 15971
const val itemInsomniaEarring_15972 = 15972
const val itemVisionEarring_15973 = 15973
const val itemVelocityEarring_15974 = 15974
const val itemImmortalsEarring_15975 = 15975
const val itemPiratesEarring_15976 = 15976
const val itemBuskersEarring_15977 = 15977
const val itemRaptureEarring_15978 = 15978
const val itemFowlingEarring_15979 = 15979
const val itemMagnifyingEarring_15980 = 15980
const val itemHatenEarring_15981 = 15981
const val itemPriestsEarring_15982 = 15982
const val itemChaoticEarring_15983 = 15983
const val itemVoluntEarring_15984 = 15984
const val itemSigmaEarring_15985 = 15985
const val itemEtaEarring_15986 = 15986
const val itemEpsilonEarring_15987 = 15987
const val itemBetaEarring_15988 = 15988
const val itemGammaEarring_15989 = 15989
const val itemDeltaEarring_15990 = 15990
const val itemStarEarring_15991 = 15991
const val itemCelestialEarring_15992 = 15992
const val itemCrimsonEarring_15993 = 15993
const val itemHarmoniusEarring_15994 = 15994
const val itemCarlineEarring_15995 = 15995
const val itemLadybugEarring_15996 = 15996
const val itemLbugEarring1_15997 = 15997
const val itemKoccosEarring_15998 = 15998
const val itemGuignolEarring_15999 = 15999
const val itemDragoonsEarring_16000 = 16000
const val itemCrapaudEarring_16001 = 16001
const val itemRoundelEarring_16002 = 16002
const val itemRaisingEarring_16003 = 16003
const val itemSupremacyEarring_16004 = 16004
const val itemParamountEarring_16005 = 16005
const val itemBrilliantEarring_16006 = 16006
const val itemProtectEarring_16007 = 16007
const val itemAptusEarring_16008 = 16008
const val itemPennonEarring_16009 = 16009
const val itemPennonEarring1_16010 = 16010
const val itemLycEarring_16011 = 16011
const val itemMamoolJaEarring_16012 = 16012
const val itemStellarEarring_16013 = 16013
const val itemStormerEarring_16014 = 16014
const val itemEsseEarring_16015 = 16015
const val itemCharyEarring_16016 = 16016
const val itemArdentEarring_16017 = 16017
const val itemAtaraxyEarring_16018 = 16018
const val itemForteEarring_16019 = 16019
const val itemSurvivorEarring_16020 = 16020
const val itemBrawnEarring_16021 = 16021
const val itemFidelityEarring_16022 = 16022
const val itemMystiqueEarring_16023 = 16023
const val itemImpetusEarring_16024 = 16024
const val itemRatheEarring_16025 = 16025
const val itemElanEarring_16026 = 16026
const val itemSeekerEarring_16027 = 16027
const val itemPsycheEarring_16028 = 16028
const val itemBoosterEarring_16029 = 16029
const val itemSoarerEarring_16030 = 16030
const val itemAffinityEarring_16031 = 16031
const val itemMuffleEarring_16032 = 16032
const val itemSylphEarring_16033 = 16033
const val itemSarabandeEarring_16034 = 16034
const val itemAltdorfsEarring_16035 = 16035
const val itemWilhelmsEarring_16036 = 16036
const val itemHelenussEarring_16037 = 16037
const val itemCassEarring_16038 = 16038
const val itemKingdomEarring_16039 = 16039
const val itemRepublicEarring_16040 = 16040
const val itemFederationEarring_16041 = 16041
const val itemDuchyEarring_16042 = 16042
const val itemSelbinaEarring_16043 = 16043
const val itemMhauraEarring_16044 = 16044
const val itemRabaoEarring_16045 = 16045
const val itemKazhamEarring_16046 = 16046
const val itemNorgEarring_16047 = 16047
const val itemSafeholdEarring_16048 = 16048
const val itemEmpireEarring_16049 = 16049
const val itemNashmauEarring_16050 = 16050
const val itemIncubusEarring_16052 = 16052
const val itemIncubusEarring1_16053 = 16053
const val itemHirudineaEarring_16054 = 16054
const val itemChoreiaEarring_16055 = 16055
const val itemPagondasEarring_16056 = 16056
const val itemAesirEarPendant_16057 = 16057
const val itemColossussEarring_16058 = 16058
const val itemGraiaiEarring_16059 = 16059
const val itemSipahiTurban_16061 = 16061
const val itemAmirPuggaree_16062 = 16062
const val itemJaridahKhud_16063 = 16063
const val itemYigitTurban_16064 = 16064
const val itemStormZucchetto_16065 = 16065
const val itemStormTurban_16066 = 16066
const val itemAbtalTurban_16067 = 16067
const val itemAkinjiKhud_16068 = 16068
const val itemPlnQalansuwa_16069 = 16069
const val itemGloryCrown_16070 = 16070
const val itemKawahoriKabuto_16071 = 16071
const val itemBrigandsMask_16072 = 16072
const val itemHydraMask_16073 = 16073
const val itemHydraMask1_16074 = 16074
const val itemWitchHat_16075 = 16075
const val itemCovenHat_16076 = 16076
const val itemMegrimCrown_16077 = 16077
const val itemBlissfulChapeau_16078 = 16078
const val itemSilkenHat_16079 = 16079
const val itemMagiHat_16080 = 16080
const val itemCuratesHat_16081 = 16081
const val itemVolunteersKhud_16082 = 16082
const val itemMrcTurban_16083 = 16083
const val itemAresMask_16084 = 16084
const val itemEnyosMask_16085 = 16085
const val itemPhobossMask_16086 = 16086
const val itemDeimossMask_16087 = 16087
const val itemSkadisVisor_16088 = 16088
const val itemNjordsMask_16089 = 16089
const val itemFreyrsMask_16090 = 16090
const val itemFreyasMask_16091 = 16091
const val itemUsukaneSomen_16092 = 16092
const val itemHkazuHachimaki_16093 = 16093
const val itemTkazuJinpachi_16094 = 16094
const val itemHikazuKabuto_16095 = 16095
const val itemMarduksTiara_16096 = 16096
const val itemAnusTiara_16097 = 16097
const val itemEasTiara_16098 = 16098
const val itemEnlilsTiara_16099 = 16099
const val itemMorrigansCoron_16100 = 16100
const val itemNemainsCrown_16101 = 16101
const val itemBodbsCrown_16102 = 16102
const val itemMachasCrown_16103 = 16103
const val itemKhimairaBonnet_16104 = 16104
const val itemStoutBonnet_16105 = 16105
const val itemAskarZucchetto_16106 = 16106
const val itemDenaliBonnet_16107 = 16107
const val itemGoliardChapeau_16108 = 16108
const val itemEggHelm_16109 = 16109
const val itemPlainCap_16110 = 16110
const val itemTabinBeret_16111 = 16111
const val itemTabinBeret1_16112 = 16112
const val itemShadowHelm_16113 = 16113
const val itemValkyriesHelm_16114 = 16114
const val itemShadowHat_16115 = 16115
const val itemValkyriesHat_16116 = 16116
const val itemValhallaHelm_16117 = 16117
const val itemMoogleCap_16118 = 16118
const val itemNomadCap_16119 = 16119
const val itemRedeyes_16120 = 16120
const val itemMamoolJaHelm_16121 = 16121
const val itemTrollCoif_16122 = 16122
const val itemLamiaGarland_16123 = 16123
const val itemQiqirnHood_16124 = 16124
const val itemBreederMask_16125 = 16125
const val itemBowmansMask_16126 = 16126
const val itemCarlineRibbon_16127 = 16127
const val itemWivreHairpin_16128 = 16128
const val itemWivreHairpin1_16129 = 16129
const val itemWivreMask_16130 = 16130
const val itemWivreMask1_16131 = 16131
const val itemDandySpectacles_16132 = 16132
const val itemFancySpectacles_16133 = 16133
const val itemZoraalJasHelm_16134 = 16134
const val itemDartorgorsCoif_16135 = 16135
const val itemNo3sGarland_16136 = 16136
const val itemCacaroonsHood_16137 = 16137
const val itemDancersTiara_16138 = 16138
const val itemDancersTiara_16139 = 16139
const val itemScholarsMboard_16140 = 16140
const val itemIronRamHelm_16141 = 16141
const val itemFourthArmet_16142 = 16142
const val itemCobraHat_16143 = 16143
const val itemSolCap_16144 = 16144
const val itemLunarCap_16145 = 16145
const val itemIronRamSallet_16146 = 16146
const val itemFourthHaube_16147 = 16147
const val itemCobraCap_16148 = 16148
const val itemCobraCloche_16149 = 16149
const val itemSaurianHelm_16150 = 16150
const val itemLeonineMask_16151 = 16151
const val itemHisshoHachimaki_16152 = 16152
const val itemReikyoHairpin_16153 = 16153
const val itemKaruraHachigane_16154 = 16154
const val itemAurumArmet_16155 = 16155
const val itemOraclesCap_16156 = 16156
const val itemEnkidusCap_16157 = 16157
const val itemGnadbhodsHelm_16158 = 16158
const val itemZhaGosBarbut_16159 = 16159
const val itemReesHeadgear_16160 = 16160
const val itemJanuwiyah_16161 = 16161
const val itemTariqah_16162 = 16162
const val itemJanuwiyah1_16163 = 16163
const val itemTariqah1_16164 = 16164
const val itemStormShield_16165 = 16165
const val itemJanuwiyah1_16166 = 16166
const val itemTariqah1_16167 = 16167
const val itemSentinelShield_16168 = 16168
const val itemCaballeroShield_16169 = 16169
const val itemWivreShield_16170 = 16170
const val itemWivreShield1_16171 = 16171
const val itemIronRamShield_16172 = 16172
const val itemPallassShield_16173 = 16173
const val itemRiotShield_16174 = 16174
const val itemMuseTariqah_16175 = 16175
const val itemSimbaBuckler_16176 = 16176
const val itemLegionScutum_16177 = 16177
const val itemAvalonShield_16178 = 16178
const val itemAiryBuckler_16179 = 16179
const val itemHarpyShield_16180 = 16180
const val itemTerrorShield_16181 = 16181
const val itemTownMogShield_16182 = 16182
const val itemNomadMogShield_16183 = 16183
const val itemFlatShield_16184 = 16184
const val itemPelte_16185 = 16185
const val itemSpellcastersEcu_16186 = 16186
const val itemAdoubeursPavise_16187 = 16187
const val itemRustyShield_16188 = 16188
const val itemGleamingShield_16189 = 16189
const val itemBloomBuckler_16190 = 16190
const val itemUtilisShield_16191 = 16191
const val itemOchain_16192 = 16192
const val itemOchain_16193 = 16193
const val itemOchain_16194 = 16194
const val itemAegis_16195 = 16195
const val itemAegis_16196 = 16196
const val itemAegis_16197 = 16197
const val itemAegis_16198 = 16198
const val itemOchain_16199 = 16199
const val itemAegis_16200 = 16200
const val itemGenesisShield_16201 = 16201
const val itemDagdasShield_16202 = 16202
const val itemGoetiaMantle_16203 = 16203
const val itemEstoqueursCape_16204 = 16204
const val itemSylvanChlamys_16205 = 16205
const val itemUnkaiSugemino_16206 = 16206
const val itemIgaDochugappa_16207 = 16207
const val itemLancersPelerine_16208 = 16208
const val itemNavarchsMantle_16209 = 16209
const val itemEbullientCape_16210 = 16210
const val itemMaridMantle_16211 = 16211
const val itemCerberusMantle_16212 = 16212
const val itemLamiaMantle_16213 = 16213
const val itemLamiaMantle1_16214 = 16214
const val itemMaridMantle1_16215 = 16215
const val itemCerbMantle1_16216 = 16216
const val itemImmortalsCape_16217 = 16217
const val itemPiratesCape_16218 = 16218
const val itemBuskersCape_16219 = 16219
const val itemVolitionalMantle_16220 = 16220
const val itemAileronMantle_16221 = 16221
const val itemMrcMantle_16222 = 16222
const val itemOrangeTank_16223 = 16223
const val itemAppleTank_16224 = 16224
const val itemPearTank_16225 = 16225
const val itemPamamaTank_16226 = 16226
const val itemPersikosTank_16227 = 16227
const val itemAslanCape_16228 = 16228
const val itemGleemansCape_16229 = 16229
const val itemLieutenantsCape_16230 = 16230
const val itemSmilodonMantle_16231 = 16231
const val itemSmilodMantle1_16232 = 16232
const val itemPeisteMantle_16233 = 16233
const val itemPeisteMantle1_16234 = 16234
const val itemLynxMantle_16235 = 16235
const val itemLynxMantle1_16236 = 16236
const val itemThunderersMantle_16237 = 16237
const val itemTastersCape_16238 = 16238
const val itemSolitaireCape_16239 = 16239
const val itemEratosCape_16240 = 16240
const val itemCuchulainsMantle_16241 = 16241
const val itemIxionCape_16242 = 16242
const val itemDroversMantle_16243 = 16243
const val itemMirageMantle_16244 = 16244
const val itemPantinCape_16245 = 16245
const val itemViatorCape_16246 = 16246
const val itemCaloyerCape_16247 = 16247
const val itemEtoileCape_16248 = 16248
const val itemElixirTank_16249 = 16249
const val itemMamoolJaMantle_16250 = 16250
const val itemCMelonTank_16251 = 16251
const val itemResilientMantle_16252 = 16252
const val itemChiffonCape_16253 = 16253
const val itemAltiusMantle_16254 = 16254
const val itemCortegeCape_16255 = 16255
const val itemRuggedMantle_16256 = 16256
const val itemGhostCape_16257 = 16257
const val itemArrestorMantle_16258 = 16258
const val itemTwilightCape_16259 = 16259
const val itemAthelingMantle_16260 = 16260
const val itemMohbwaScarf_16261 = 16261
const val itemMohbwaScarf1_16262 = 16262
const val itemBeakNecklace_16263 = 16263
const val itemBeakNecklace1_16264 = 16264
const val itemWivreGorget_16265 = 16265
const val itemWivreGorget1_16266 = 16266
const val itemRitterGorget_16267 = 16267
const val itemKubiraBeads_16268 = 16268
const val itemMorganasChoker_16269 = 16269
const val itemChanoixsGorget_16270 = 16270
const val itemLieutGorget_16271 = 16271
const val itemNaraentenBeads_16272 = 16272
const val itemPullusTorque_16273 = 16273
const val itemAlmahTorque_16274 = 16274
const val itemAncientTorque_16275 = 16275
const val itemRepSilverMedal_16276 = 16276
const val itemBandoleroScarf_16277 = 16277
const val itemPipersTorque_16278 = 16278
const val itemPileChain_16279 = 16279
const val itemHaraldrsMuffler_16280 = 16280
const val itemBuffoonsCollar_16281 = 16281
const val itemBfnCollar1_16282 = 16282
const val itemGnoleTorque_16283 = 16283
const val itemCaractChoker_16284 = 16284
const val itemPendantCompass_16285 = 16285
const val itemNitidChoker_16286 = 16286
const val itemPneumaCollar_16287 = 16287
const val itemAureateNecklace_16288 = 16288
const val itemAlloyTorque_16289 = 16289
const val itemBurlyGorget_16290 = 16290
const val itemShieldCollar_16291 = 16291
const val itemBullNecklace_16292 = 16292
const val itemCougarPendant_16293 = 16293
const val itemCrocodileCollar_16294 = 16294
const val itemVariusTorque_16295 = 16295
const val itemArmigersLace_16296 = 16296
const val itemShepherdsChain_16297 = 16297
const val itemKnackPendant_16298 = 16298
const val itemLleusCharm_16299 = 16299
const val itemWitPendant_16300 = 16300
const val itemFocusCollar_16301 = 16301
const val itemBloodbeadGorget_16302 = 16302
const val itemLaransPendant_16303 = 16303
const val itemFocusCollar1_16304 = 16304
const val itemSanctusRosary_16305 = 16305
const val itemHaltingStole_16306 = 16306
const val itemRepellingCollar_16307 = 16307
const val itemFeudPendant_16308 = 16308
const val itemInvidiaTorque_16309 = 16309
const val itemScholarsPants_16311 = 16311
const val itemIRBreeches_16312 = 16312
const val itemFourthCuisses_16313 = 16313
const val itemCobraSlops_16314 = 16314
const val itemIronRamHose_16315 = 16315
const val itemFourthSchoss_16316 = 16316
const val itemCobraSubligar_16317 = 16317
const val itemCobraTrews_16318 = 16318
const val itemSangomaLappa_16319 = 16319
const val itemKenseiSitabaki_16320 = 16320
const val itemCustomTrunks_16321 = 16321
const val itemCustomShorts_16322 = 16322
const val itemMagnaTrunks_16323 = 16323
const val itemMagnaShorts_16324 = 16324
const val itemWonderTrunks_16325 = 16325
const val itemWonderShorts_16326 = 16326
const val itemSavageShorts_16327 = 16327
const val itemElderTrunks_16328 = 16328
const val itemCustomTrunks1_16329 = 16329
const val itemCustomShorts1_16330 = 16330
const val itemMagnaTrunks1_16331 = 16331
const val itemMagnaShorts1_16332 = 16332
const val itemWonderTrunks1_16333 = 16333
const val itemWonderShorts1_16334 = 16334
const val itemSavageShorts1_16335 = 16335
const val itemElderTrunks1_16336 = 16336
const val itemHachiryuHaidate_16337 = 16337
const val itemRubySeraweels_16338 = 16338
const val itemPaddockTrousers_16339 = 16339
const val itemArmadilloCuisses_16340 = 16340
const val itemAurumCuisses_16341 = 16341
const val itemOraclesBraconi_16342 = 16342
const val itemEnkidusSubligar_16343 = 16343
const val itemOilyTrousers_16344 = 16344
const val itemMagusShalwar1_16345 = 16345
const val itemMirageShalwar_16346 = 16346
const val itemMirageShalwar1_16347 = 16347
const val itemCorCulottes1_16348 = 16348
const val itemCommTrews_16349 = 16349
const val itemCommTrews1_16350 = 16350
const val itemPupChuridars1_16351 = 16351
const val itemPantinChuridars_16352 = 16352
const val itemPtnChuridars1_16353 = 16353
const val itemMalagigisTrousers_16354 = 16354
const val itemBediveresHose_16355 = 16355
const val itemNimuesTights_16356 = 16356
const val itemDancersTights1_16357 = 16357
const val itemDancersTights1_16358 = 16358
const val itemScholarsPants1_16359 = 16359
const val itemEtoileTights_16360 = 16360
const val itemEtoileTights1_16361 = 16361
const val itemArgutePants_16362 = 16362
const val itemArgutePants1_16363 = 16363
const val itemBenedightHose_16364 = 16364
const val itemArgentHose_16365 = 16365
const val itemPlatinoHose_16366 = 16366
const val itemPhlTrousers_16367 = 16367
const val itemHerdersSubligar_16368 = 16368
const val itemBlitzerPoleyn_16369 = 16369
const val itemDesultorTassets_16370 = 16370
const val itemTatsuSitagoromo_16371 = 16371
const val itemStearcSubligar_16372 = 16372
const val itemKyoshuSitabaki_16373 = 16373
const val itemLayqaSeraweels_16374 = 16374
const val itemSurgeSubligar_16375 = 16375
const val itemBahramCuisses_16376 = 16376
const val itemKyoSitabaki1_16377 = 16377
const val itemDinnerHose_16378 = 16378
const val itemInmicusCuisses_16379 = 16379
const val itemEntoisTrousers_16380 = 16380
const val itemTumblerTrunks_16381 = 16381
const val itemAdapasSlacks_16382 = 16382
const val itemMiradorTrousers_16383 = 16383
